import { emptySplitApi as api } from "./baseApi";
export const addTagTypes = [
  "EmployeeReviewController",
  "InventoryLocationController",
  "AccessApplicationController",
  "AccessLogController",
  "InviteController",
  "AgreementController",
  "AmortisationController",
  "BalancedScorecardController",
  "BomController",
  "ExternalItemMapController",
  "BomItemAuditTrailController",
  "BomItemController",
  "BusinessUnitController",
  "CashbookController",
  "CashflowController",
  "CastingToolController",
  "CEODashboardController",
  "PropertyRegisterController",
  "CompetencyController",
  "ComsBlockController",
  "ComsUploadAuditController",
  "ComsCatalogController",
  "ComsMatController",
  "ComsMonthlyReportRecordController",
  "ComsDailyReportController",
  "ComsWeeklyReportController",
  "ContractItemAuditTrailController",
  "ContractItemController",
  "GRVController",
  "ProcurementProcessController",
  "PurchaseOrderController",
  "ProcurementController",
  "RequisitionReviewController",
  "CreditorsController",
  "DashboardController",
  "DebtorsController",
  "TransactionsController",
  "DevelopmentController",
  "FinanceController",
  "FinanceDashboardController",
  "GradingConfigController",
  "DebtorCreditorImportController",
  "InventoryController",
  "ItemCategoryController",
  "ItemLocationController",
  "ItemTransferController",
  "ItemController",
  "ItemIssuedController",
  "JobDescriptionController",
  "KnowledgeBaseController",
  "LabourTrackerController",
  "PasswordResetRequestController",
  "PaymentRequisitionController",
  "PayrollController",
  "PEARReviewController",
  "RequesttoPaymentController",
  "PingController",
  "ProcurementContractController",
  "ProTrackController",
  "QuotationsUploadProgressController",
  "SheqController",
  "StakeholderController",
  "SupervisorController",
  "UnitController",
  "UserController",
  "VatController",
  "VirtualWarehouseController",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      get360ReviewsByUserByUserId: build.query<
        Get360ReviewsByUserByUserIdApiResponse,
        Get360ReviewsByUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/360-reviews-by-user/${queryArg.userId}`,
        }),
        providesTags: ["EmployeeReviewController"],
      }),
      getInventoryLocationsCount: build.query<
        GetInventoryLocationsCountApiResponse,
        GetInventoryLocationsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/InventoryLocations/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["InventoryLocationController"],
      }),
      getInventoryLocationsById: build.query<
        GetInventoryLocationsByIdApiResponse,
        GetInventoryLocationsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/InventoryLocations/${queryArg.id}` }),
        providesTags: ["InventoryLocationController"],
      }),
      deleteInventoryLocationsById: build.mutation<
        DeleteInventoryLocationsByIdApiResponse,
        DeleteInventoryLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/InventoryLocations/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["InventoryLocationController"],
      }),
      postInventoryLocations: build.mutation<
        PostInventoryLocationsApiResponse,
        PostInventoryLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/InventoryLocations`,
          method: "POST",
          body: queryArg.newInventoryLocation,
        }),
        invalidatesTags: ["InventoryLocationController"],
      }),
      getInventoryLocations: build.query<
        GetInventoryLocationsApiResponse,
        GetInventoryLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/InventoryLocations`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["InventoryLocationController"],
      }),
      getAccessApplicationsCount: build.query<
        GetAccessApplicationsCountApiResponse,
        GetAccessApplicationsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/access-applications/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["AccessApplicationController"],
      }),
      putAccessApplicationsById: build.mutation<
        PutAccessApplicationsByIdApiResponse,
        PutAccessApplicationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/access-applications/${queryArg.id}`,
          method: "PUT",
          body: queryArg.updateAccessApplication,
        }),
        invalidatesTags: ["AccessApplicationController"],
      }),
      getAccessApplicationsById: build.query<
        GetAccessApplicationsByIdApiResponse,
        GetAccessApplicationsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/access-applications/${queryArg.id}` }),
        providesTags: ["AccessApplicationController"],
      }),
      deleteAccessApplicationsById: build.mutation<
        DeleteAccessApplicationsByIdApiResponse,
        DeleteAccessApplicationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/access-applications/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AccessApplicationController"],
      }),
      postAccessApplications: build.mutation<
        PostAccessApplicationsApiResponse,
        PostAccessApplicationsApiArg
      >({
        query: (queryArg) => ({
          url: `/access-applications`,
          method: "POST",
          body: queryArg.newAccessApplication,
        }),
        invalidatesTags: ["AccessApplicationController"],
      }),
      getAccessApplications: build.query<
        GetAccessApplicationsApiResponse,
        GetAccessApplicationsApiArg
      >({
        query: (queryArg) => ({
          url: `/access-applications`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["AccessApplicationController"],
      }),
      getAccessLogsCount: build.query<
        GetAccessLogsCountApiResponse,
        GetAccessLogsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/access-logs/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["AccessLogController"],
      }),
      getAccessLogsById: build.query<
        GetAccessLogsByIdApiResponse,
        GetAccessLogsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/access-logs/${queryArg.id}` }),
        providesTags: ["AccessLogController"],
      }),
      deleteAccessLogsById: build.mutation<
        DeleteAccessLogsByIdApiResponse,
        DeleteAccessLogsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/access-logs/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AccessLogController"],
      }),
      postAccessLogs: build.mutation<
        PostAccessLogsApiResponse,
        PostAccessLogsApiArg
      >({
        query: (queryArg) => ({
          url: `/access-logs`,
          method: "POST",
          body: queryArg.newAccessLog,
        }),
        invalidatesTags: ["AccessLogController"],
      }),
      getAccessLogs: build.query<GetAccessLogsApiResponse, GetAccessLogsApiArg>(
        {
          query: (queryArg) => ({
            url: `/access-logs`,
            params: { filter: queryArg.filter },
          }),
          providesTags: ["AccessLogController"],
        }
      ),
      postAddEmployeeReview: build.mutation<
        PostAddEmployeeReviewApiResponse,
        PostAddEmployeeReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/add-employee-review`,
          method: "POST",
          body: queryArg.employeeReviewData,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      postAddInvite: build.mutation<
        PostAddInviteApiResponse,
        PostAddInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/add-invite`,
          method: "POST",
          body: queryArg.inviteData,
        }),
        invalidatesTags: ["InviteController"],
      }),
      postAddLifeWheel: build.mutation<
        PostAddLifeWheelApiResponse,
        PostAddLifeWheelApiArg
      >({
        query: (queryArg) => ({
          url: `/add-life-wheel`,
          method: "POST",
          body: queryArg.lifeWheelData,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      postAgreementsClientCreate: build.mutation<
        PostAgreementsClientCreateApiResponse,
        PostAgreementsClientCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/agreements/client/create`,
          method: "POST",
          body: queryArg.agreementData,
        }),
        invalidatesTags: ["AgreementController"],
      }),
      postAgreementsEmploymentCreate: build.mutation<
        PostAgreementsEmploymentCreateApiResponse,
        PostAgreementsEmploymentCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/agreements/employment/create`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AgreementController"],
      }),
      getAllLifeWheels: build.query<
        GetAllLifeWheelsApiResponse,
        GetAllLifeWheelsApiArg
      >({
        query: () => ({ url: `/all-life-wheels` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getAllSpearReviews: build.query<
        GetAllSpearReviewsApiResponse,
        GetAllSpearReviewsApiArg
      >({
        query: () => ({ url: `/all-spear-reviews` }),
        providesTags: ["EmployeeReviewController"],
      }),
      postAmortisationGenerateByDebtorId: build.mutation<
        PostAmortisationGenerateByDebtorIdApiResponse,
        PostAmortisationGenerateByDebtorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/amortisation/generate/${queryArg.debtorId}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AmortisationController"],
      }),
      getAmortisationSummaryByDebtorId: build.query<
        GetAmortisationSummaryByDebtorIdApiResponse,
        GetAmortisationSummaryByDebtorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/amortisation/summary/${queryArg.debtorId}`,
        }),
        providesTags: ["AmortisationController"],
      }),
      patchAmortisationByScheduleIdMarkPaid: build.mutation<
        PatchAmortisationByScheduleIdMarkPaidApiResponse,
        PatchAmortisationByScheduleIdMarkPaidApiArg
      >({
        query: (queryArg) => ({
          url: `/amortisation/${queryArg.scheduleId}/mark-paid`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["AmortisationController"],
      }),
      getAmortisationByDebtorId: build.query<
        GetAmortisationByDebtorIdApiResponse,
        GetAmortisationByDebtorIdApiArg
      >({
        query: (queryArg) => ({ url: `/amortisation/${queryArg.debtorId}` }),
        providesTags: ["AmortisationController"],
      }),
      deleteAmortisationByDebtorId: build.mutation<
        DeleteAmortisationByDebtorIdApiResponse,
        DeleteAmortisationByDebtorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/amortisation/${queryArg.debtorId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AmortisationController"],
      }),
      getBalancedScorecardsByPeriodByPeriod: build.query<
        GetBalancedScorecardsByPeriodByPeriodApiResponse,
        GetBalancedScorecardsByPeriodByPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/by-period/${queryArg.period}`,
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsByUserByUserId: build.query<
        GetBalancedScorecardsByUserByUserIdApiResponse,
        GetBalancedScorecardsByUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/by-user/${queryArg.userId}`,
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsCount: build.query<
        GetBalancedScorecardsCountApiResponse,
        GetBalancedScorecardsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsMySubmissions: build.query<
        GetBalancedScorecardsMySubmissionsApiResponse,
        GetBalancedScorecardsMySubmissionsApiArg
      >({
        query: () => ({ url: `/balanced-scorecards/my-submissions` }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsOrgChartByJobDescriptionIdReports: build.query<
        GetBalancedScorecardsOrgChartByJobDescriptionIdReportsApiResponse,
        GetBalancedScorecardsOrgChartByJobDescriptionIdReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/org-chart/${queryArg.jobDescriptionId}/reports`,
          params: { period: queryArg.period },
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsOrgChart: build.query<
        GetBalancedScorecardsOrgChartApiResponse,
        GetBalancedScorecardsOrgChartApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/org-chart`,
          params: { period: queryArg.period },
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsPendingReview: build.query<
        GetBalancedScorecardsPendingReviewApiResponse,
        GetBalancedScorecardsPendingReviewApiArg
      >({
        query: () => ({ url: `/balanced-scorecards/pending-review` }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsTeamSubmissions: build.query<
        GetBalancedScorecardsTeamSubmissionsApiResponse,
        GetBalancedScorecardsTeamSubmissionsApiArg
      >({
        query: () => ({ url: `/balanced-scorecards/team-submissions` }),
        providesTags: ["BalancedScorecardController"],
      }),
      patchBalancedScorecardsByIdApprove: build.mutation<
        PatchBalancedScorecardsByIdApproveApiResponse,
        PatchBalancedScorecardsByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}/approve`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      patchBalancedScorecardsByIdReject: build.mutation<
        PatchBalancedScorecardsByIdRejectApiResponse,
        PatchBalancedScorecardsByIdRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}/reject`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      patchBalancedScorecardsByIdRevertToDraft: build.mutation<
        PatchBalancedScorecardsByIdRevertToDraftApiResponse,
        PatchBalancedScorecardsByIdRevertToDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}/revert-to-draft`,
          method: "PATCH",
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      patchBalancedScorecardsByIdSubmit: build.mutation<
        PatchBalancedScorecardsByIdSubmitApiResponse,
        PatchBalancedScorecardsByIdSubmitApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}/submit`,
          method: "PATCH",
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      patchBalancedScorecardsById: build.mutation<
        PatchBalancedScorecardsByIdApiResponse,
        PatchBalancedScorecardsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.balancedScorecardPartial,
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecardsById: build.query<
        GetBalancedScorecardsByIdApiResponse,
        GetBalancedScorecardsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      deleteBalancedScorecardsById: build.mutation<
        DeleteBalancedScorecardsByIdApiResponse,
        DeleteBalancedScorecardsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      postBalancedScorecards: build.mutation<
        PostBalancedScorecardsApiResponse,
        PostBalancedScorecardsApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards`,
          method: "POST",
          body: queryArg.newBalancedScorecard,
        }),
        invalidatesTags: ["BalancedScorecardController"],
      }),
      getBalancedScorecards: build.query<
        GetBalancedScorecardsApiResponse,
        GetBalancedScorecardsApiArg
      >({
        query: (queryArg) => ({
          url: `/balanced-scorecards`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BalancedScorecardController"],
      }),
      getBomByDevelopmentByDevelopmentId: build.query<
        GetBomByDevelopmentByDevelopmentIdApiResponse,
        GetBomByDevelopmentByDevelopmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom/by-development/${queryArg.developmentId}`,
        }),
        providesTags: ["BomController"],
      }),
      getBomByProjectByProjectId: build.query<
        GetBomByProjectByProjectIdApiResponse,
        GetBomByProjectByProjectIdApiArg
      >({
        query: (queryArg) => ({ url: `/bom/by-project/${queryArg.projectId}` }),
        providesTags: ["BomController"],
      }),
      getBomCount: build.query<GetBomCountApiResponse, GetBomCountApiArg>({
        query: (queryArg) => ({
          url: `/bom/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["BomController"],
      }),
      postBomExternalItemMappingUpload: build.mutation<
        PostBomExternalItemMappingUploadApiResponse,
        PostBomExternalItemMappingUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/bom/external-item-mapping/upload`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ExternalItemMapController"],
      }),
      patchBomById: build.mutation<PatchBomByIdApiResponse, PatchBomByIdApiArg>(
        {
          query: (queryArg) => ({
            url: `/bom/${queryArg.id}`,
            method: "PATCH",
            body: queryArg.billOfMaterialPartial,
          }),
          invalidatesTags: ["BomController"],
        }
      ),
      getBomById: build.query<GetBomByIdApiResponse, GetBomByIdApiArg>({
        query: (queryArg) => ({ url: `/bom/${queryArg.id}` }),
        providesTags: ["BomController"],
      }),
      deleteBomById: build.mutation<
        DeleteBomByIdApiResponse,
        DeleteBomByIdApiArg
      >({
        query: (queryArg) => ({ url: `/bom/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["BomController"],
      }),
      postBom: build.mutation<PostBomApiResponse, PostBomApiArg>({
        query: (queryArg) => ({
          url: `/bom`,
          method: "POST",
          body: queryArg.newBillOfMaterial,
        }),
        invalidatesTags: ["BomController"],
      }),
      getBom: build.query<GetBomApiResponse, GetBomApiArg>({
        query: (queryArg) => ({
          url: `/bom`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BomController"],
      }),
      getBomItemAuditTrailsByBomItemByBomItemId: build.query<
        GetBomItemAuditTrailsByBomItemByBomItemIdApiResponse,
        GetBomItemAuditTrailsByBomItemByBomItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-item-audit-trails/by-bom-item/${queryArg.bomItemId}`,
          params: { limit: queryArg.limit, skip: queryArg.skip },
        }),
        providesTags: ["BomItemAuditTrailController"],
      }),
      patchBomItemAuditTrailsByIdFirstApproval: build.mutation<
        PatchBomItemAuditTrailsByIdFirstApprovalApiResponse,
        PatchBomItemAuditTrailsByIdFirstApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-item-audit-trails/${queryArg.id}/first-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemAuditTrailController"],
      }),
      patchBomItemAuditTrailsByIdSecondApproval: build.mutation<
        PatchBomItemAuditTrailsByIdSecondApprovalApiResponse,
        PatchBomItemAuditTrailsByIdSecondApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-item-audit-trails/${queryArg.id}/second-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemAuditTrailController"],
      }),
      postBomItemAuditTrails: build.mutation<
        PostBomItemAuditTrailsApiResponse,
        PostBomItemAuditTrailsApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-item-audit-trails`,
          method: "POST",
          body: queryArg.newBomItemAuditTrail,
        }),
        invalidatesTags: ["BomItemAuditTrailController"],
      }),
      getBomItemsByBomByBomId: build.query<
        GetBomItemsByBomByBomIdApiResponse,
        GetBomItemsByBomByBomIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/by-bom/${queryArg.bomId}`,
          params: {
            projectId: queryArg.projectId,
            developmentId: queryArg.developmentId,
            bomName: queryArg.bomName,
            projectName: queryArg.projectName,
            developmentName: queryArg.developmentName,
            itemCode: queryArg.itemCode,
            isService: queryArg.isService,
            isVAT: queryArg.isVat,
            itemDescription: queryArg.itemDescription,
            itemUnit: queryArg.itemUnit,
            itemBudgetedCost: queryArg.itemBudgetedCost,
            itemQuantity: queryArg.itemQuantity,
            itemCurrentValue: queryArg.itemCurrentValue,
            initialQuantity: queryArg.initialQuantity,
            itemInitialValue: queryArg.itemInitialValue,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["BomItemController"],
      }),
      getBomItemsByProjectByProjectId: build.query<
        GetBomItemsByProjectByProjectIdApiResponse,
        GetBomItemsByProjectByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/by-project/${queryArg.projectId}`,
          params: { limit: queryArg.limit, skip: queryArg.skip },
        }),
        providesTags: ["BomItemController"],
      }),
      getBomItemsCount: build.query<
        GetBomItemsCountApiResponse,
        GetBomItemsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["BomItemController"],
      }),
      patchBomItemsByIdFirstApproval: build.mutation<
        PatchBomItemsByIdFirstApprovalApiResponse,
        PatchBomItemsByIdFirstApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/${queryArg.id}/first-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemController"],
      }),
      patchBomItemsByIdSecondApproval: build.mutation<
        PatchBomItemsByIdSecondApprovalApiResponse,
        PatchBomItemsByIdSecondApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/${queryArg.id}/second-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemController"],
      }),
      putBomItemsById: build.mutation<
        PutBomItemsByIdApiResponse,
        PutBomItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/${queryArg.id}`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemController"],
      }),
      patchBomItemsById: build.mutation<
        PatchBomItemsByIdApiResponse,
        PatchBomItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["BomItemController"],
      }),
      getBomItemsById: build.query<
        GetBomItemsByIdApiResponse,
        GetBomItemsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/bom-items/${queryArg.id}` }),
        providesTags: ["BomItemController"],
      }),
      deleteBomItemsById: build.mutation<
        DeleteBomItemsByIdApiResponse,
        DeleteBomItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/bom-items/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["BomItemController"],
      }),
      postBomItems: build.mutation<PostBomItemsApiResponse, PostBomItemsApiArg>(
        {
          query: (queryArg) => ({
            url: `/bom-items`,
            method: "POST",
            body: queryArg.newBomItem,
          }),
          invalidatesTags: ["BomItemController"],
        }
      ),
      getBomItems: build.query<GetBomItemsApiResponse, GetBomItemsApiArg>({
        query: (queryArg) => ({
          url: `/bom-items`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BomItemController"],
      }),
      getBusinessUnitsActive: build.query<
        GetBusinessUnitsActiveApiResponse,
        GetBusinessUnitsActiveApiArg
      >({
        query: () => ({ url: `/business-units/active` }),
        providesTags: ["BusinessUnitController"],
      }),
      getBusinessUnitsCount: build.query<
        GetBusinessUnitsCountApiResponse,
        GetBusinessUnitsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["BusinessUnitController"],
      }),
      postBusinessUnitsSeedDefaults: build.mutation<
        PostBusinessUnitsSeedDefaultsApiResponse,
        PostBusinessUnitsSeedDefaultsApiArg
      >({
        query: () => ({ url: `/business-units/seed-defaults`, method: "POST" }),
        invalidatesTags: ["BusinessUnitController"],
      }),
      patchBusinessUnitsById: build.mutation<
        PatchBusinessUnitsByIdApiResponse,
        PatchBusinessUnitsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.businessUnitPartial,
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),
      getBusinessUnitsById: build.query<
        GetBusinessUnitsByIdApiResponse,
        GetBusinessUnitsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BusinessUnitController"],
      }),
      deleteBusinessUnitsById: build.mutation<
        DeleteBusinessUnitsByIdApiResponse,
        DeleteBusinessUnitsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),
      postBusinessUnits: build.mutation<
        PostBusinessUnitsApiResponse,
        PostBusinessUnitsApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units`,
          method: "POST",
          body: queryArg.newBusinessUnit,
        }),
        invalidatesTags: ["BusinessUnitController"],
      }),
      getBusinessUnits: build.query<
        GetBusinessUnitsApiResponse,
        GetBusinessUnitsApiArg
      >({
        query: (queryArg) => ({
          url: `/business-units`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["BusinessUnitController"],
      }),
      getCashbookAccountBalances: build.query<
        GetCashbookAccountBalancesApiResponse,
        GetCashbookAccountBalancesApiArg
      >({
        query: (queryArg) => ({
          url: `/cashbook/account-balances`,
          params: { asAtDate: queryArg.asAtDate },
        }),
        providesTags: ["CashbookController"],
      }),
      postCashbook: build.mutation<PostCashbookApiResponse, PostCashbookApiArg>(
        {
          query: (queryArg) => ({
            url: `/cashbook`,
            method: "POST",
            body: queryArg.body,
          }),
          invalidatesTags: ["CashbookController"],
        }
      ),
      getCashbook: build.query<GetCashbookApiResponse, GetCashbookApiArg>({
        query: (queryArg) => ({
          url: `/cashbook`,
          params: {
            account: queryArg.account,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            developmentId: queryArg.developmentId,
          },
        }),
        providesTags: ["CashbookController"],
      }),
      getCashflowForecast: build.query<
        GetCashflowForecastApiResponse,
        GetCashflowForecastApiArg
      >({
        query: (queryArg) => ({
          url: `/cashflow/forecast`,
          params: {
            monthsAhead: queryArg.monthsAhead,
            developmentId: queryArg.developmentId,
          },
        }),
        providesTags: ["CashflowController"],
      }),
      getCashflowVariance: build.query<
        GetCashflowVarianceApiResponse,
        GetCashflowVarianceApiArg
      >({
        query: (queryArg) => ({
          url: `/cashflow/variance`,
          params: { month: queryArg.month },
        }),
        providesTags: ["CashflowController"],
      }),
      getCashflowVarianceHistory: build.query<
        GetCashflowVarianceHistoryApiResponse,
        GetCashflowVarianceHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/cashflow/variance-history`,
          params: { months: queryArg.months },
        }),
        providesTags: ["CashflowController"],
      }),
      getCastingToolPeriodByReviewPeriod: build.query<
        GetCastingToolPeriodByReviewPeriodApiResponse,
        GetCastingToolPeriodByReviewPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tool/period/${queryArg.reviewPeriod}`,
        }),
        providesTags: ["CastingToolController"],
      }),
      patchCastingToolById: build.mutation<
        PatchCastingToolByIdApiResponse,
        PatchCastingToolByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tool/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.castingToolPartialExcludingIdUserIdCreatedAt,
        }),
        invalidatesTags: ["CastingToolController"],
      }),
      getCastingToolById: build.query<
        GetCastingToolByIdApiResponse,
        GetCastingToolByIdApiArg
      >({
        query: (queryArg) => ({ url: `/casting-tool/${queryArg.id}` }),
        providesTags: ["CastingToolController"],
      }),
      postCastingTool: build.mutation<
        PostCastingToolApiResponse,
        PostCastingToolApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tool`,
          method: "POST",
          body: queryArg.newCastingTool,
        }),
        invalidatesTags: ["CastingToolController"],
      }),
      getCastingToolsAll: build.query<
        GetCastingToolsAllApiResponse,
        GetCastingToolsAllApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tools/all`,
          params: { reviewPeriod: queryArg.reviewPeriod },
        }),
        providesTags: ["CastingToolController"],
      }),
      getCastingToolsDepartmentByDepartment: build.query<
        GetCastingToolsDepartmentByDepartmentApiResponse,
        GetCastingToolsDepartmentByDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tools/department/${queryArg.department}`,
          params: { reviewPeriod: queryArg.reviewPeriod },
        }),
        providesTags: ["CastingToolController"],
      }),
      getCastingToolsDepartmentStats: build.query<
        GetCastingToolsDepartmentStatsApiResponse,
        GetCastingToolsDepartmentStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tools/department-stats`,
          params: { reviewPeriod: queryArg.reviewPeriod },
        }),
        providesTags: ["CastingToolController"],
      }),
      getCastingToolsMy: build.query<
        GetCastingToolsMyApiResponse,
        GetCastingToolsMyApiArg
      >({
        query: () => ({ url: `/casting-tools/my` }),
        providesTags: ["CastingToolController"],
      }),
      getCastingToolsByUserByUserId: build.query<
        GetCastingToolsByUserByUserIdApiResponse,
        GetCastingToolsByUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/casting-tools-by-user/${queryArg.userId}`,
        }),
        providesTags: ["CastingToolController"],
      }),
      getCeoDashboardBscPerspectives: build.query<
        GetCeoDashboardBscPerspectivesApiResponse,
        GetCeoDashboardBscPerspectivesApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/bsc-perspectives`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardDepartmentsByDepartmentEmployees: build.query<
        GetCeoDashboardDepartmentsByDepartmentEmployeesApiResponse,
        GetCeoDashboardDepartmentsByDepartmentEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/departments/${queryArg.department}/employees`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardDepartmentsByDepartment: build.query<
        GetCeoDashboardDepartmentsByDepartmentApiResponse,
        GetCeoDashboardDepartmentsByDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/departments/${queryArg.department}`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardDepartments: build.query<
        GetCeoDashboardDepartmentsApiResponse,
        GetCeoDashboardDepartmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/departments`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardEmployeesByEmployeeId: build.query<
        GetCeoDashboardEmployeesByEmployeeIdApiResponse,
        GetCeoDashboardEmployeesByEmployeeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/employees/${queryArg.employeeId}`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardEmployees: build.query<
        GetCeoDashboardEmployeesApiResponse,
        GetCeoDashboardEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/employees`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardLifeWheel: build.query<
        GetCeoDashboardLifeWheelApiResponse,
        GetCeoDashboardLifeWheelApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/life-wheel`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardNeedsAttention: build.query<
        GetCeoDashboardNeedsAttentionApiResponse,
        GetCeoDashboardNeedsAttentionApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/needs-attention`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardOrganization: build.query<
        GetCeoDashboardOrganizationApiResponse,
        GetCeoDashboardOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/organization`,
          params: { period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      getCeoDashboardTopPerformers: build.query<
        GetCeoDashboardTopPerformersApiResponse,
        GetCeoDashboardTopPerformersApiArg
      >({
        query: (queryArg) => ({
          url: `/ceo-dashboard/top-performers`,
          params: { limit: queryArg.limit, period: queryArg.period },
        }),
        providesTags: ["CEODashboardController"],
      }),
      postClient: build.mutation<PostClientApiResponse, PostClientApiArg>({
        query: (queryArg) => ({
          url: `/client`,
          method: "POST",
          body: queryArg.clientData,
        }),
        invalidatesTags: ["PropertyRegisterController"],
      }),
      getClients: build.query<GetClientsApiResponse, GetClientsApiArg>({
        query: (queryArg) => ({
          url: `/clients`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["PropertyRegisterController"],
      }),
      getCompetenciesActive: build.query<
        GetCompetenciesActiveApiResponse,
        GetCompetenciesActiveApiArg
      >({
        query: () => ({ url: `/competencies/active` }),
        providesTags: ["CompetencyController"],
      }),
      getCompetenciesByCategoryByCategory: build.query<
        GetCompetenciesByCategoryByCategoryApiResponse,
        GetCompetenciesByCategoryByCategoryApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies/by-category/${queryArg.category}`,
        }),
        providesTags: ["CompetencyController"],
      }),
      getCompetenciesCount: build.query<
        GetCompetenciesCountApiResponse,
        GetCompetenciesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["CompetencyController"],
      }),
      postCompetenciesSeedDefaults: build.mutation<
        PostCompetenciesSeedDefaultsApiResponse,
        PostCompetenciesSeedDefaultsApiArg
      >({
        query: () => ({ url: `/competencies/seed-defaults`, method: "POST" }),
        invalidatesTags: ["CompetencyController"],
      }),
      patchCompetenciesById: build.mutation<
        PatchCompetenciesByIdApiResponse,
        PatchCompetenciesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.competencyPartial,
        }),
        invalidatesTags: ["CompetencyController"],
      }),
      getCompetenciesById: build.query<
        GetCompetenciesByIdApiResponse,
        GetCompetenciesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["CompetencyController"],
      }),
      deleteCompetenciesById: build.mutation<
        DeleteCompetenciesByIdApiResponse,
        DeleteCompetenciesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["CompetencyController"],
      }),
      postCompetencies: build.mutation<
        PostCompetenciesApiResponse,
        PostCompetenciesApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies`,
          method: "POST",
          body: queryArg.newCompetency,
        }),
        invalidatesTags: ["CompetencyController"],
      }),
      getCompetencies: build.query<
        GetCompetenciesApiResponse,
        GetCompetenciesApiArg
      >({
        query: (queryArg) => ({
          url: `/competencies`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["CompetencyController"],
      }),
      postComsBlocksByBlockIdBaselineActuals: build.mutation<
        PostComsBlocksByBlockIdBaselineActualsApiResponse,
        PostComsBlocksByBlockIdBaselineActualsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.blockId}/baseline-actuals`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsBlockController"],
      }),
      getComsBlocksByBlockIdEvmOverview: build.query<
        GetComsBlocksByBlockIdEvmOverviewApiResponse,
        GetComsBlocksByBlockIdEvmOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.blockId}/evm-overview`,
        }),
        providesTags: ["ComsBlockController"],
      }),
      getComsBlocksByBlockIdHasActuals: build.query<
        GetComsBlocksByBlockIdHasActualsApiResponse,
        GetComsBlocksByBlockIdHasActualsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.blockId}/has-actuals`,
        }),
        providesTags: ["ComsBlockController"],
      }),
      getComsBlocksByIdStats: build.query<
        GetComsBlocksByIdStatsApiResponse,
        GetComsBlocksByIdStatsApiArg
      >({
        query: (queryArg) => ({ url: `/coms/blocks/${queryArg.id}/stats` }),
        providesTags: ["ComsBlockController"],
      }),
      postComsBlocksByBlockIdUploadAudit: build.mutation<
        PostComsBlocksByBlockIdUploadAuditApiResponse,
        PostComsBlocksByBlockIdUploadAuditApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.blockId}/upload-audit`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsUploadAuditController"],
      }),
      getComsBlocksByBlockIdUploadAudit: build.query<
        GetComsBlocksByBlockIdUploadAuditApiResponse,
        GetComsBlocksByBlockIdUploadAuditApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.blockId}/upload-audit`,
        }),
        providesTags: ["ComsUploadAuditController"],
      }),
      patchComsBlocksById: build.mutation<
        PatchComsBlocksByIdApiResponse,
        PatchComsBlocksByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.comsBlockPartial,
        }),
        invalidatesTags: ["ComsBlockController"],
      }),
      getComsBlocksById: build.query<
        GetComsBlocksByIdApiResponse,
        GetComsBlocksByIdApiArg
      >({
        query: (queryArg) => ({ url: `/coms/blocks/${queryArg.id}` }),
        providesTags: ["ComsBlockController"],
      }),
      deleteComsBlocksById: build.mutation<
        DeleteComsBlocksByIdApiResponse,
        DeleteComsBlocksByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsBlockController"],
      }),
      postComsBlocks: build.mutation<
        PostComsBlocksApiResponse,
        PostComsBlocksApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/blocks`,
          method: "POST",
          body: queryArg.newComsBlock,
        }),
        invalidatesTags: ["ComsBlockController"],
      }),
      getComsBlocks: build.query<GetComsBlocksApiResponse, GetComsBlocksApiArg>(
        {
          query: () => ({ url: `/coms/blocks` }),
          providesTags: ["ComsBlockController"],
        }
      ),
      patchComsCatalogById: build.mutation<
        PatchComsCatalogByIdApiResponse,
        PatchComsCatalogByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/catalog/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.comsCatalogItemPartial,
        }),
        invalidatesTags: ["ComsCatalogController"],
      }),
      getComsCatalogById: build.query<
        GetComsCatalogByIdApiResponse,
        GetComsCatalogByIdApiArg
      >({
        query: (queryArg) => ({ url: `/coms/catalog/${queryArg.id}` }),
        providesTags: ["ComsCatalogController"],
      }),
      deleteComsCatalogById: build.mutation<
        DeleteComsCatalogByIdApiResponse,
        DeleteComsCatalogByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/catalog/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsCatalogController"],
      }),
      postComsCatalog: build.mutation<
        PostComsCatalogApiResponse,
        PostComsCatalogApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/catalog`,
          method: "POST",
          body: queryArg.newComsCatalogItem,
        }),
        invalidatesTags: ["ComsCatalogController"],
      }),
      getComsCatalog: build.query<
        GetComsCatalogApiResponse,
        GetComsCatalogApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/catalog`,
          params: {
            blockId: queryArg.blockId,
            type: queryArg["type"],
            catalogueType: queryArg.catalogueType,
          },
        }),
        providesTags: ["ComsCatalogController"],
      }),
      deleteComsMatDeliveriesById: build.mutation<
        DeleteComsMatDeliveriesByIdApiResponse,
        DeleteComsMatDeliveriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/mat-deliveries/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsMatController"],
      }),
      postComsMatDeliveries: build.mutation<
        PostComsMatDeliveriesApiResponse,
        PostComsMatDeliveriesApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/mat-deliveries`,
          method: "POST",
          body: queryArg.newComsMatDelivery,
        }),
        invalidatesTags: ["ComsMatController"],
      }),
      getComsMatDeliveries: build.query<
        GetComsMatDeliveriesApiResponse,
        GetComsMatDeliveriesApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/mat-deliveries`,
          params: {
            blockId: queryArg.blockId,
            budgetItemId: queryArg.budgetItemId,
          },
        }),
        providesTags: ["ComsMatController"],
      }),
      postComsMonthlyReportRecordsBackfill: build.mutation<
        PostComsMonthlyReportRecordsBackfillApiResponse,
        PostComsMonthlyReportRecordsBackfillApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/backfill`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsMonthlyReportRecordController"],
      }),
      postComsMonthlyReportRecordsGenerate: build.mutation<
        PostComsMonthlyReportRecordsGenerateApiResponse,
        PostComsMonthlyReportRecordsGenerateApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/generate`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsMonthlyReportRecordController"],
      }),
      postComsMonthlyReportRecordsRegenerateForDate: build.mutation<
        PostComsMonthlyReportRecordsRegenerateForDateApiResponse,
        PostComsMonthlyReportRecordsRegenerateForDateApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/regenerate-for-date`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsMonthlyReportRecordController"],
      }),
      patchComsMonthlyReportRecordsById: build.mutation<
        PatchComsMonthlyReportRecordsByIdApiResponse,
        PatchComsMonthlyReportRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsMonthlyReportRecordController"],
      }),
      getComsMonthlyReportRecordsById: build.query<
        GetComsMonthlyReportRecordsByIdApiResponse,
        GetComsMonthlyReportRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/${queryArg.id}`,
        }),
        providesTags: ["ComsMonthlyReportRecordController"],
      }),
      deleteComsMonthlyReportRecordsById: build.mutation<
        DeleteComsMonthlyReportRecordsByIdApiResponse,
        DeleteComsMonthlyReportRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsMonthlyReportRecordController"],
      }),
      getComsMonthlyReportRecords: build.query<
        GetComsMonthlyReportRecordsApiResponse,
        GetComsMonthlyReportRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/monthly-report-records`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["ComsMonthlyReportRecordController"],
      }),
      getComsReportsMonthly: build.query<
        GetComsReportsMonthlyApiResponse,
        GetComsReportsMonthlyApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports/monthly`,
          params: {
            blockId: queryArg.blockId,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["ComsDailyReportController"],
      }),
      getComsReportsWorkDone: build.query<
        GetComsReportsWorkDoneApiResponse,
        GetComsReportsWorkDoneApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports/work-done`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["ComsDailyReportController"],
      }),
      patchComsReportsById: build.mutation<
        PatchComsReportsByIdApiResponse,
        PatchComsReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.comsDailyReportPartial,
        }),
        invalidatesTags: ["ComsDailyReportController"],
      }),
      getComsReportsById: build.query<
        GetComsReportsByIdApiResponse,
        GetComsReportsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/coms/reports/${queryArg.id}` }),
        providesTags: ["ComsDailyReportController"],
      }),
      deleteComsReportsById: build.mutation<
        DeleteComsReportsByIdApiResponse,
        DeleteComsReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsDailyReportController"],
      }),
      postComsReports: build.mutation<
        PostComsReportsApiResponse,
        PostComsReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports`,
          method: "POST",
          body: queryArg.newComsDailyReport,
        }),
        invalidatesTags: ["ComsDailyReportController"],
      }),
      getComsReports: build.query<
        GetComsReportsApiResponse,
        GetComsReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/reports`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["ComsDailyReportController"],
      }),
      postComsWeeklyReportsBackfill: build.mutation<
        PostComsWeeklyReportsBackfillApiResponse,
        PostComsWeeklyReportsBackfillApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports/backfill`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsWeeklyReportController"],
      }),
      postComsWeeklyReportsGenerate: build.mutation<
        PostComsWeeklyReportsGenerateApiResponse,
        PostComsWeeklyReportsGenerateApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports/generate`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsWeeklyReportController"],
      }),
      postComsWeeklyReportsRegenerateForDate: build.mutation<
        PostComsWeeklyReportsRegenerateForDateApiResponse,
        PostComsWeeklyReportsRegenerateForDateApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports/regenerate-for-date`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsWeeklyReportController"],
      }),
      patchComsWeeklyReportsById: build.mutation<
        PatchComsWeeklyReportsByIdApiResponse,
        PatchComsWeeklyReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ComsWeeklyReportController"],
      }),
      getComsWeeklyReportsById: build.query<
        GetComsWeeklyReportsByIdApiResponse,
        GetComsWeeklyReportsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/coms/weekly-reports/${queryArg.id}` }),
        providesTags: ["ComsWeeklyReportController"],
      }),
      deleteComsWeeklyReportsById: build.mutation<
        DeleteComsWeeklyReportsByIdApiResponse,
        DeleteComsWeeklyReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ComsWeeklyReportController"],
      }),
      getComsWeeklyReports: build.query<
        GetComsWeeklyReportsApiResponse,
        GetComsWeeklyReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/coms/weekly-reports`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["ComsWeeklyReportController"],
      }),
      getContractItemAuditTrailsByContractItemByContractItemId: build.query<
        GetContractItemAuditTrailsByContractItemByContractItemIdApiResponse,
        GetContractItemAuditTrailsByContractItemByContractItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-item-audit-trails/by-contract-item/${queryArg.contractItemId}`,
          params: { limit: queryArg.limit, skip: queryArg.skip },
        }),
        providesTags: ["ContractItemAuditTrailController"],
      }),
      patchContractItemAuditTrailsByIdFirstApproval: build.mutation<
        PatchContractItemAuditTrailsByIdFirstApprovalApiResponse,
        PatchContractItemAuditTrailsByIdFirstApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-item-audit-trails/${queryArg.id}/first-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemAuditTrailController"],
      }),
      patchContractItemAuditTrailsByIdSecondApproval: build.mutation<
        PatchContractItemAuditTrailsByIdSecondApprovalApiResponse,
        PatchContractItemAuditTrailsByIdSecondApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-item-audit-trails/${queryArg.id}/second-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemAuditTrailController"],
      }),
      postContractItemAuditTrails: build.mutation<
        PostContractItemAuditTrailsApiResponse,
        PostContractItemAuditTrailsApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-item-audit-trails`,
          method: "POST",
          body: queryArg.newContractItemAuditTrail,
        }),
        invalidatesTags: ["ContractItemAuditTrailController"],
      }),
      getContractItemsByContractByContractId: build.query<
        GetContractItemsByContractByContractIdApiResponse,
        GetContractItemsByContractByContractIdApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/by-contract/${queryArg.contractId}`,
          params: {
            supplierId: queryArg.supplierId,
            contractName: queryArg.contractName,
            supplierName: queryArg.supplierName,
            itemCode: queryArg.itemCode,
            isService: queryArg.isService,
            isVAT: queryArg.isVat,
            itemDescription: queryArg.itemDescription,
            itemUnit: queryArg.itemUnit,
            itemBudgetedCost: queryArg.itemBudgetedCost,
            itemQuantity: queryArg.itemQuantity,
            itemCurrentValue: queryArg.itemCurrentValue,
            initialQuantity: queryArg.initialQuantity,
            itemInitialValue: queryArg.itemInitialValue,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["ContractItemController"],
      }),
      getContractItemsCount: build.query<
        GetContractItemsCountApiResponse,
        GetContractItemsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["ContractItemController"],
      }),
      patchContractItemsByIdFirstApproval: build.mutation<
        PatchContractItemsByIdFirstApprovalApiResponse,
        PatchContractItemsByIdFirstApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/${queryArg.id}/first-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      patchContractItemsByIdSecondApproval: build.mutation<
        PatchContractItemsByIdSecondApprovalApiResponse,
        PatchContractItemsByIdSecondApprovalApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/${queryArg.id}/second-approval`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      putContractItemsById: build.mutation<
        PutContractItemsByIdApiResponse,
        PutContractItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/${queryArg.id}`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      patchContractItemsById: build.mutation<
        PatchContractItemsByIdApiResponse,
        PatchContractItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      getContractItemsById: build.query<
        GetContractItemsByIdApiResponse,
        GetContractItemsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/contract-items/${queryArg.id}` }),
        providesTags: ["ContractItemController"],
      }),
      deleteContractItemsById: build.mutation<
        DeleteContractItemsByIdApiResponse,
        DeleteContractItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      postContractItems: build.mutation<
        PostContractItemsApiResponse,
        PostContractItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items`,
          method: "POST",
          body: queryArg.newContractItem,
        }),
        invalidatesTags: ["ContractItemController"],
      }),
      getContractItems: build.query<
        GetContractItemsApiResponse,
        GetContractItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/contract-items`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["ContractItemController"],
      }),
      postCreateGrv: build.mutation<
        PostCreateGrvApiResponse,
        PostCreateGrvApiArg
      >({
        query: (queryArg) => ({
          url: `/create-grv`,
          method: "POST",
          body: queryArg.newGrv,
        }),
        invalidatesTags: ["GRVController"],
      }),
      postCreateProcurementProcess: build.mutation<
        PostCreateProcurementProcessApiResponse,
        PostCreateProcurementProcessApiArg
      >({
        query: (queryArg) => ({
          url: `/create-procurement-process`,
          method: "POST",
          body: queryArg.newProcurementProcess,
        }),
        invalidatesTags: ["ProcurementProcessController"],
      }),
      postCreatePurchaseOrder: build.mutation<
        PostCreatePurchaseOrderApiResponse,
        PostCreatePurchaseOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/create-purchase-order`,
          method: "POST",
          body: queryArg.newPurchaseOrder,
        }),
        invalidatesTags: ["PurchaseOrderController"],
      }),
      postCreateRequisition: build.mutation<
        PostCreateRequisitionApiResponse,
        PostCreateRequisitionApiArg
      >({
        query: (queryArg) => ({
          url: `/create-requisition`,
          method: "POST",
          body: queryArg.requisitionData,
        }),
        invalidatesTags: ["ProcurementController"],
      }),
      postCreateRequisitionReview: build.mutation<
        PostCreateRequisitionReviewApiResponse,
        PostCreateRequisitionReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/create-requisition-review`,
          method: "POST",
          body: queryArg.requisitionReviewData,
        }),
        invalidatesTags: ["RequisitionReviewController"],
      }),
      getCreditorsAgeAnalysisReportPdf: build.query<
        GetCreditorsAgeAnalysisReportPdfApiResponse,
        GetCreditorsAgeAnalysisReportPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/age-analysis/report.pdf`,
          params: {
            developmentId: queryArg.developmentId,
            asAtDate: queryArg.asAtDate,
          },
        }),
        providesTags: ["CreditorsController"],
      }),
      getCreditorsAgeAnalysis: build.query<
        GetCreditorsAgeAnalysisApiResponse,
        GetCreditorsAgeAnalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/age-analysis`,
          params: {
            developmentId: queryArg.developmentId,
            asAtDate: queryArg.asAtDate,
          },
        }),
        providesTags: ["CreditorsController"],
      }),
      getCreditorsCount: build.query<
        GetCreditorsCountApiResponse,
        GetCreditorsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["CreditorsController"],
      }),
      getCreditorsByIdFull: build.query<
        GetCreditorsByIdFullApiResponse,
        GetCreditorsByIdFullApiArg
      >({
        query: (queryArg) => ({ url: `/creditors/${queryArg.id}/full` }),
        providesTags: ["CreditorsController"],
      }),
      postCreditorsByIdInvoices: build.mutation<
        PostCreditorsByIdInvoicesApiResponse,
        PostCreditorsByIdInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/${queryArg.id}/invoices`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["CreditorsController"],
      }),
      getCreditorsByIdInvoices: build.query<
        GetCreditorsByIdInvoicesApiResponse,
        GetCreditorsByIdInvoicesApiArg
      >({
        query: (queryArg) => ({ url: `/creditors/${queryArg.id}/invoices` }),
        providesTags: ["CreditorsController"],
      }),
      postCreditorsByIdPayments: build.mutation<
        PostCreditorsByIdPaymentsApiResponse,
        PostCreditorsByIdPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/${queryArg.id}/payments`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["CreditorsController"],
      }),
      getCreditorsByIdPayments: build.query<
        GetCreditorsByIdPaymentsApiResponse,
        GetCreditorsByIdPaymentsApiArg
      >({
        query: (queryArg) => ({ url: `/creditors/${queryArg.id}/payments` }),
        providesTags: ["CreditorsController"],
      }),
      patchCreditorsById: build.mutation<
        PatchCreditorsByIdApiResponse,
        PatchCreditorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.creditorPartial,
        }),
        invalidatesTags: ["CreditorsController"],
      }),
      getCreditorsById: build.query<
        GetCreditorsByIdApiResponse,
        GetCreditorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["CreditorsController"],
      }),
      deleteCreditorsById: build.mutation<
        DeleteCreditorsByIdApiResponse,
        DeleteCreditorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["CreditorsController"],
      }),
      postCreditors: build.mutation<
        PostCreditorsApiResponse,
        PostCreditorsApiArg
      >({
        query: (queryArg) => ({
          url: `/creditors`,
          method: "POST",
          body: queryArg.newCreditor,
        }),
        invalidatesTags: ["CreditorsController"],
      }),
      getCreditors: build.query<GetCreditorsApiResponse, GetCreditorsApiArg>({
        query: (queryArg) => ({
          url: `/creditors`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["CreditorsController"],
      }),
      getDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValues:
        build.query<
          GetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesApiResponse,
          GetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesApiArg
        >({
          query: (queryArg) => ({
            url: `/dashboard-data-sources/${queryArg.sourceId}/dimensions/${queryArg.dimensionId}/values`,
          }),
          providesTags: ["DashboardController"],
        }),
      getDashboardDataSourcesByIdDimensions: build.query<
        GetDashboardDataSourcesByIdDimensionsApiResponse,
        GetDashboardDataSourcesByIdDimensionsApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboard-data-sources/${queryArg.id}/dimensions`,
        }),
        providesTags: ["DashboardController"],
      }),
      getDashboardDataSourcesByIdMetrics: build.query<
        GetDashboardDataSourcesByIdMetricsApiResponse,
        GetDashboardDataSourcesByIdMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboard-data-sources/${queryArg.id}/metrics`,
        }),
        providesTags: ["DashboardController"],
      }),
      getDashboardDataSources: build.query<
        GetDashboardDataSourcesApiResponse,
        GetDashboardDataSourcesApiArg
      >({
        query: () => ({ url: `/dashboard-data-sources` }),
        providesTags: ["DashboardController"],
      }),
      getDashboardLayoutsById: build.query<
        GetDashboardLayoutsByIdApiResponse,
        GetDashboardLayoutsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/dashboard-layouts/${queryArg.id}` }),
        providesTags: ["DashboardController"],
      }),
      getDashboardLayouts: build.query<
        GetDashboardLayoutsApiResponse,
        GetDashboardLayoutsApiArg
      >({
        query: () => ({ url: `/dashboard-layouts` }),
        providesTags: ["DashboardController"],
      }),
      postDashboardsByIdData: build.mutation<
        PostDashboardsByIdDataApiResponse,
        PostDashboardsByIdDataApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards/${queryArg.id}/data`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DashboardController"],
      }),
      postDashboardsByIdDrilldown: build.mutation<
        PostDashboardsByIdDrilldownApiResponse,
        PostDashboardsByIdDrilldownApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards/${queryArg.id}/drilldown`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DashboardController"],
      }),
      postDashboardsByIdPermissions: build.mutation<
        PostDashboardsByIdPermissionsApiResponse,
        PostDashboardsByIdPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards/${queryArg.id}/permissions`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DashboardController"],
      }),
      putDashboardsById: build.mutation<
        PutDashboardsByIdApiResponse,
        PutDashboardsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards/${queryArg.id}`,
          method: "PUT",
          body: queryArg.dashboardPartialExcludingIdCreatedAtCreatedBy,
        }),
        invalidatesTags: ["DashboardController"],
      }),
      getDashboardsById: build.query<
        GetDashboardsByIdApiResponse,
        GetDashboardsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/dashboards/${queryArg.id}` }),
        providesTags: ["DashboardController"],
      }),
      deleteDashboardsById: build.mutation<
        DeleteDashboardsByIdApiResponse,
        DeleteDashboardsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DashboardController"],
      }),
      postDashboards: build.mutation<
        PostDashboardsApiResponse,
        PostDashboardsApiArg
      >({
        query: (queryArg) => ({
          url: `/dashboards`,
          method: "POST",
          body: queryArg.newDashboard,
        }),
        invalidatesTags: ["DashboardController"],
      }),
      getDashboards: build.query<GetDashboardsApiResponse, GetDashboardsApiArg>(
        {
          query: (queryArg) => ({
            url: `/dashboards`,
            params: {
              publishedOnly: queryArg.publishedOnly,
              includeOwn: queryArg.includeOwn,
            },
          }),
          providesTags: ["DashboardController"],
        }
      ),
      patchDebtorInvoicesById: build.mutation<
        PatchDebtorInvoicesByIdApiResponse,
        PatchDebtorInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/debtor-invoices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      deleteDebtorInvoicesById: build.mutation<
        DeleteDebtorInvoicesByIdApiResponse,
        DeleteDebtorInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/debtor-invoices/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorInvoices: build.query<
        GetDebtorInvoicesApiResponse,
        GetDebtorInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/debtor-invoices`,
          params: {
            developmentId: queryArg.developmentId,
            status: queryArg.status,
            invoiceType: queryArg.invoiceType,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsAgeAnalysisReportPdf: build.query<
        GetDebtorsAgeAnalysisReportPdfApiResponse,
        GetDebtorsAgeAnalysisReportPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/age-analysis/report.pdf`,
          params: {
            developmentId: queryArg.developmentId,
            asAtDate: queryArg.asAtDate,
            hideZeroBalance: queryArg.hideZeroBalance,
          },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsAgeAnalysis: build.query<
        GetDebtorsAgeAnalysisApiResponse,
        GetDebtorsAgeAnalysisApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/age-analysis`,
          params: {
            developmentId: queryArg.developmentId,
            asAtDate: queryArg.asAtDate,
            hideZeroBalance: queryArg.hideZeroBalance,
          },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsAgingFromExcel: build.query<
        GetDebtorsAgingFromExcelApiResponse,
        GetDebtorsAgingFromExcelApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/aging-from-excel`,
          params: {
            excelPath: queryArg.excelPath,
            asAtDate: queryArg.asAtDate,
          },
        }),
        providesTags: ["DebtorsController"],
      }),
      patchDebtorsBulkAge: build.mutation<
        PatchDebtorsBulkAgeApiResponse,
        PatchDebtorsBulkAgeApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/bulk-age`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsComprehensiveAging: build.query<
        GetDebtorsComprehensiveAgingApiResponse,
        GetDebtorsComprehensiveAgingApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/comprehensive-aging`,
          params: { asAtDate: queryArg.asAtDate },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsCount: build.query<
        GetDebtorsCountApiResponse,
        GetDebtorsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsDebugAgedCount: build.query<
        GetDebtorsDebugAgedCountApiResponse,
        GetDebtorsDebugAgedCountApiArg
      >({
        query: () => ({ url: `/debtors/debug/aged-count` }),
        providesTags: ["DebtorsController"],
      }),
      patchDebtorsDebugClearAllAged: build.mutation<
        PatchDebtorsDebugClearAllAgedApiResponse,
        PatchDebtorsDebugClearAllAgedApiArg
      >({
        query: () => ({
          url: `/debtors/debug/clear-all-aged`,
          method: "PATCH",
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsDebugClearAllAged: build.query<
        GetDebtorsDebugClearAllAgedApiResponse,
        GetDebtorsDebugClearAllAgedApiArg
      >({
        query: () => ({ url: `/debtors/debug/clear-all-aged` }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsByIdFull: build.query<
        GetDebtorsByIdFullApiResponse,
        GetDebtorsByIdFullApiArg
      >({
        query: (queryArg) => ({ url: `/debtors/${queryArg.id}/full` }),
        providesTags: ["DebtorsController"],
      }),
      postDebtorsByIdInvoices: build.mutation<
        PostDebtorsByIdInvoicesApiResponse,
        PostDebtorsByIdInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/invoices`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsByIdInvoices: build.query<
        GetDebtorsByIdInvoicesApiResponse,
        GetDebtorsByIdInvoicesApiArg
      >({
        query: (queryArg) => ({ url: `/debtors/${queryArg.id}/invoices` }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsByDebtorIdPayments: build.query<
        GetDebtorsByDebtorIdPaymentsApiResponse,
        GetDebtorsByDebtorIdPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.debtorId}/payments`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      postDebtorsByIdReceipts: build.mutation<
        PostDebtorsByIdReceiptsApiResponse,
        PostDebtorsByIdReceiptsApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/receipts`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsByIdReceipts: build.query<
        GetDebtorsByIdReceiptsApiResponse,
        GetDebtorsByIdReceiptsApiArg
      >({
        query: (queryArg) => ({ url: `/debtors/${queryArg.id}/receipts` }),
        providesTags: ["DebtorsController"],
      }),
      postDebtorsByIdStatementEmail: build.mutation<
        PostDebtorsByIdStatementEmailApiResponse,
        PostDebtorsByIdStatementEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/statement/email`,
          method: "POST",
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsByIdStatementPdf: build.query<
        GetDebtorsByIdStatementPdfApiResponse,
        GetDebtorsByIdStatementPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/statement/pdf`,
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsByIdStatement: build.query<
        GetDebtorsByIdStatementApiResponse,
        GetDebtorsByIdStatementApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/statement`,
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsByDebtorIdTransactionsAll: build.query<
        GetDebtorsByDebtorIdTransactionsAllApiResponse,
        GetDebtorsByDebtorIdTransactionsAllApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.debtorId}/transactions/all`,
        }),
        providesTags: ["TransactionsController"],
      }),
      getDebtorsByDebtorIdTransactionsSummary: build.query<
        GetDebtorsByDebtorIdTransactionsSummaryApiResponse,
        GetDebtorsByDebtorIdTransactionsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.debtorId}/transactions/summary`,
        }),
        providesTags: ["TransactionsController"],
      }),
      getDebtorsByDebtorIdVatInvoices: build.query<
        GetDebtorsByDebtorIdVatInvoicesApiResponse,
        GetDebtorsByDebtorIdVatInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.debtorId}/vat-invoices`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      getDebtorsByDebtorIdVatPayments: build.query<
        GetDebtorsByDebtorIdVatPaymentsApiResponse,
        GetDebtorsByDebtorIdVatPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.debtorId}/vat-payments`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      postDebtorsByIdVatStatementEmail: build.mutation<
        PostDebtorsByIdVatStatementEmailApiResponse,
        PostDebtorsByIdVatStatementEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/vat-statement/email`,
          method: "POST",
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsByIdVatStatementPdf: build.query<
        GetDebtorsByIdVatStatementPdfApiResponse,
        GetDebtorsByIdVatStatementPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/vat-statement/pdf`,
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        providesTags: ["DebtorsController"],
      }),
      getDebtorsByIdVatStatement: build.query<
        GetDebtorsByIdVatStatementApiResponse,
        GetDebtorsByIdVatStatementApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}/vat-statement`,
          params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
        }),
        providesTags: ["DebtorsController"],
      }),
      patchDebtorsById: build.mutation<
        PatchDebtorsByIdApiResponse,
        PatchDebtorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.debtorPartial,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtorsById: build.query<
        GetDebtorsByIdApiResponse,
        GetDebtorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["DebtorsController"],
      }),
      deleteDebtorsById: build.mutation<
        DeleteDebtorsByIdApiResponse,
        DeleteDebtorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/debtors/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      postDebtors: build.mutation<PostDebtorsApiResponse, PostDebtorsApiArg>({
        query: (queryArg) => ({
          url: `/debtors`,
          method: "POST",
          body: queryArg.newDebtor,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getDebtors: build.query<GetDebtorsApiResponse, GetDebtorsApiArg>({
        query: (queryArg) => ({
          url: `/debtors`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["DebtorsController"],
      }),
      postDevelopment: build.mutation<
        PostDevelopmentApiResponse,
        PostDevelopmentApiArg
      >({
        query: (queryArg) => ({
          url: `/development`,
          method: "POST",
          body: queryArg.developmentData,
        }),
        invalidatesTags: ["DevelopmentController"],
      }),
      getDevelopmentsCount: build.query<
        GetDevelopmentsCountApiResponse,
        GetDevelopmentsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/developments/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["DevelopmentController"],
      }),
      getDevelopmentsProjects: build.query<
        GetDevelopmentsProjectsApiResponse,
        GetDevelopmentsProjectsApiArg
      >({
        query: () => ({ url: `/developments/projects` }),
        providesTags: ["DevelopmentController"],
      }),
      putDevelopmentsById: build.mutation<
        PutDevelopmentsByIdApiResponse,
        PutDevelopmentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/developments/${queryArg.id}`,
          method: "PUT",
          body: queryArg.development,
        }),
        invalidatesTags: ["DevelopmentController"],
      }),
      patchDevelopmentsById: build.mutation<
        PatchDevelopmentsByIdApiResponse,
        PatchDevelopmentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/developments/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.developmentPartial,
        }),
        invalidatesTags: ["DevelopmentController"],
      }),
      getDevelopmentsById: build.query<
        GetDevelopmentsByIdApiResponse,
        GetDevelopmentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/developments/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["DevelopmentController"],
      }),
      deleteDevelopmentsById: build.mutation<
        DeleteDevelopmentsByIdApiResponse,
        DeleteDevelopmentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/developments/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DevelopmentController"],
      }),
      patchDevelopments: build.mutation<
        PatchDevelopmentsApiResponse,
        PatchDevelopmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/developments`,
          method: "PATCH",
          body: queryArg.developmentPartial,
          params: { where: queryArg.where },
        }),
        invalidatesTags: ["DevelopmentController"],
      }),
      getDevelopments: build.query<
        GetDevelopmentsApiResponse,
        GetDevelopmentsApiArg
      >({
        query: () => ({ url: `/developments` }),
        providesTags: ["DevelopmentController"],
      }),
      patchEmployeeReviewByIdCompleteGoal: build.mutation<
        PatchEmployeeReviewByIdCompleteGoalApiResponse,
        PatchEmployeeReviewByIdCompleteGoalApiArg
      >({
        query: (queryArg) => ({
          url: `/employee-review/${queryArg.id}/complete-goal`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      patchEmployeeReviewById: build.mutation<
        PatchEmployeeReviewByIdApiResponse,
        PatchEmployeeReviewByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/employee-review/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.employeeReviewPartial,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      getEmployeeReviewById: build.query<
        GetEmployeeReviewByIdApiResponse,
        GetEmployeeReviewByIdApiArg
      >({
        query: (queryArg) => ({ url: `/employee-review/${queryArg.id}` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getEmployeeReviewsGoalStatistics: build.query<
        GetEmployeeReviewsGoalStatisticsApiResponse,
        GetEmployeeReviewsGoalStatisticsApiArg
      >({
        query: (queryArg) => ({
          url: `/employee-reviews/goal-statistics`,
          params: { period: queryArg.period },
        }),
        providesTags: ["EmployeeReviewController"],
      }),
      getEmployeeReviewsByUserByUserId: build.query<
        GetEmployeeReviewsByUserByUserIdApiResponse,
        GetEmployeeReviewsByUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/employee-reviews-by-user/${queryArg.userId}`,
        }),
        providesTags: ["EmployeeReviewController"],
      }),
      patchExternalItemMapsById: build.mutation<
        PatchExternalItemMapsByIdApiResponse,
        PatchExternalItemMapsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/external-item-maps/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["ExternalItemMapController"],
      }),
      getExternalItemMaps: build.query<
        GetExternalItemMapsApiResponse,
        GetExternalItemMapsApiArg
      >({
        query: (queryArg) => ({
          url: `/external-item-maps`,
          params: {
            itemCode: queryArg.itemCode,
            description: queryArg.description,
            quantityUnit: queryArg.quantityUnit,
            externalItemCode: queryArg.externalItemCode,
            externalDescription: queryArg.externalDescription,
            externalQuantityUnit: queryArg.externalQuantityUnit,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["ExternalItemMapController"],
      }),
      getFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriod: build.query<
        GetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodApiResponse,
        GetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback-survey/draft/${queryArg.userId}/${queryArg.reviewerId}/${queryArg.reviewPeriod}`,
        }),
        providesTags: ["EmployeeReviewController"],
      }),
      putFeedbackSurveyDraft: build.mutation<
        PutFeedbackSurveyDraftApiResponse,
        PutFeedbackSurveyDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback-survey/draft`,
          method: "PUT",
          body: queryArg.feedbackSurveyDraftData,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      getFeedbackSurveyMySubmissions: build.query<
        GetFeedbackSurveyMySubmissionsApiResponse,
        GetFeedbackSurveyMySubmissionsApiArg
      >({
        query: () => ({ url: `/feedback-survey/my-submissions` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getFeedbackSurveyById: build.query<
        GetFeedbackSurveyByIdApiResponse,
        GetFeedbackSurveyByIdApiArg
      >({
        query: (queryArg) => ({ url: `/feedback-survey/${queryArg.id}` }),
        providesTags: ["EmployeeReviewController"],
      }),
      postFeedbackSurvey: build.mutation<
        PostFeedbackSurveyApiResponse,
        PostFeedbackSurveyApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback-survey`,
          method: "POST",
          body: queryArg.feedbackSurveyData,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      patchFinanceAccountsById: build.mutation<
        PatchFinanceAccountsByIdApiResponse,
        PatchFinanceAccountsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/accounts/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.accountPartial,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceAccountsById: build.query<
        GetFinanceAccountsByIdApiResponse,
        GetFinanceAccountsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/finance/accounts/${queryArg.id}` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceAccounts: build.mutation<
        PostFinanceAccountsApiResponse,
        PostFinanceAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/accounts`,
          method: "POST",
          body: queryArg.newAccount,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceAccounts: build.query<
        GetFinanceAccountsApiResponse,
        GetFinanceAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/accounts`,
          params: {
            accountType: queryArg.accountType,
            department: queryArg.department,
            isActive: queryArg.isActive,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      postFinanceBudgetsByIdActivate: build.mutation<
        PostFinanceBudgetsByIdActivateApiResponse,
        PostFinanceBudgetsByIdActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets/${queryArg.id}/activate`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceBudgetsByIdApprove: build.mutation<
        PostFinanceBudgetsByIdApproveApiResponse,
        PostFinanceBudgetsByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets/${queryArg.id}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceBudgetsByIdUtilization: build.query<
        GetFinanceBudgetsByIdUtilizationApiResponse,
        GetFinanceBudgetsByIdUtilizationApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets/${queryArg.id}/utilization`,
        }),
        providesTags: ["FinanceController"],
      }),
      patchFinanceBudgetsById: build.mutation<
        PatchFinanceBudgetsByIdApiResponse,
        PatchFinanceBudgetsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.budgetPartial,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceBudgetsById: build.query<
        GetFinanceBudgetsByIdApiResponse,
        GetFinanceBudgetsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/finance/budgets/${queryArg.id}` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceBudgets: build.mutation<
        PostFinanceBudgetsApiResponse,
        PostFinanceBudgetsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets`,
          method: "POST",
          body: queryArg.newBudget,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceBudgets: build.query<
        GetFinanceBudgetsApiResponse,
        GetFinanceBudgetsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/budgets`,
          params: {
            fiscalYear: queryArg.fiscalYear,
            department: queryArg.department,
            status: queryArg.status,
            budgetType: queryArg.budgetType,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceDashboard: build.query<
        GetFinanceDashboardApiResponse,
        GetFinanceDashboardApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/dashboard`,
          params: { developmentId: queryArg.developmentId },
        }),
        providesTags: ["FinanceDashboardController"],
      }),
      postFinanceExpenseReportsByIdAddExpense: build.mutation<
        PostFinanceExpenseReportsByIdAddExpenseApiResponse,
        PostFinanceExpenseReportsByIdAddExpenseApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}/add-expense`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceExpenseReportsByIdApprove: build.mutation<
        PostFinanceExpenseReportsByIdApproveApiResponse,
        PostFinanceExpenseReportsByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}/approve`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceExpenseReportsByIdReimburse: build.mutation<
        PostFinanceExpenseReportsByIdReimburseApiResponse,
        PostFinanceExpenseReportsByIdReimburseApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}/reimburse`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceExpenseReportsByIdReject: build.mutation<
        PostFinanceExpenseReportsByIdRejectApiResponse,
        PostFinanceExpenseReportsByIdRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}/reject`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceExpenseReportsByIdSubmit: build.mutation<
        PostFinanceExpenseReportsByIdSubmitApiResponse,
        PostFinanceExpenseReportsByIdSubmitApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}/submit`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      patchFinanceExpenseReportsById: build.mutation<
        PatchFinanceExpenseReportsByIdApiResponse,
        PatchFinanceExpenseReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.expenseReportPartial,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceExpenseReportsById: build.query<
        GetFinanceExpenseReportsByIdApiResponse,
        GetFinanceExpenseReportsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports/${queryArg.id}`,
        }),
        providesTags: ["FinanceController"],
      }),
      postFinanceExpenseReports: build.mutation<
        PostFinanceExpenseReportsApiResponse,
        PostFinanceExpenseReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports`,
          method: "POST",
          body: queryArg.newExpenseReport,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceExpenseReports: build.query<
        GetFinanceExpenseReportsApiResponse,
        GetFinanceExpenseReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/expense-reports`,
          params: {
            status: queryArg.status,
            department: queryArg.department,
            reportType: queryArg.reportType,
            myReportsOnly: queryArg.myReportsOnly,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceInvoicesAccountsPayableSummary: build.query<
        GetFinanceInvoicesAccountsPayableSummaryApiResponse,
        GetFinanceInvoicesAccountsPayableSummaryApiArg
      >({
        query: () => ({ url: `/finance/invoices/accounts-payable-summary` }),
        providesTags: ["FinanceController"],
      }),
      getFinanceInvoicesAccountsReceivableSummary: build.query<
        GetFinanceInvoicesAccountsReceivableSummaryApiResponse,
        GetFinanceInvoicesAccountsReceivableSummaryApiArg
      >({
        query: () => ({ url: `/finance/invoices/accounts-receivable-summary` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceInvoicesByIdApprove: build.mutation<
        PostFinanceInvoicesByIdApproveApiResponse,
        PostFinanceInvoicesByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/invoices/${queryArg.id}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceInvoicesByIdRecordPayment: build.mutation<
        PostFinanceInvoicesByIdRecordPaymentApiResponse,
        PostFinanceInvoicesByIdRecordPaymentApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/invoices/${queryArg.id}/record-payment`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      patchFinanceInvoicesById: build.mutation<
        PatchFinanceInvoicesByIdApiResponse,
        PatchFinanceInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/invoices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.invoicePartial,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceInvoicesById: build.query<
        GetFinanceInvoicesByIdApiResponse,
        GetFinanceInvoicesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/finance/invoices/${queryArg.id}` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceInvoices: build.mutation<
        PostFinanceInvoicesApiResponse,
        PostFinanceInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/invoices`,
          method: "POST",
          body: queryArg.newInvoice,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceInvoices: build.query<
        GetFinanceInvoicesApiResponse,
        GetFinanceInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/invoices`,
          params: {
            invoiceType: queryArg.invoiceType,
            status: queryArg.status,
            department: queryArg.department,
            partyName: queryArg.partyName,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceMonthlyInstalments: build.query<
        GetFinanceMonthlyInstalmentsApiResponse,
        GetFinanceMonthlyInstalmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/monthly-instalments`,
          params: {
            developmentId: queryArg.developmentId,
            month: queryArg.month,
          },
        }),
        providesTags: ["FinanceDashboardController"],
      }),
      getFinanceReportsExpenseSummaryByCategory: build.query<
        GetFinanceReportsExpenseSummaryByCategoryApiResponse,
        GetFinanceReportsExpenseSummaryByCategoryApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/reports/expense-summary-by-category`,
          params: {
            department: queryArg.department,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceReportsExpenseSummaryByEmployee: build.query<
        GetFinanceReportsExpenseSummaryByEmployeeApiResponse,
        GetFinanceReportsExpenseSummaryByEmployeeApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/reports/expense-summary-by-employee`,
          params: {
            department: queryArg.department,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceReportsGeneralLedgerByAccountId: build.query<
        GetFinanceReportsGeneralLedgerByAccountIdApiResponse,
        GetFinanceReportsGeneralLedgerByAccountIdApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/reports/general-ledger/${queryArg.accountId}`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceReportsTrialBalance: build.query<
        GetFinanceReportsTrialBalanceApiResponse,
        GetFinanceReportsTrialBalanceApiArg
      >({
        query: () => ({ url: `/finance/reports/trial-balance` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceTransactionsByIdApprove: build.mutation<
        PostFinanceTransactionsByIdApproveApiResponse,
        PostFinanceTransactionsByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/transactions/${queryArg.id}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceTransactionsByIdPost: build.mutation<
        PostFinanceTransactionsByIdPostApiResponse,
        PostFinanceTransactionsByIdPostApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/transactions/${queryArg.id}/post`,
          method: "POST",
        }),
        invalidatesTags: ["FinanceController"],
      }),
      postFinanceTransactionsByIdReverse: build.mutation<
        PostFinanceTransactionsByIdReverseApiResponse,
        PostFinanceTransactionsByIdReverseApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/transactions/${queryArg.id}/reverse`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceTransactionsById: build.query<
        GetFinanceTransactionsByIdApiResponse,
        GetFinanceTransactionsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/finance/transactions/${queryArg.id}` }),
        providesTags: ["FinanceController"],
      }),
      postFinanceTransactions: build.mutation<
        PostFinanceTransactionsApiResponse,
        PostFinanceTransactionsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/transactions`,
          method: "POST",
          body: queryArg.newTransaction,
        }),
        invalidatesTags: ["FinanceController"],
      }),
      getFinanceTransactions: build.query<
        GetFinanceTransactionsApiResponse,
        GetFinanceTransactionsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/transactions`,
          params: {
            transactionType: queryArg.transactionType,
            status: queryArg.status,
            department: queryArg.department,
            isPosted: queryArg.isPosted,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      postGetSignedUrl: build.mutation<
        PostGetSignedUrlApiResponse,
        PostGetSignedUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/get-signed-url`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["ProcurementProcessController"],
      }),
      getGradingConfigActive: build.query<
        GetGradingConfigActiveApiResponse,
        GetGradingConfigActiveApiArg
      >({
        query: () => ({ url: `/grading-config/active` }),
        providesTags: ["GradingConfigController"],
      }),
      postGradingConfigResetToDefault: build.mutation<
        PostGradingConfigResetToDefaultApiResponse,
        PostGradingConfigResetToDefaultApiArg
      >({
        query: () => ({
          url: `/grading-config/reset-to-default`,
          method: "POST",
        }),
        invalidatesTags: ["GradingConfigController"],
      }),
      patchGradingConfigById: build.mutation<
        PatchGradingConfigByIdApiResponse,
        PatchGradingConfigByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/grading-config/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.gradingConfigPartial,
        }),
        invalidatesTags: ["GradingConfigController"],
      }),
      postGradingConfig: build.mutation<
        PostGradingConfigApiResponse,
        PostGradingConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/grading-config`,
          method: "POST",
          body: queryArg.newGradingConfig,
        }),
        invalidatesTags: ["GradingConfigController"],
      }),
      getGradingConfig: build.query<
        GetGradingConfigApiResponse,
        GetGradingConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/grading-config`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["GradingConfigController"],
      }),
      getGrvsDropdown: build.query<
        GetGrvsDropdownApiResponse,
        GetGrvsDropdownApiArg
      >({
        query: () => ({ url: `/grvs/dropdown` }),
        providesTags: ["GRVController"],
      }),
      patchGrvsById: build.mutation<
        PatchGrvsByIdApiResponse,
        PatchGrvsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/grvs/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.grvPartial,
        }),
        invalidatesTags: ["GRVController"],
      }),
      getGrvsById: build.query<GetGrvsByIdApiResponse, GetGrvsByIdApiArg>({
        query: (queryArg) => ({ url: `/grvs/${queryArg.id}` }),
        providesTags: ["GRVController"],
      }),
      getGrvs: build.query<GetGrvsApiResponse, GetGrvsApiArg>({
        query: (queryArg) => ({
          url: `/grvs`,
          params: {
            grvNumber: queryArg.grvNumber,
            status: queryArg.status,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["GRVController"],
      }),
      postImportCreditors: build.mutation<
        PostImportCreditorsApiResponse,
        PostImportCreditorsApiArg
      >({
        query: () => ({ url: `/import/creditors`, method: "POST" }),
        invalidatesTags: ["DebtorCreditorImportController"],
      }),
      postImportDebtorInvoices: build.mutation<
        PostImportDebtorInvoicesApiResponse,
        PostImportDebtorInvoicesApiArg
      >({
        query: () => ({ url: `/import/debtor-invoices`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      postImportDebtors: build.mutation<
        PostImportDebtorsApiResponse,
        PostImportDebtorsApiArg
      >({
        query: () => ({ url: `/import/debtors`, method: "POST" }),
        invalidatesTags: ["DebtorCreditorImportController"],
      }),
      postImportPayments: build.mutation<
        PostImportPaymentsApiResponse,
        PostImportPaymentsApiArg
      >({
        query: () => ({ url: `/import/payments`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      postImportReceipts: build.mutation<
        PostImportReceiptsApiResponse,
        PostImportReceiptsApiArg
      >({
        query: () => ({ url: `/import/receipts`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      postImportTakeOnTransactions: build.mutation<
        PostImportTakeOnTransactionsApiResponse,
        PostImportTakeOnTransactionsApiArg
      >({
        query: () => ({ url: `/import/take-on-transactions`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      getImportTemplatesCreditors: build.query<
        GetImportTemplatesCreditorsApiResponse,
        GetImportTemplatesCreditorsApiArg
      >({
        query: () => ({ url: `/import/templates/creditors` }),
        providesTags: ["DebtorCreditorImportController"],
      }),
      getImportTemplatesDebtorInvoices: build.query<
        GetImportTemplatesDebtorInvoicesApiResponse,
        GetImportTemplatesDebtorInvoicesApiArg
      >({
        query: () => ({ url: `/import/templates/debtor-invoices` }),
        providesTags: ["TransactionsController"],
      }),
      getImportTemplatesDebtors: build.query<
        GetImportTemplatesDebtorsApiResponse,
        GetImportTemplatesDebtorsApiArg
      >({
        query: () => ({ url: `/import/templates/debtors` }),
        providesTags: ["DebtorCreditorImportController"],
      }),
      getImportTemplatesPayments: build.query<
        GetImportTemplatesPaymentsApiResponse,
        GetImportTemplatesPaymentsApiArg
      >({
        query: () => ({ url: `/import/templates/payments` }),
        providesTags: ["TransactionsController"],
      }),
      getImportTemplatesReceipts: build.query<
        GetImportTemplatesReceiptsApiResponse,
        GetImportTemplatesReceiptsApiArg
      >({
        query: () => ({ url: `/import/templates/receipts` }),
        providesTags: ["TransactionsController"],
      }),
      getImportTemplatesTakeOnTransactions: build.query<
        GetImportTemplatesTakeOnTransactionsApiResponse,
        GetImportTemplatesTakeOnTransactionsApiArg
      >({
        query: () => ({ url: `/import/templates/take-on-transactions` }),
        providesTags: ["TransactionsController"],
      }),
      getImportTemplatesVatInvoices: build.query<
        GetImportTemplatesVatInvoicesApiResponse,
        GetImportTemplatesVatInvoicesApiArg
      >({
        query: () => ({ url: `/import/templates/vat-invoices` }),
        providesTags: ["TransactionsController"],
      }),
      getImportTemplatesVatPayments: build.query<
        GetImportTemplatesVatPaymentsApiResponse,
        GetImportTemplatesVatPaymentsApiArg
      >({
        query: () => ({ url: `/import/templates/vat-payments` }),
        providesTags: ["TransactionsController"],
      }),
      postImportVatInvoices: build.mutation<
        PostImportVatInvoicesApiResponse,
        PostImportVatInvoicesApiArg
      >({
        query: () => ({ url: `/import/vat-invoices`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      postImportVatPayments: build.mutation<
        PostImportVatPaymentsApiResponse,
        PostImportVatPaymentsApiArg
      >({
        query: () => ({ url: `/import/vat-payments`, method: "POST" }),
        invalidatesTags: ["TransactionsController"],
      }),
      getInventoriesCount: build.query<
        GetInventoriesCountApiResponse,
        GetInventoriesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/inventories/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["InventoryController"],
      }),
      getInventoriesById: build.query<
        GetInventoriesByIdApiResponse,
        GetInventoriesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/inventories/${queryArg.id}` }),
        providesTags: ["InventoryController"],
      }),
      deleteInventoriesById: build.mutation<
        DeleteInventoriesByIdApiResponse,
        DeleteInventoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/inventories/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["InventoryController"],
      }),
      postInventories: build.mutation<
        PostInventoriesApiResponse,
        PostInventoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/inventories`,
          method: "POST",
          body: queryArg.newInventory,
        }),
        invalidatesTags: ["InventoryController"],
      }),
      getInventories: build.query<
        GetInventoriesApiResponse,
        GetInventoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/inventories`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["InventoryController"],
      }),
      patchInviteMarkAsScannedById: build.mutation<
        PatchInviteMarkAsScannedByIdApiResponse,
        PatchInviteMarkAsScannedByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/invite/markAsScanned/${queryArg.id}`,
          method: "PATCH",
        }),
        invalidatesTags: ["InviteController"],
      }),
      getInviteById: build.query<GetInviteByIdApiResponse, GetInviteByIdApiArg>(
        {
          query: (queryArg) => ({ url: `/invite/${queryArg.id}` }),
          providesTags: ["InviteController"],
        }
      ),
      getInvites: build.query<GetInvitesApiResponse, GetInvitesApiArg>({
        query: (queryArg) => ({
          url: `/invites`,
          params: { timeZone: queryArg.timeZone },
        }),
        providesTags: ["InviteController"],
      }),
      getItemCategoriesCount: build.query<
        GetItemCategoriesCountApiResponse,
        GetItemCategoriesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/item-categories/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["ItemCategoryController"],
      }),
      getItemCategoriesById: build.query<
        GetItemCategoriesByIdApiResponse,
        GetItemCategoriesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/item-categories/${queryArg.id}` }),
        providesTags: ["ItemCategoryController"],
      }),
      deleteItemCategoriesById: build.mutation<
        DeleteItemCategoriesByIdApiResponse,
        DeleteItemCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/item-categories/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ItemCategoryController"],
      }),
      postItemCategories: build.mutation<
        PostItemCategoriesApiResponse,
        PostItemCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/item-categories`,
          method: "POST",
          body: queryArg.newItemCategory,
        }),
        invalidatesTags: ["ItemCategoryController"],
      }),
      getItemCategories: build.query<
        GetItemCategoriesApiResponse,
        GetItemCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/item-categories`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["ItemCategoryController"],
      }),
      getItemLocationsCount: build.query<
        GetItemLocationsCountApiResponse,
        GetItemLocationsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/item-locations/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["ItemLocationController"],
      }),
      getItemLocationsById: build.query<
        GetItemLocationsByIdApiResponse,
        GetItemLocationsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/item-locations/${queryArg.id}` }),
        providesTags: ["ItemLocationController"],
      }),
      deleteItemLocationsById: build.mutation<
        DeleteItemLocationsByIdApiResponse,
        DeleteItemLocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/item-locations/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ItemLocationController"],
      }),
      postItemLocations: build.mutation<
        PostItemLocationsApiResponse,
        PostItemLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/item-locations`,
          method: "POST",
          body: queryArg.newItemLocation,
        }),
        invalidatesTags: ["ItemLocationController"],
      }),
      getItemLocations: build.query<
        GetItemLocationsApiResponse,
        GetItemLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/item-locations`,
          params: {
            itemCode: queryArg.itemCode,
            itemDescription: queryArg.itemDescription,
            locationCode: queryArg.locationCode,
            locationDescription: queryArg.locationDescription,
            developmentAllocation: queryArg.developmentAllocation,
            projectAllocation: queryArg.projectAllocation,
            supplier: queryArg.supplier,
            purchaseOrderNumber: queryArg.purchaseOrderNumber,
            currency: queryArg.currency,
            rate: queryArg.rate,
            itemDiscount: queryArg.itemDiscount,
            VAT: queryArg.vat,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["ItemLocationController"],
      }),
      getItemTransfersCount: build.query<
        GetItemTransfersCountApiResponse,
        GetItemTransfersCountApiArg
      >({
        query: (queryArg) => ({
          url: `/item-transfers/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["ItemTransferController"],
      }),
      getItemTransfersById: build.query<
        GetItemTransfersByIdApiResponse,
        GetItemTransfersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/item-transfers/${queryArg.id}` }),
        providesTags: ["ItemTransferController"],
      }),
      deleteItemTransfersById: build.mutation<
        DeleteItemTransfersByIdApiResponse,
        DeleteItemTransfersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/item-transfers/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ItemTransferController"],
      }),
      postItemTransfers: build.mutation<
        PostItemTransfersApiResponse,
        PostItemTransfersApiArg
      >({
        query: (queryArg) => ({
          url: `/item-transfers`,
          method: "POST",
          body: queryArg.newItemTransfer,
        }),
        invalidatesTags: ["ItemTransferController"],
      }),
      getItemTransfers: build.query<
        GetItemTransfersApiResponse,
        GetItemTransfersApiArg
      >({
        query: (queryArg) => ({
          url: `/item-transfers`,
          params: {
            title: queryArg.title,
            transferredBy: queryArg.transferredBy,
            transferType: queryArg.transferType,
            purchaseOrderNumber: queryArg.purchaseOrderNumber,
            procurementProcessId: queryArg.procurementProcessId,
            quotationNumber: queryArg.quotationNumber,
            currency: queryArg.currency,
            transferredDate: queryArg.transferredDate,
            isService: queryArg.isService,
            sourceLocationType: queryArg.sourceLocationType,
            destinationLocationType: queryArg.destinationLocationType,
            reasonForTransfer: queryArg.reasonForTransfer,
            grvNumber: queryArg.grvNumber,
            givNumber: queryArg.givNumber,
            supplier: queryArg.supplier,
            limit: queryArg.limit,
            skip: queryArg.skip,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
          },
        }),
        providesTags: ["ItemTransferController"],
      }),
      getItemsCount: build.query<GetItemsCountApiResponse, GetItemsCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/items/count`,
            params: { where: queryArg.where },
          }),
          providesTags: ["ItemController"],
        }
      ),
      getItemsDropdown: build.query<
        GetItemsDropdownApiResponse,
        GetItemsDropdownApiArg
      >({
        query: () => ({ url: `/items/dropdown` }),
        providesTags: ["ItemController"],
      }),
      getItemsById: build.query<GetItemsByIdApiResponse, GetItemsByIdApiArg>({
        query: (queryArg) => ({ url: `/items/${queryArg.id}` }),
        providesTags: ["ItemController"],
      }),
      deleteItemsById: build.mutation<
        DeleteItemsByIdApiResponse,
        DeleteItemsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/items/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ItemController"],
      }),
      postItems: build.mutation<PostItemsApiResponse, PostItemsApiArg>({
        query: (queryArg) => ({
          url: `/items`,
          method: "POST",
          body: queryArg.newItem,
        }),
        invalidatesTags: ["ItemController"],
      }),
      getItems: build.query<GetItemsApiResponse, GetItemsApiArg>({
        query: (queryArg) => ({
          url: `/items`,
          params: {
            itemCode: queryArg.itemCode,
            description: queryArg.description,
            quantityUnit: queryArg.quantityUnit,
            inventoryCode: queryArg.inventoryCode,
            inventoryDescription: queryArg.inventoryDescription,
            categoryCode: queryArg.categoryCode,
            categoryDescription: queryArg.categoryDescription,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["ItemController"],
      }),
      postItemsIssued: build.mutation<
        PostItemsIssuedApiResponse,
        PostItemsIssuedApiArg
      >({
        query: (queryArg) => ({
          url: `/items-issued`,
          method: "POST",
          body: queryArg.newItemsIssued,
        }),
        invalidatesTags: ["ItemIssuedController"],
      }),
      getItemsIssued: build.query<
        GetItemsIssuedApiResponse,
        GetItemsIssuedApiArg
      >({
        query: (queryArg) => ({
          url: `/items-issued`,
          params: {
            itemCode: queryArg.itemCode,
            itemDescription: queryArg.itemDescription,
            unitName: queryArg.unitName,
            locationDescription: queryArg.locationDescription,
            developmentAllocation: queryArg.developmentAllocation,
            projectAllocation: queryArg.projectAllocation,
            correctProjectAllocation: queryArg.correctProjectAllocation,
            isIncorrectIssue: queryArg.isIncorrectIssue,
            supplier: queryArg.supplier,
            purchaseOrderNumber: queryArg.purchaseOrderNumber,
            currency: queryArg.currency,
            rate: queryArg.rate,
            itemDiscount: queryArg.itemDiscount,
            VAT: queryArg.vat,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["ItemIssuedController"],
      }),
      getJobDescriptionsActive: build.query<
        GetJobDescriptionsActiveApiResponse,
        GetJobDescriptionsActiveApiArg
      >({
        query: () => ({ url: `/job-descriptions/active` }),
        providesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsByDepartmentByDepartment: build.query<
        GetJobDescriptionsByDepartmentByDepartmentApiResponse,
        GetJobDescriptionsByDepartmentByDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/by-department/${queryArg.department}`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsCount: build.query<
        GetJobDescriptionsCountApiResponse,
        GetJobDescriptionsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsDepartments: build.query<
        GetJobDescriptionsDepartmentsApiResponse,
        GetJobDescriptionsDepartmentsApiArg
      >({
        query: () => ({ url: `/job-descriptions/departments` }),
        providesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsGrades: build.query<
        GetJobDescriptionsGradesApiResponse,
        GetJobDescriptionsGradesApiArg
      >({
        query: () => ({ url: `/job-descriptions/grades` }),
        providesTags: ["JobDescriptionController"],
      }),
      postJobDescriptionsMy: build.mutation<
        PostJobDescriptionsMyApiResponse,
        PostJobDescriptionsMyApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/my`,
          method: "POST",
          body: queryArg.newMyJobDescription,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      patchJobDescriptionsMy: build.mutation<
        PatchJobDescriptionsMyApiResponse,
        PatchJobDescriptionsMyApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/my`,
          method: "PATCH",
          body: queryArg.jobDescriptionPartial,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsMy: build.query<
        GetJobDescriptionsMyApiResponse,
        GetJobDescriptionsMyApiArg
      >({
        query: () => ({ url: `/job-descriptions/my` }),
        providesTags: ["JobDescriptionController"],
      }),
      deleteJobDescriptionsMy: build.mutation<
        DeleteJobDescriptionsMyApiResponse,
        DeleteJobDescriptionsMyApiArg
      >({
        query: () => ({ url: `/job-descriptions/my`, method: "DELETE" }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      postJobDescriptionsRecalculateAllCounts: build.mutation<
        PostJobDescriptionsRecalculateAllCountsApiResponse,
        PostJobDescriptionsRecalculateAllCountsApiArg
      >({
        query: () => ({
          url: `/job-descriptions/recalculate-all-counts`,
          method: "POST",
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsTeam: build.query<
        GetJobDescriptionsTeamApiResponse,
        GetJobDescriptionsTeamApiArg
      >({
        query: () => ({ url: `/job-descriptions/team` }),
        providesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsUserByUserId: build.query<
        GetJobDescriptionsUserByUserIdApiResponse,
        GetJobDescriptionsUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/user/${queryArg.userId}`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      postJobDescriptionsByIdAssign: build.mutation<
        PostJobDescriptionsByIdAssignApiResponse,
        PostJobDescriptionsByIdAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}/assign`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsByIdReportsCounts: build.query<
        GetJobDescriptionsByIdReportsCountsApiResponse,
        GetJobDescriptionsByIdReportsCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}/reports-counts`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      postJobDescriptionsByIdUnassign: build.mutation<
        PostJobDescriptionsByIdUnassignApiResponse,
        PostJobDescriptionsByIdUnassignApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}/unassign`,
          method: "POST",
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      putJobDescriptionsById: build.mutation<
        PutJobDescriptionsByIdApiResponse,
        PutJobDescriptionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}`,
          method: "PUT",
          body: queryArg.jobDescription,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      patchJobDescriptionsById: build.mutation<
        PatchJobDescriptionsByIdApiResponse,
        PatchJobDescriptionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.jobDescriptionPartial,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      getJobDescriptionsById: build.query<
        GetJobDescriptionsByIdApiResponse,
        GetJobDescriptionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["JobDescriptionController"],
      }),
      deleteJobDescriptionsById: build.mutation<
        DeleteJobDescriptionsByIdApiResponse,
        DeleteJobDescriptionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      postJobDescriptions: build.mutation<
        PostJobDescriptionsApiResponse,
        PostJobDescriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions`,
          method: "POST",
          body: queryArg.newJobDescription,
        }),
        invalidatesTags: ["JobDescriptionController"],
      }),
      getJobDescriptions: build.query<
        GetJobDescriptionsApiResponse,
        GetJobDescriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/job-descriptions`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["JobDescriptionController"],
      }),
      postKnowledgeBase: build.mutation<
        PostKnowledgeBaseApiResponse,
        PostKnowledgeBaseApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge-base`,
          method: "POST",
          body: queryArg.newKnowledgeBaseEntry,
        }),
        invalidatesTags: ["KnowledgeBaseController"],
      }),
      getKnowledgeBase: build.query<
        GetKnowledgeBaseApiResponse,
        GetKnowledgeBaseApiArg
      >({
        query: () => ({ url: `/knowledge-base` }),
        providesTags: ["KnowledgeBaseController"],
      }),
      postLabourAttendanceBatch: build.mutation<
        PostLabourAttendanceBatchApiResponse,
        PostLabourAttendanceBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/attendance/batch`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      getLabourAttendance: build.query<
        GetLabourAttendanceApiResponse,
        GetLabourAttendanceApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/attendance`,
          params: { from: queryArg["from"], to: queryArg.to },
        }),
        providesTags: ["LabourTrackerController"],
      }),
      patchLabourBlocksById: build.mutation<
        PatchLabourBlocksByIdApiResponse,
        PatchLabourBlocksByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/blocks/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      deleteLabourBlocksById: build.mutation<
        DeleteLabourBlocksByIdApiResponse,
        DeleteLabourBlocksByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/blocks/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      postLabourBlocks: build.mutation<
        PostLabourBlocksApiResponse,
        PostLabourBlocksApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/blocks`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      getLabourBlocks: build.query<
        GetLabourBlocksApiResponse,
        GetLabourBlocksApiArg
      >({
        query: () => ({ url: `/labour/blocks` }),
        providesTags: ["LabourTrackerController"],
      }),
      getLabourReportsDaily: build.query<
        GetLabourReportsDailyApiResponse,
        GetLabourReportsDailyApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/reports/daily`,
          params: { date: queryArg.date },
        }),
        providesTags: ["LabourTrackerController"],
      }),
      getLabourReportsDashboard: build.query<
        GetLabourReportsDashboardApiResponse,
        GetLabourReportsDashboardApiArg
      >({
        query: () => ({ url: `/labour/reports/dashboard` }),
        providesTags: ["LabourTrackerController"],
      }),
      getLabourReportsPayroll: build.query<
        GetLabourReportsPayrollApiResponse,
        GetLabourReportsPayrollApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/reports/payroll`,
          params: { from: queryArg["from"], to: queryArg.to },
        }),
        providesTags: ["LabourTrackerController"],
      }),
      getLabourReportsRange: build.query<
        GetLabourReportsRangeApiResponse,
        GetLabourReportsRangeApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/reports/range`,
          params: { from: queryArg["from"], to: queryArg.to },
        }),
        providesTags: ["LabourTrackerController"],
      }),
      postLabourWorkersImportOdoo: build.mutation<
        PostLabourWorkersImportOdooApiResponse,
        PostLabourWorkersImportOdooApiArg
      >({
        query: () => ({ url: `/labour/workers/import-odoo`, method: "POST" }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      patchLabourWorkersById: build.mutation<
        PatchLabourWorkersByIdApiResponse,
        PatchLabourWorkersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/workers/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      deleteLabourWorkersById: build.mutation<
        DeleteLabourWorkersByIdApiResponse,
        DeleteLabourWorkersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/workers/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      postLabourWorkers: build.mutation<
        PostLabourWorkersApiResponse,
        PostLabourWorkersApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/workers`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["LabourTrackerController"],
      }),
      getLabourWorkers: build.query<
        GetLabourWorkersApiResponse,
        GetLabourWorkersApiArg
      >({
        query: (queryArg) => ({
          url: `/labour/workers`,
          params: { active: queryArg.active },
        }),
        providesTags: ["LabourTrackerController"],
      }),
      getLifeWheelById: build.query<
        GetLifeWheelByIdApiResponse,
        GetLifeWheelByIdApiArg
      >({
        query: (queryArg) => ({ url: `/life-wheel/${queryArg.id}` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getLifeWheelsByUserByUserId: build.query<
        GetLifeWheelsByUserByUserIdApiResponse,
        GetLifeWheelsByUserByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/life-wheels-by-user/${queryArg.userId}`,
        }),
        providesTags: ["EmployeeReviewController"],
      }),
      getOrgChartDepartmentByDepartment: build.query<
        GetOrgChartDepartmentByDepartmentApiResponse,
        GetOrgChartDepartmentByDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/org-chart/department/${queryArg.department}`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getOrgChartSupervisors: build.query<
        GetOrgChartSupervisorsApiResponse,
        GetOrgChartSupervisorsApiArg
      >({
        query: (queryArg) => ({
          url: `/org-chart/supervisors`,
          params: { excludeUserId: queryArg.excludeUserId },
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getOrgChartUserByUserIdDirectReports: build.query<
        GetOrgChartUserByUserIdDirectReportsApiResponse,
        GetOrgChartUserByUserIdDirectReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/org-chart/user/${queryArg.userId}/direct-reports`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getOrgChartUserByUserIdReportingChain: build.query<
        GetOrgChartUserByUserIdReportingChainApiResponse,
        GetOrgChartUserByUserIdReportingChainApiArg
      >({
        query: (queryArg) => ({
          url: `/org-chart/user/${queryArg.userId}/reporting-chain`,
        }),
        providesTags: ["JobDescriptionController"],
      }),
      getOrgChartUserByUserId: build.query<
        GetOrgChartUserByUserIdApiResponse,
        GetOrgChartUserByUserIdApiArg
      >({
        query: (queryArg) => ({ url: `/org-chart/user/${queryArg.userId}` }),
        providesTags: ["JobDescriptionController"],
      }),
      getOrgChart: build.query<GetOrgChartApiResponse, GetOrgChartApiArg>({
        query: () => ({ url: `/org-chart` }),
        providesTags: ["JobDescriptionController"],
      }),
      getPasswordResetIsResetLinkValidByResetId: build.query<
        GetPasswordResetIsResetLinkValidByResetIdApiResponse,
        GetPasswordResetIsResetLinkValidByResetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/is-reset-link-valid/${queryArg.resetId}`,
        }),
        providesTags: ["PasswordResetRequestController"],
      }),
      postPasswordResetRequestByUserEmail: build.mutation<
        PostPasswordResetRequestByUserEmailApiResponse,
        PostPasswordResetRequestByUserEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/request/${queryArg.userEmail}`,
          method: "POST",
        }),
        invalidatesTags: ["PasswordResetRequestController"],
      }),
      postPasswordResetResetPassword: build.mutation<
        PostPasswordResetResetPasswordApiResponse,
        PostPasswordResetResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/reset-password`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PasswordResetRequestController"],
      }),
      patchPaymentRequisitionsById: build.mutation<
        PatchPaymentRequisitionsByIdApiResponse,
        PatchPaymentRequisitionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/payment-requisitions/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.paymentRequisitionPartial,
        }),
        invalidatesTags: ["PaymentRequisitionController"],
      }),
      postPaymentRequisitions: build.mutation<
        PostPaymentRequisitionsApiResponse,
        PostPaymentRequisitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/payment-requisitions`,
          method: "POST",
          body: queryArg.newPaymentRequisition,
        }),
        invalidatesTags: ["PaymentRequisitionController"],
      }),
      getPaymentRequisitions: build.query<
        GetPaymentRequisitionsApiResponse,
        GetPaymentRequisitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/payment-requisitions`,
          params: {
            title: queryArg.title,
            supplierName: queryArg.supplierName,
            reqNumber: queryArg.reqNumber,
            development: queryArg.development,
            project: queryArg.project,
            department: queryArg.department,
            currency: queryArg.currency,
            referenceNumber: queryArg.referenceNumber,
            batchNumber: queryArg.batchNumber,
            paymentMethod: queryArg.paymentMethod,
            paymentType: queryArg.paymentType,
            status: queryArg.status,
            priority: queryArg.priority,
            amount: queryArg.amount,
            purchaseOrderNumber: queryArg.purchaseOrderNumber,
            procurementProcessId: queryArg.procurementProcessId,
            reviewedByEmail: queryArg.reviewedByEmail,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            isOutstandingPayment: queryArg.isOutstandingPayment,
            reportByEmail: queryArg.reportByEmail,
            notReviewedOnly: queryArg.notReviewedOnly,
            reportName: queryArg.reportName,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["PaymentRequisitionController"],
      }),
      getPaymentsCount: build.query<
        GetPaymentsCountApiResponse,
        GetPaymentsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["TransactionsController"],
      }),
      patchPaymentsById: build.mutation<
        PatchPaymentsByIdApiResponse,
        PatchPaymentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.paymentPartial,
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      getPaymentsById: build.query<
        GetPaymentsByIdApiResponse,
        GetPaymentsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/payments/${queryArg.id}` }),
        providesTags: ["TransactionsController"],
      }),
      deletePaymentsById: build.mutation<
        DeletePaymentsByIdApiResponse,
        DeletePaymentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      postPayments: build.mutation<PostPaymentsApiResponse, PostPaymentsApiArg>(
        {
          query: (queryArg) => ({
            url: `/payments`,
            method: "POST",
            body: queryArg.newPayment,
          }),
          invalidatesTags: ["TransactionsController"],
        }
      ),
      getPayments: build.query<GetPaymentsApiResponse, GetPaymentsApiArg>({
        query: (queryArg) => ({
          url: `/payments`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      postPayrollUpload: build.mutation<
        PostPayrollUploadApiResponse,
        PostPayrollUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/payroll/upload`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PayrollController"],
      }),
      getPearReviewsAdminAll: build.query<
        GetPearReviewsAdminAllApiResponse,
        GetPearReviewsAdminAllApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/admin/all`,
          params: {
            reviewPeriod: queryArg.reviewPeriod,
            status: queryArg.status,
          },
        }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsByEmployeeByEmployeeId: build.query<
        GetPearReviewsByEmployeeByEmployeeIdApiResponse,
        GetPearReviewsByEmployeeByEmployeeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/by-employee/${queryArg.employeeId}`,
        }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsCount: build.query<
        GetPearReviewsCountApiResponse,
        GetPearReviewsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsMyDirectReports: build.query<
        GetPearReviewsMyDirectReportsApiResponse,
        GetPearReviewsMyDirectReportsApiArg
      >({
        query: () => ({ url: `/pear-reviews/my-direct-reports` }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsMyReviews: build.query<
        GetPearReviewsMyReviewsApiResponse,
        GetPearReviewsMyReviewsApiArg
      >({
        query: () => ({ url: `/pear-reviews/my-reviews` }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsRatingScale: build.query<
        GetPearReviewsRatingScaleApiResponse,
        GetPearReviewsRatingScaleApiArg
      >({
        query: () => ({ url: `/pear-reviews/rating-scale` }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsSummary: build.query<
        GetPearReviewsSummaryApiResponse,
        GetPearReviewsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/summary`,
          params: { reviewPeriod: queryArg.reviewPeriod },
        }),
        providesTags: ["PEARReviewController"],
      }),
      getPearReviewsTemplate: build.query<
        GetPearReviewsTemplateApiResponse,
        GetPearReviewsTemplateApiArg
      >({
        query: () => ({ url: `/pear-reviews/template` }),
        providesTags: ["PEARReviewController"],
      }),
      postPearReviewsByIdApprove: build.mutation<
        PostPearReviewsByIdApproveApiResponse,
        PostPearReviewsByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      patchPearReviewsByIdManagerEdit: build.mutation<
        PatchPearReviewsByIdManagerEditApiResponse,
        PatchPearReviewsByIdManagerEditApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}/manager-edit`,
          method: "PATCH",
          body: queryArg.pearReviewPartial,
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      postPearReviewsByIdSubmit: build.mutation<
        PostPearReviewsByIdSubmitApiResponse,
        PostPearReviewsByIdSubmitApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}/submit`,
          method: "POST",
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      patchPearReviewsById: build.mutation<
        PatchPearReviewsByIdApiResponse,
        PatchPearReviewsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.pearReviewPartial,
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      getPearReviewsById: build.query<
        GetPearReviewsByIdApiResponse,
        GetPearReviewsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["PEARReviewController"],
      }),
      deletePearReviewsById: build.mutation<
        DeletePearReviewsByIdApiResponse,
        DeletePearReviewsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      postPearReviews: build.mutation<
        PostPearReviewsApiResponse,
        PostPearReviewsApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews`,
          method: "POST",
          body: queryArg.newPearReview,
        }),
        invalidatesTags: ["PEARReviewController"],
      }),
      getPearReviews: build.query<
        GetPearReviewsApiResponse,
        GetPearReviewsApiArg
      >({
        query: (queryArg) => ({
          url: `/pear-reviews`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["PEARReviewController"],
      }),
      postPerformanceAssessmentAlertsSmokeTest: build.mutation<
        PostPerformanceAssessmentAlertsSmokeTestApiResponse,
        PostPerformanceAssessmentAlertsSmokeTestApiArg
      >({
        query: (queryArg) => ({
          url: `/performance-assessment-alerts/smoke-test`,
          method: "POST",
          params: { trigger: queryArg.trigger },
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      getPerformanceRatings: build.query<
        GetPerformanceRatingsApiResponse,
        GetPerformanceRatingsApiArg
      >({
        query: () => ({ url: `/performance-ratings` }),
        providesTags: ["BalancedScorecardController"],
      }),
      postPettyCashBulkApprove: build.mutation<
        PostPettyCashBulkApproveApiResponse,
        PostPettyCashBulkApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/bulk-approve`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashMigratePaymentRequisitions: build.mutation<
        PostPettyCashMigratePaymentRequisitionsApiResponse,
        PostPettyCashMigratePaymentRequisitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/migrate-payment-requisitions`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      getPettyCashSummaryDashboard: build.query<
        GetPettyCashSummaryDashboardApiResponse,
        GetPettyCashSummaryDashboardApiArg
      >({
        query: () => ({ url: `/petty-cash/summary/dashboard` }),
        providesTags: ["RequesttoPaymentController"],
      }),
      patchPettyCashSummarySettings: build.mutation<
        PatchPettyCashSummarySettingsApiResponse,
        PatchPettyCashSummarySettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/summary/settings`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      getPettyCashSummarySettings: build.query<
        GetPettyCashSummarySettingsApiResponse,
        GetPettyCashSummarySettingsApiArg
      >({
        query: () => ({ url: `/petty-cash/summary/settings` }),
        providesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdApprove: build.mutation<
        PostPettyCashByIdApproveApiResponse,
        PostPettyCashByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/approve`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      getPettyCashByIdAuditLog: build.query<
        GetPettyCashByIdAuditLogApiResponse,
        GetPettyCashByIdAuditLogApiArg
      >({
        query: (queryArg) => ({ url: `/petty-cash/${queryArg.id}/audit-log` }),
        providesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdCancel: build.mutation<
        PostPettyCashByIdCancelApiResponse,
        PostPettyCashByIdCancelApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/cancel`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdHold: build.mutation<
        PostPettyCashByIdHoldApiResponse,
        PostPettyCashByIdHoldApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/hold`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdMarkPaid: build.mutation<
        PostPettyCashByIdMarkPaidApiResponse,
        PostPettyCashByIdMarkPaidApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/mark-paid`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdMoreInfo: build.mutation<
        PostPettyCashByIdMoreInfoApiResponse,
        PostPettyCashByIdMoreInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/more-info`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      patchPettyCashByIdPaymentDetails: build.mutation<
        PatchPettyCashByIdPaymentDetailsApiResponse,
        PatchPettyCashByIdPaymentDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/payment-details`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdPrepare: build.mutation<
        PostPettyCashByIdPrepareApiResponse,
        PostPettyCashByIdPrepareApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/prepare`,
          method: "POST",
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdReject: build.mutation<
        PostPettyCashByIdRejectApiResponse,
        PostPettyCashByIdRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/reject`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdSubmit: build.mutation<
        PostPettyCashByIdSubmitApiResponse,
        PostPettyCashByIdSubmitApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/submit`,
          method: "POST",
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      postPettyCashByIdUpload: build.mutation<
        PostPettyCashByIdUploadApiResponse,
        PostPettyCashByIdUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/upload`,
          method: "POST",
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      patchPettyCashByIdUrgency: build.mutation<
        PatchPettyCashByIdUrgencyApiResponse,
        PatchPettyCashByIdUrgencyApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}/urgency`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      patchPettyCashById: build.mutation<
        PatchPettyCashByIdApiResponse,
        PatchPettyCashByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      getPettyCashById: build.query<
        GetPettyCashByIdApiResponse,
        GetPettyCashByIdApiArg
      >({
        query: (queryArg) => ({ url: `/petty-cash/${queryArg.id}` }),
        providesTags: ["RequesttoPaymentController"],
      }),
      postPettyCash: build.mutation<
        PostPettyCashApiResponse,
        PostPettyCashApiArg
      >({
        query: (queryArg) => ({
          url: `/petty-cash`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["RequesttoPaymentController"],
      }),
      getPettyCash: build.query<GetPettyCashApiResponse, GetPettyCashApiArg>({
        query: () => ({ url: `/petty-cash` }),
        providesTags: ["RequesttoPaymentController"],
      }),
      getPing: build.query<GetPingApiResponse, GetPingApiArg>({
        query: () => ({ url: `/ping` }),
        providesTags: ["PingController"],
      }),
      getProcurementContractsBySupplierBySupplierId: build.query<
        GetProcurementContractsBySupplierBySupplierIdApiResponse,
        GetProcurementContractsBySupplierBySupplierIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts/by-supplier/${queryArg.supplierId}`,
        }),
        providesTags: ["ProcurementContractController"],
      }),
      getProcurementContractsCount: build.query<
        GetProcurementContractsCountApiResponse,
        GetProcurementContractsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["ProcurementContractController"],
      }),
      patchProcurementContractsById: build.mutation<
        PatchProcurementContractsByIdApiResponse,
        PatchProcurementContractsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.procurementContractPartial,
        }),
        invalidatesTags: ["ProcurementContractController"],
      }),
      getProcurementContractsById: build.query<
        GetProcurementContractsByIdApiResponse,
        GetProcurementContractsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/procurement-contracts/${queryArg.id}` }),
        providesTags: ["ProcurementContractController"],
      }),
      deleteProcurementContractsById: build.mutation<
        DeleteProcurementContractsByIdApiResponse,
        DeleteProcurementContractsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProcurementContractController"],
      }),
      postProcurementContracts: build.mutation<
        PostProcurementContractsApiResponse,
        PostProcurementContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts`,
          method: "POST",
          body: queryArg.newProcurementContract,
        }),
        invalidatesTags: ["ProcurementContractController"],
      }),
      getProcurementContracts: build.query<
        GetProcurementContractsApiResponse,
        GetProcurementContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-contracts`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["ProcurementContractController"],
      }),
      putProcurementProcessesById: build.mutation<
        PutProcurementProcessesByIdApiResponse,
        PutProcurementProcessesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-processes/${queryArg.id}`,
          method: "PUT",
          body: queryArg.procurementProcessPartial,
        }),
        invalidatesTags: ["ProcurementProcessController"],
      }),
      patchProcurementProcessesById: build.mutation<
        PatchProcurementProcessesByIdApiResponse,
        PatchProcurementProcessesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-processes/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.procurementProcessPartial,
        }),
        invalidatesTags: ["ProcurementProcessController"],
      }),
      getProcurementProcessesById: build.query<
        GetProcurementProcessesByIdApiResponse,
        GetProcurementProcessesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/procurement-processes/${queryArg.id}` }),
        providesTags: ["ProcurementProcessController"],
      }),
      deleteProcurementProcessesById: build.mutation<
        DeleteProcurementProcessesByIdApiResponse,
        DeleteProcurementProcessesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-processes/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProcurementProcessController"],
      }),
      getProcurementProcesses: build.query<
        GetProcurementProcessesApiResponse,
        GetProcurementProcessesApiArg
      >({
        query: (queryArg) => ({
          url: `/procurement-processes`,
          params: {
            currentTask: queryArg.currentTask,
            requestType: queryArg.requestType,
            limit: queryArg.limit,
            skip: queryArg.skip,
            title: queryArg.title,
            approved: queryArg.approved,
            development: queryArg.development,
            reqNumber: queryArg.reqNumber,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            rejectedBy: queryArg.rejectedBy,
            approvedBy: queryArg.approvedBy,
            reportByEmail: queryArg.reportByEmail,
            reportName: queryArg.reportName,
            procurementOfficer: queryArg.procurementOfficer,
            procurementProcessId: queryArg.procurementProcessId,
          },
        }),
        providesTags: ["ProcurementProcessController"],
      }),
      getProperties: build.query<GetPropertiesApiResponse, GetPropertiesApiArg>(
        {
          query: (queryArg) => ({
            url: `/properties`,
            params: { filter: queryArg.filter },
          }),
          providesTags: ["PropertyRegisterController"],
        }
      ),
      postProperty: build.mutation<PostPropertyApiResponse, PostPropertyApiArg>(
        {
          query: (queryArg) => ({
            url: `/property`,
            method: "POST",
            body: queryArg.propertyData,
          }),
          invalidatesTags: ["PropertyRegisterController"],
        }
      ),
      getProtrackDashboard: build.query<
        GetProtrackDashboardApiResponse,
        GetProtrackDashboardApiArg
      >({
        query: () => ({ url: `/protrack/dashboard` }),
        providesTags: ["ProTrackController"],
      }),
      patchProtrackHandoversById: build.mutation<
        PatchProtrackHandoversByIdApiResponse,
        PatchProtrackHandoversByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/handovers/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.proTrackHandoverPartial,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackHandoversById: build.query<
        GetProtrackHandoversByIdApiResponse,
        GetProtrackHandoversByIdApiArg
      >({
        query: (queryArg) => ({ url: `/protrack/handovers/${queryArg.id}` }),
        providesTags: ["ProTrackController"],
      }),
      deleteProtrackHandoversById: build.mutation<
        DeleteProtrackHandoversByIdApiResponse,
        DeleteProtrackHandoversByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/handovers/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      postProtrackHandovers: build.mutation<
        PostProtrackHandoversApiResponse,
        PostProtrackHandoversApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/handovers`,
          method: "POST",
          body: queryArg.newProTrackHandover,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackHandovers: build.query<
        GetProtrackHandoversApiResponse,
        GetProtrackHandoversApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/handovers`,
          params: { blockId: queryArg.blockId, status: queryArg.status },
        }),
        providesTags: ["ProTrackController"],
      }),
      patchProtrackMilestonesById: build.mutation<
        PatchProtrackMilestonesByIdApiResponse,
        PatchProtrackMilestonesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/milestones/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.proTrackMilestonePartial,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackMilestonesById: build.query<
        GetProtrackMilestonesByIdApiResponse,
        GetProtrackMilestonesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/protrack/milestones/${queryArg.id}` }),
        providesTags: ["ProTrackController"],
      }),
      deleteProtrackMilestonesById: build.mutation<
        DeleteProtrackMilestonesByIdApiResponse,
        DeleteProtrackMilestonesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/milestones/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      postProtrackMilestones: build.mutation<
        PostProtrackMilestonesApiResponse,
        PostProtrackMilestonesApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/milestones`,
          method: "POST",
          body: queryArg.newProTrackMilestone,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackMilestones: build.query<
        GetProtrackMilestonesApiResponse,
        GetProtrackMilestonesApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/milestones`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["ProTrackController"],
      }),
      getProtrackProjectsPortfolio: build.query<
        GetProtrackProjectsPortfolioApiResponse,
        GetProtrackProjectsPortfolioApiArg
      >({
        query: () => ({ url: `/protrack/projects/portfolio` }),
        providesTags: ["ProTrackController"],
      }),
      patchProtrackProjectsById: build.mutation<
        PatchProtrackProjectsByIdApiResponse,
        PatchProtrackProjectsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/projects/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.proTrackProjectPartial,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackProjectsById: build.query<
        GetProtrackProjectsByIdApiResponse,
        GetProtrackProjectsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/protrack/projects/${queryArg.id}` }),
        providesTags: ["ProTrackController"],
      }),
      deleteProtrackProjectsById: build.mutation<
        DeleteProtrackProjectsByIdApiResponse,
        DeleteProtrackProjectsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/projects/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      postProtrackProjects: build.mutation<
        PostProtrackProjectsApiResponse,
        PostProtrackProjectsApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/projects`,
          method: "POST",
          body: queryArg.newProTrackProject,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackProjects: build.query<
        GetProtrackProjectsApiResponse,
        GetProtrackProjectsApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/projects`,
          params: {
            siteId: queryArg.siteId,
            overallStatus: queryArg.overallStatus,
          },
        }),
        providesTags: ["ProTrackController"],
      }),
      patchProtrackSnagsById: build.mutation<
        PatchProtrackSnagsByIdApiResponse,
        PatchProtrackSnagsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/snags/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.proTrackSnagPartial,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackSnagsById: build.query<
        GetProtrackSnagsByIdApiResponse,
        GetProtrackSnagsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/protrack/snags/${queryArg.id}` }),
        providesTags: ["ProTrackController"],
      }),
      deleteProtrackSnagsById: build.mutation<
        DeleteProtrackSnagsByIdApiResponse,
        DeleteProtrackSnagsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/snags/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      postProtrackSnags: build.mutation<
        PostProtrackSnagsApiResponse,
        PostProtrackSnagsApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/snags`,
          method: "POST",
          body: queryArg.newProTrackSnag,
        }),
        invalidatesTags: ["ProTrackController"],
      }),
      getProtrackSnags: build.query<
        GetProtrackSnagsApiResponse,
        GetProtrackSnagsApiArg
      >({
        query: (queryArg) => ({
          url: `/protrack/snags`,
          params: { blockId: queryArg.blockId, status: queryArg.status },
        }),
        providesTags: ["ProTrackController"],
      }),
      patchPurchaseOrdersByIdUpdateCodes: build.mutation<
        PatchPurchaseOrdersByIdUpdateCodesApiResponse,
        PatchPurchaseOrdersByIdUpdateCodesApiArg
      >({
        query: (queryArg) => ({
          url: `/purchase-orders/${queryArg.id}/update-codes`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["PurchaseOrderController"],
      }),
      patchPurchaseOrdersById: build.mutation<
        PatchPurchaseOrdersByIdApiResponse,
        PatchPurchaseOrdersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/purchase-orders/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.purchaseOrderPartial,
        }),
        invalidatesTags: ["PurchaseOrderController"],
      }),
      getPurchaseOrdersById: build.query<
        GetPurchaseOrdersByIdApiResponse,
        GetPurchaseOrdersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/purchase-orders/${queryArg.id}` }),
        providesTags: ["PurchaseOrderController"],
      }),
      deletePurchaseOrdersById: build.mutation<
        DeletePurchaseOrdersByIdApiResponse,
        DeletePurchaseOrdersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/purchase-orders/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PurchaseOrderController"],
      }),
      getPurchaseOrders: build.query<
        GetPurchaseOrdersApiResponse,
        GetPurchaseOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/purchase-orders`,
          params: {
            amount: queryArg.amount,
            title: queryArg.title,
            supplierName: queryArg.supplierName,
            purchaseOrderNumber: queryArg.purchaseOrderNumber,
            reqNumber: queryArg.reqNumber,
            procurementProcessId: queryArg.procurementProcessId,
            development: queryArg.development,
            project: queryArg.project,
            itemCode: queryArg.itemCode,
            currency: queryArg.currency,
            status: queryArg.status,
            latestAction: queryArg.latestAction,
            limit: queryArg.limit,
            skip: queryArg.skip,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            backOrder: queryArg.backOrder,
            detailed: queryArg.detailed,
            reportByEmail: queryArg.reportByEmail,
            reportName: queryArg.reportName,
          },
        }),
        providesTags: ["PurchaseOrderController"],
      }),
      getQuotationsUploadProgressCount: build.query<
        GetQuotationsUploadProgressCountApiResponse,
        GetQuotationsUploadProgressCountApiArg
      >({
        query: (queryArg) => ({
          url: `/quotations-upload-progress/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["QuotationsUploadProgressController"],
      }),
      getQuotationsUploadProgressById: build.query<
        GetQuotationsUploadProgressByIdApiResponse,
        GetQuotationsUploadProgressByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/quotations-upload-progress/${queryArg.id}`,
        }),
        providesTags: ["QuotationsUploadProgressController"],
      }),
      deleteQuotationsUploadProgressById: build.mutation<
        DeleteQuotationsUploadProgressByIdApiResponse,
        DeleteQuotationsUploadProgressByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/quotations-upload-progress/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["QuotationsUploadProgressController"],
      }),
      postQuotationsUploadProgress: build.mutation<
        PostQuotationsUploadProgressApiResponse,
        PostQuotationsUploadProgressApiArg
      >({
        query: (queryArg) => ({
          url: `/quotations-upload-progress`,
          method: "POST",
          body: queryArg.newQuotationsUploadProgress,
        }),
        invalidatesTags: ["QuotationsUploadProgressController"],
      }),
      getQuotationsUploadProgress: build.query<
        GetQuotationsUploadProgressApiResponse,
        GetQuotationsUploadProgressApiArg
      >({
        query: (queryArg) => ({
          url: `/quotations-upload-progress`,
          params: { reqNumber: queryArg.reqNumber },
        }),
        providesTags: ["QuotationsUploadProgressController"],
      }),
      getReceiptsNextNumber: build.query<
        GetReceiptsNextNumberApiResponse,
        GetReceiptsNextNumberApiArg
      >({
        query: () => ({ url: `/receipts/next-number` }),
        providesTags: ["DebtorsController"],
      }),
      patchReceiptsById: build.mutation<
        PatchReceiptsByIdApiResponse,
        PatchReceiptsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/receipts/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      deleteReceiptsById: build.mutation<
        DeleteReceiptsByIdApiResponse,
        DeleteReceiptsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/receipts/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getReceipts: build.query<GetReceiptsApiResponse, GetReceiptsApiArg>({
        query: (queryArg) => ({
          url: `/receipts`,
          params: {
            developmentId: queryArg.developmentId,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
            receiptType: queryArg.receiptType,
            paymentType: queryArg.paymentType,
          },
        }),
        providesTags: ["DebtorsController"],
      }),
      getRequisitionById: build.query<
        GetRequisitionByIdApiResponse,
        GetRequisitionByIdApiArg
      >({
        query: (queryArg) => ({ url: `/requisition/${queryArg.id}` }),
        providesTags: ["ProcurementController"],
      }),
      getRequisitionReviewById: build.query<
        GetRequisitionReviewByIdApiResponse,
        GetRequisitionReviewByIdApiArg
      >({
        query: (queryArg) => ({ url: `/requisition-review/${queryArg.id}` }),
        providesTags: ["RequisitionReviewController"],
      }),
      getRequisitionReviews: build.query<
        GetRequisitionReviewsApiResponse,
        GetRequisitionReviewsApiArg
      >({
        query: () => ({ url: `/requisition-reviews` }),
        providesTags: ["RequisitionReviewController"],
      }),
      getRequisitionsNew: build.query<
        GetRequisitionsNewApiResponse,
        GetRequisitionsNewApiArg
      >({
        query: (queryArg) => ({
          url: `/requisitions/new`,
          params: { site: queryArg.site },
        }),
        providesTags: ["ProcurementController"],
      }),
      getRequisitions: build.query<
        GetRequisitionsApiResponse,
        GetRequisitionsApiArg
      >({
        query: () => ({ url: `/requisitions` }),
        providesTags: ["ProcurementController"],
      }),
      getSheqDashboard: build.query<
        GetSheqDashboardApiResponse,
        GetSheqDashboardApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/dashboard`,
          params: { blockId: queryArg.blockId },
        }),
        providesTags: ["SheqController"],
      }),
      patchSheqHealthRecordsById: build.mutation<
        PatchSheqHealthRecordsByIdApiResponse,
        PatchSheqHealthRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/health/records/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqHealthRecordsById: build.query<
        GetSheqHealthRecordsByIdApiResponse,
        GetSheqHealthRecordsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/sheq/health/records/${queryArg.id}` }),
        providesTags: ["SheqController"],
      }),
      deleteSheqHealthRecordsById: build.mutation<
        DeleteSheqHealthRecordsByIdApiResponse,
        DeleteSheqHealthRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/health/records/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqHealthRecords: build.mutation<
        PostSheqHealthRecordsApiResponse,
        PostSheqHealthRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/health/records`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqHealthRecords: build.query<
        GetSheqHealthRecordsApiResponse,
        GetSheqHealthRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/health/records`,
          params: {
            blockId: queryArg.blockId,
            workerId: queryArg.workerId,
            checkType: queryArg.checkType,
            fitStatus: queryArg.fitStatus,
            from: queryArg["from"],
            to: queryArg.to,
            followUpRequired: queryArg.followUpRequired,
          },
        }),
        providesTags: ["SheqController"],
      }),
      patchSheqIncidentsById: build.mutation<
        PatchSheqIncidentsByIdApiResponse,
        PatchSheqIncidentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/incidents/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqIncidentsById: build.query<
        GetSheqIncidentsByIdApiResponse,
        GetSheqIncidentsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/sheq/incidents/${queryArg.id}` }),
        providesTags: ["SheqController"],
      }),
      deleteSheqIncidentsById: build.mutation<
        DeleteSheqIncidentsByIdApiResponse,
        DeleteSheqIncidentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/incidents/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqIncidents: build.mutation<
        PostSheqIncidentsApiResponse,
        PostSheqIncidentsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/incidents`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqIncidents: build.query<
        GetSheqIncidentsApiResponse,
        GetSheqIncidentsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/incidents`,
          params: {
            blockId: queryArg.blockId,
            status: queryArg.status,
            type: queryArg["type"],
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SheqController"],
      }),
      patchSheqInspectionsById: build.mutation<
        PatchSheqInspectionsByIdApiResponse,
        PatchSheqInspectionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/inspections/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqInspectionsById: build.query<
        GetSheqInspectionsByIdApiResponse,
        GetSheqInspectionsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/sheq/inspections/${queryArg.id}` }),
        providesTags: ["SheqController"],
      }),
      deleteSheqInspectionsById: build.mutation<
        DeleteSheqInspectionsByIdApiResponse,
        DeleteSheqInspectionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/inspections/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqInspections: build.mutation<
        PostSheqInspectionsApiResponse,
        PostSheqInspectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/inspections`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqInspections: build.query<
        GetSheqInspectionsApiResponse,
        GetSheqInspectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/inspections`,
          params: {
            blockId: queryArg.blockId,
            type: queryArg["type"],
            outcome: queryArg.outcome,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SheqController"],
      }),
      patchSheqPpeCatalogueById: build.mutation<
        PatchSheqPpeCatalogueByIdApiResponse,
        PatchSheqPpeCatalogueByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/catalogue/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      deleteSheqPpeCatalogueById: build.mutation<
        DeleteSheqPpeCatalogueByIdApiResponse,
        DeleteSheqPpeCatalogueByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/catalogue/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqPpeCatalogue: build.mutation<
        PostSheqPpeCatalogueApiResponse,
        PostSheqPpeCatalogueApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/catalogue`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqPpeCatalogue: build.query<
        GetSheqPpeCatalogueApiResponse,
        GetSheqPpeCatalogueApiArg
      >({
        query: () => ({ url: `/sheq/ppe/catalogue` }),
        providesTags: ["SheqController"],
      }),
      postSheqPpeExpire: build.mutation<
        PostSheqPpeExpireApiResponse,
        PostSheqPpeExpireApiArg
      >({
        query: () => ({ url: `/sheq/ppe/expire`, method: "POST" }),
        invalidatesTags: ["SheqController"],
      }),
      patchSheqPpeRecordsByIdReturn: build.mutation<
        PatchSheqPpeRecordsByIdReturnApiResponse,
        PatchSheqPpeRecordsByIdReturnApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/records/${queryArg.id}/return`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      patchSheqPpeRecordsById: build.mutation<
        PatchSheqPpeRecordsByIdApiResponse,
        PatchSheqPpeRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/records/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqPpeRecordsById: build.query<
        GetSheqPpeRecordsByIdApiResponse,
        GetSheqPpeRecordsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/sheq/ppe/records/${queryArg.id}` }),
        providesTags: ["SheqController"],
      }),
      deleteSheqPpeRecordsById: build.mutation<
        DeleteSheqPpeRecordsByIdApiResponse,
        DeleteSheqPpeRecordsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/records/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqPpeRecords: build.mutation<
        PostSheqPpeRecordsApiResponse,
        PostSheqPpeRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/records`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqPpeRecords: build.query<
        GetSheqPpeRecordsApiResponse,
        GetSheqPpeRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/records`,
          params: {
            blockId: queryArg.blockId,
            status: queryArg.status,
            workerId: queryArg.workerId,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["SheqController"],
      }),
      getSheqPpeWorkerByWorkerIdHoldings: build.query<
        GetSheqPpeWorkerByWorkerIdHoldingsApiResponse,
        GetSheqPpeWorkerByWorkerIdHoldingsApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/ppe/worker/${queryArg.workerId}/holdings`,
        }),
        providesTags: ["SheqController"],
      }),
      getSheqReportsExpiring: build.query<
        GetSheqReportsExpiringApiResponse,
        GetSheqReportsExpiringApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/reports/expiring`,
          params: { days: queryArg.days, blockId: queryArg.blockId },
        }),
        providesTags: ["SheqController"],
      }),
      getSheqReportsIncidentsSummary: build.query<
        GetSheqReportsIncidentsSummaryApiResponse,
        GetSheqReportsIncidentsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/reports/incidents-summary`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            blockId: queryArg.blockId,
          },
        }),
        providesTags: ["SheqController"],
      }),
      patchSheqSopsById: build.mutation<
        PatchSheqSopsByIdApiResponse,
        PatchSheqSopsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/sops/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["SheqController"],
      }),
      getSheqSopsById: build.query<
        GetSheqSopsByIdApiResponse,
        GetSheqSopsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/sheq/sops/${queryArg.id}` }),
        providesTags: ["SheqController"],
      }),
      deleteSheqSopsById: build.mutation<
        DeleteSheqSopsByIdApiResponse,
        DeleteSheqSopsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/sheq/sops/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SheqController"],
      }),
      postSheqSops: build.mutation<PostSheqSopsApiResponse, PostSheqSopsApiArg>(
        {
          query: (queryArg) => ({
            url: `/sheq/sops`,
            method: "POST",
            body: queryArg.body,
          }),
          invalidatesTags: ["SheqController"],
        }
      ),
      getSheqSops: build.query<GetSheqSopsApiResponse, GetSheqSopsApiArg>({
        query: (queryArg) => ({
          url: `/sheq/sops`,
          params: {
            category: queryArg.category,
            status: queryArg.status,
            blockId: queryArg.blockId,
          },
        }),
        providesTags: ["SheqController"],
      }),
      postSpearReviewByIdApprove: build.mutation<
        PostSpearReviewByIdApproveApiResponse,
        PostSpearReviewByIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/spear-review/${queryArg.id}/approve`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      patchSpearReviewByIdGoalStatus: build.mutation<
        PatchSpearReviewByIdGoalStatusApiResponse,
        PatchSpearReviewByIdGoalStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/spear-review/${queryArg.id}/goal-status`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      patchSpearReviewByIdManagerEdit: build.mutation<
        PatchSpearReviewByIdManagerEditApiResponse,
        PatchSpearReviewByIdManagerEditApiArg
      >({
        query: (queryArg) => ({
          url: `/spear-review/${queryArg.id}/manager-edit`,
          method: "PATCH",
          body: queryArg.employeeReviewPartialExcludingIdUserIdReviewPeriodCreatedAt,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      postSpearReviewByIdReject: build.mutation<
        PostSpearReviewByIdRejectApiResponse,
        PostSpearReviewByIdRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/spear-review/${queryArg.id}/reject`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      postSpearReviewByIdSubmit: build.mutation<
        PostSpearReviewByIdSubmitApiResponse,
        PostSpearReviewByIdSubmitApiArg
      >({
        query: (queryArg) => ({
          url: `/spear-review/${queryArg.id}/submit`,
          method: "POST",
        }),
        invalidatesTags: ["EmployeeReviewController"],
      }),
      getSpearReviewsMyDirectReports: build.query<
        GetSpearReviewsMyDirectReportsApiResponse,
        GetSpearReviewsMyDirectReportsApiArg
      >({
        query: () => ({ url: `/spear-reviews/my-direct-reports` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getStakeholdersByTypeByType: build.query<
        GetStakeholdersByTypeByTypeApiResponse,
        GetStakeholdersByTypeByTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders/by-type/${queryArg["type"]}`,
        }),
        providesTags: ["StakeholderController"],
      }),
      getStakeholdersCount: build.query<
        GetStakeholdersCountApiResponse,
        GetStakeholdersCountApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["StakeholderController"],
      }),
      patchStakeholdersById: build.mutation<
        PatchStakeholdersByIdApiResponse,
        PatchStakeholdersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.stakeholderPartial,
        }),
        invalidatesTags: ["StakeholderController"],
      }),
      getStakeholdersById: build.query<
        GetStakeholdersByIdApiResponse,
        GetStakeholdersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/stakeholders/${queryArg.id}` }),
        providesTags: ["StakeholderController"],
      }),
      deleteStakeholdersById: build.mutation<
        DeleteStakeholdersByIdApiResponse,
        DeleteStakeholdersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["StakeholderController"],
      }),
      postStakeholders: build.mutation<
        PostStakeholdersApiResponse,
        PostStakeholdersApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders`,
          method: "POST",
          body: queryArg.newStakeholder,
        }),
        invalidatesTags: ["StakeholderController"],
      }),
      getStakeholders: build.query<
        GetStakeholdersApiResponse,
        GetStakeholdersApiArg
      >({
        query: (queryArg) => ({
          url: `/stakeholders`,
          params: {
            limit: queryArg.limit,
            skip: queryArg.skip,
            name: queryArg.name,
            type: queryArg["type"],
            supplierCode: queryArg.supplierCode,
            customerCode: queryArg.customerCode,
            tin: queryArg.tin,
            paymentTerms: queryArg.paymentTerms,
            rating: queryArg.rating,
            latestAction: queryArg.latestAction,
            isTaxClearanceValid: queryArg.isTaxClearanceValid,
            isStakeholderVerified: queryArg.isStakeholderVerified,
          },
        }),
        providesTags: ["StakeholderController"],
      }),
      postStatementsBulkSend: build.mutation<
        PostStatementsBulkSendApiResponse,
        PostStatementsBulkSendApiArg
      >({
        query: (queryArg) => ({
          url: `/statements/bulk-send`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["DebtorsController"],
      }),
      getStatementsLogs: build.query<
        GetStatementsLogsApiResponse,
        GetStatementsLogsApiArg
      >({
        query: (queryArg) => ({
          url: `/statements/logs`,
          params: { debtorId: queryArg.debtorId, limit: queryArg.limit },
        }),
        providesTags: ["DebtorsController"],
      }),
      putSupervisorsById: build.mutation<
        PutSupervisorsByIdApiResponse,
        PutSupervisorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/supervisors/${queryArg.id}`,
          method: "PUT",
          body: queryArg.supervisorPartial,
        }),
        invalidatesTags: ["SupervisorController"],
      }),
      patchSupervisorsById: build.mutation<
        PatchSupervisorsByIdApiResponse,
        PatchSupervisorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/supervisors/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.supervisorPartial,
        }),
        invalidatesTags: ["SupervisorController"],
      }),
      deleteSupervisorsById: build.mutation<
        DeleteSupervisorsByIdApiResponse,
        DeleteSupervisorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/supervisors/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SupervisorController"],
      }),
      postSupervisors: build.mutation<
        PostSupervisorsApiResponse,
        PostSupervisorsApiArg
      >({
        query: (queryArg) => ({
          url: `/supervisors`,
          method: "POST",
          body: queryArg.supervisorData,
        }),
        invalidatesTags: ["SupervisorController"],
      }),
      getSupervisors: build.query<
        GetSupervisorsApiResponse,
        GetSupervisorsApiArg
      >({
        query: (queryArg) => ({
          url: `/supervisors`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["SupervisorController"],
      }),
      postUnit: build.mutation<PostUnitApiResponse, PostUnitApiArg>({
        query: (queryArg) => ({
          url: `/unit`,
          method: "POST",
          body: queryArg.unitData,
        }),
        invalidatesTags: ["UnitController"],
      }),
      getUnitsByProjectByProjectId: build.query<
        GetUnitsByProjectByProjectIdApiResponse,
        GetUnitsByProjectByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/units/by-project/${queryArg.projectId}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["UnitController"],
      }),
      getUnitsCount: build.query<GetUnitsCountApiResponse, GetUnitsCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/units/count`,
            params: { where: queryArg.where },
          }),
          providesTags: ["UnitController"],
        }
      ),
      putUnitsById: build.mutation<PutUnitsByIdApiResponse, PutUnitsByIdApiArg>(
        {
          query: (queryArg) => ({
            url: `/units/${queryArg.id}`,
            method: "PUT",
            body: queryArg.unit,
          }),
          invalidatesTags: ["UnitController"],
        }
      ),
      patchUnitsById: build.mutation<
        PatchUnitsByIdApiResponse,
        PatchUnitsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/units/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.unitPartial,
        }),
        invalidatesTags: ["UnitController"],
      }),
      getUnitsById: build.query<GetUnitsByIdApiResponse, GetUnitsByIdApiArg>({
        query: (queryArg) => ({
          url: `/units/${queryArg.id}`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["UnitController"],
      }),
      deleteUnitsById: build.mutation<
        DeleteUnitsByIdApiResponse,
        DeleteUnitsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/units/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["UnitController"],
      }),
      patchUnits: build.mutation<PatchUnitsApiResponse, PatchUnitsApiArg>({
        query: (queryArg) => ({
          url: `/units`,
          method: "PATCH",
          body: queryArg.unitPartial,
          params: { where: queryArg.where },
        }),
        invalidatesTags: ["UnitController"],
      }),
      getUnits: build.query<GetUnitsApiResponse, GetUnitsApiArg>({
        query: (queryArg) => ({
          url: `/units`,
          params: {
            developmentId: queryArg.developmentId,
            projectId: queryArg.projectId,
            unitName: queryArg.unitName,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["UnitController"],
      }),
      patchUserById: build.mutation<
        PatchUserByIdApiResponse,
        PatchUserByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/user/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      getUserById: build.query<GetUserByIdApiResponse, GetUserByIdApiArg>({
        query: (queryArg) => ({ url: `/user/${queryArg.id}` }),
        providesTags: ["UserController"],
      }),
      deleteUserById: build.mutation<
        DeleteUserByIdApiResponse,
        DeleteUserByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/user/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsersAdminCreate: build.mutation<
        PostUsersAdminCreateApiResponse,
        PostUsersAdminCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/users/admin-create`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsersAdminResetPasswordById: build.mutation<
        PostUsersAdminResetPasswordByIdApiResponse,
        PostUsersAdminResetPasswordByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/admin-reset-password/${queryArg.id}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      getUsersCount: build.query<GetUsersCountApiResponse, GetUsersCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/users/count`,
            params: { where: queryArg.where },
          }),
          providesTags: ["UserController"],
        }
      ),
      postUsersLogin: build.mutation<
        PostUsersLoginApiResponse,
        PostUsersLoginApiArg
      >({
        query: (queryArg) => ({
          url: `/users/login`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsersLogout: build.mutation<
        PostUsersLogoutApiResponse,
        PostUsersLogoutApiArg
      >({
        query: () => ({ url: `/users/logout`, method: "POST" }),
        invalidatesTags: ["UserController"],
      }),
      getUsersMe: build.query<GetUsersMeApiResponse, GetUsersMeApiArg>({
        query: () => ({ url: `/users/me` }),
        providesTags: ["UserController"],
      }),
      postUsersRefreshToken: build.mutation<
        PostUsersRefreshTokenApiResponse,
        PostUsersRefreshTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/users/refresh-token`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsersResetPassword: build.mutation<
        PostUsersResetPasswordApiResponse,
        PostUsersResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/users/reset-password`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsers: build.mutation<PostUsersApiResponse, PostUsersApiArg>({
        query: (queryArg) => ({
          url: `/users`,
          method: "POST",
          body: queryArg.userWithPassword,
        }),
        invalidatesTags: ["UserController"],
      }),
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: () => ({ url: `/users` }),
        providesTags: ["UserController"],
      }),
      getUsersWithReviews: build.query<
        GetUsersWithReviewsApiResponse,
        GetUsersWithReviewsApiArg
      >({
        query: () => ({ url: `/users-with-reviews` }),
        providesTags: ["EmployeeReviewController"],
      }),
      getVatInvoicesCount: build.query<
        GetVatInvoicesCountApiResponse,
        GetVatInvoicesCountApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-invoices/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["TransactionsController"],
      }),
      patchVatInvoicesById: build.mutation<
        PatchVatInvoicesByIdApiResponse,
        PatchVatInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-invoices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.vatInvoicePartial,
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      getVatInvoicesById: build.query<
        GetVatInvoicesByIdApiResponse,
        GetVatInvoicesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/vat-invoices/${queryArg.id}` }),
        providesTags: ["TransactionsController"],
      }),
      deleteVatInvoicesById: build.mutation<
        DeleteVatInvoicesByIdApiResponse,
        DeleteVatInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-invoices/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      postVatInvoices: build.mutation<
        PostVatInvoicesApiResponse,
        PostVatInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-invoices`,
          method: "POST",
          body: queryArg.newVatInvoice,
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      getVatInvoices: build.query<
        GetVatInvoicesApiResponse,
        GetVatInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-invoices`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      getVatPaymentsCount: build.query<
        GetVatPaymentsCountApiResponse,
        GetVatPaymentsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-payments/count`,
          params: { where: queryArg.where },
        }),
        providesTags: ["TransactionsController"],
      }),
      patchVatPaymentsById: build.mutation<
        PatchVatPaymentsByIdApiResponse,
        PatchVatPaymentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-payments/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.vatPaymentPartial,
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      getVatPaymentsById: build.query<
        GetVatPaymentsByIdApiResponse,
        GetVatPaymentsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/vat-payments/${queryArg.id}` }),
        providesTags: ["TransactionsController"],
      }),
      deleteVatPaymentsById: build.mutation<
        DeleteVatPaymentsByIdApiResponse,
        DeleteVatPaymentsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-payments/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      postVatPayments: build.mutation<
        PostVatPaymentsApiResponse,
        PostVatPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-payments`,
          method: "POST",
          body: queryArg.newVatPayment,
        }),
        invalidatesTags: ["TransactionsController"],
      }),
      getVatPayments: build.query<
        GetVatPaymentsApiResponse,
        GetVatPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-payments`,
          params: { filter: queryArg.filter },
        }),
        providesTags: ["TransactionsController"],
      }),
      getVatReturnByVatPeriod: build.query<
        GetVatReturnByVatPeriodApiResponse,
        GetVatReturnByVatPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-return/${queryArg.vatPeriod}`,
          params: { developmentId: queryArg.developmentId },
        }),
        providesTags: ["VatController"],
      }),
      getVatStatementsClients: build.query<
        GetVatStatementsClientsApiResponse,
        GetVatStatementsClientsApiArg
      >({
        query: () => ({ url: `/vat-statements/clients` }),
        providesTags: ["DebtorsController"],
      }),
      getVatTransactionsByPeriodByVatPeriod: build.query<
        GetVatTransactionsByPeriodByVatPeriodApiResponse,
        GetVatTransactionsByPeriodByVatPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-transactions/by-period/${queryArg.vatPeriod}`,
          params: { developmentId: queryArg.developmentId },
        }),
        providesTags: ["VatController"],
      }),
      getVatTransactionsPeriods: build.query<
        GetVatTransactionsPeriodsApiResponse,
        GetVatTransactionsPeriodsApiArg
      >({
        query: () => ({ url: `/vat-transactions/periods` }),
        providesTags: ["VatController"],
      }),
      postVatTransactions: build.mutation<
        PostVatTransactionsApiResponse,
        PostVatTransactionsApiArg
      >({
        query: (queryArg) => ({
          url: `/vat-transactions`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["VatController"],
      }),
      getVirtualWarehouseSummary: build.query<
        GetVirtualWarehouseSummaryApiResponse,
        GetVirtualWarehouseSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/virtual-warehouse/summary`,
          params: {
            contractId: queryArg.contractId,
            contractItemId: queryArg.contractItemId,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            currency: queryArg.currency,
          },
        }),
        providesTags: ["VirtualWarehouseController"],
      }),
      getWhoAmI: build.query<GetWhoAmIApiResponse, GetWhoAmIApiArg>({
        query: () => ({ url: `/whoAmI` }),
        providesTags: ["UserController"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as vmsApi };
export type Get360ReviewsByUserByUserIdApiResponse =
  /** status 200 Array of 360 Reviews for a specific User */ FeedbackSurveyWithRelations[];
export type Get360ReviewsByUserByUserIdApiArg = {
  userId: string;
};
export type GetInventoryLocationsCountApiResponse =
  /** status 200 InventoryLocation model count */ LoopbackCount;
export type GetInventoryLocationsCountApiArg = {
  where?: any;
};
export type GetInventoryLocationsByIdApiResponse =
  /** status 200 InventoryLocation model instance */ InventoryLocationWithRelations;
export type GetInventoryLocationsByIdApiArg = {
  id: string;
};
export type DeleteInventoryLocationsByIdApiResponse = unknown;
export type DeleteInventoryLocationsByIdApiArg = {
  id: string;
};
export type PostInventoryLocationsApiResponse =
  /** status 200 InventoryLocation model instance */ InventoryLocation;
export type PostInventoryLocationsApiArg = {
  newInventoryLocation: NewInventoryLocation;
};
export type GetInventoryLocationsApiResponse =
  /** status 200 Array of InventoryLocation model instances with related Development data */ InventoryLocationWithRelations[];
export type GetInventoryLocationsApiArg = {
  filter?: any;
};
export type GetAccessApplicationsCountApiResponse =
  /** status 200 AccessApplication model count */ LoopbackCount;
export type GetAccessApplicationsCountApiArg = {
  where?: any;
};
export type PutAccessApplicationsByIdApiResponse = unknown;
export type PutAccessApplicationsByIdApiArg = {
  id: string;
  updateAccessApplication: UpdateAccessApplication;
};
export type GetAccessApplicationsByIdApiResponse =
  /** status 200 AccessApplication model instance */ AccessApplicationWithRelations;
export type GetAccessApplicationsByIdApiArg = {
  id: string;
};
export type DeleteAccessApplicationsByIdApiResponse = unknown;
export type DeleteAccessApplicationsByIdApiArg = {
  id: string;
};
export type PostAccessApplicationsApiResponse =
  /** status 200 AccessApplication model instance */ AccessApplication;
export type PostAccessApplicationsApiArg = {
  newAccessApplication: NewAccessApplication;
};
export type GetAccessApplicationsApiResponse =
  /** status 200 Array of AccessApplication model instances with related User and Development data */ AccessApplicationWithRelations[];
export type GetAccessApplicationsApiArg = {
  filter?: any;
};
export type GetAccessLogsCountApiResponse =
  /** status 200 AccessLog model count */ LoopbackCount;
export type GetAccessLogsCountApiArg = {
  where?: any;
};
export type GetAccessLogsByIdApiResponse =
  /** status 200 AccessLog model instance */ AccessLogWithRelations;
export type GetAccessLogsByIdApiArg = {
  id: string;
};
export type DeleteAccessLogsByIdApiResponse = unknown;
export type DeleteAccessLogsByIdApiArg = {
  id: string;
};
export type PostAccessLogsApiResponse =
  /** status 200 AccessLog model instance */ AccessLog;
export type PostAccessLogsApiArg = {
  newAccessLog: NewAccessLog;
};
export type GetAccessLogsApiResponse =
  /** status 200 Array of AccessLog model instances */ AccessLogWithRelations[];
export type GetAccessLogsApiArg = {
  filter?: any;
};
export type PostAddEmployeeReviewApiResponse =
  /** status 200 Employee Review */ EmployeeReview;
export type PostAddEmployeeReviewApiArg = {
  employeeReviewData: EmployeeReviewData;
};
export type PostAddInviteApiResponse = /** status 200 Invite */ Invite;
export type PostAddInviteApiArg = {
  inviteData: InviteData;
};
export type PostAddLifeWheelApiResponse =
  /** status 200 Life Wheel */ LifeWheel;
export type PostAddLifeWheelApiArg = {
  lifeWheelData: LifeWheelData;
};
export type PostAgreementsClientCreateApiResponse =
  /** status 200 create agreement */ Agreement;
export type PostAgreementsClientCreateApiArg = {
  agreementData: AgreementData;
};
export type PostAgreementsEmploymentCreateApiResponse =
  /** status 200 create employment contracts */ {
    message?: string;
    zipUrl?: string;
  };
export type PostAgreementsEmploymentCreateApiArg = {
  /** Link to the Excel file containing contract data */
  body: {
    excelFile?: string;
  };
};
export type GetAllLifeWheelsApiResponse =
  /** status 200 Array of all Life Wheels (admin/CEO/c-suite only) */ LifeWheelWithRelations[];
export type GetAllLifeWheelsApiArg = void;
export type GetAllSpearReviewsApiResponse =
  /** status 200 Array of all SPEAR reviews (admin/CEO/c-suite only) */ EmployeeReviewWithRelations[];
export type GetAllSpearReviewsApiArg = void;
export type PostAmortisationGenerateByDebtorIdApiResponse =
  /** status 200 OK */ any;
export type PostAmortisationGenerateByDebtorIdApiArg = {
  debtorId: string;
  body: {
    principal?: number;
    monthlyInstalment?: number;
    startDate?: string;
    monthlyRate?: number;
  };
};
export type GetAmortisationSummaryByDebtorIdApiResponse =
  /** status 200 OK */ any;
export type GetAmortisationSummaryByDebtorIdApiArg = {
  debtorId: string;
};
export type PatchAmortisationByScheduleIdMarkPaidApiResponse =
  /** status 200 OK */ any;
export type PatchAmortisationByScheduleIdMarkPaidApiArg = {
  scheduleId: string;
  body: {
    receiptId?: string;
    receiptNo?: string;
    amountPaid?: number;
  };
};
export type GetAmortisationByDebtorIdApiResponse = /** status 200 OK */ any;
export type GetAmortisationByDebtorIdApiArg = {
  debtorId: string;
};
export type DeleteAmortisationByDebtorIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteAmortisationByDebtorIdApiArg = {
  debtorId: string;
};
export type GetBalancedScorecardsByPeriodByPeriodApiResponse =
  /** status 200 BSC submissions for a specific period */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsByPeriodByPeriodApiArg = {
  period: string;
};
export type GetBalancedScorecardsByUserByUserIdApiResponse =
  /** status 200 Array of BSC submissions for a specific user */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsByUserByUserIdApiArg = {
  userId: string;
};
export type GetBalancedScorecardsCountApiResponse =
  /** status 200 BalancedScorecard model count */ LoopbackCount;
export type GetBalancedScorecardsCountApiArg = {
  where?: any;
};
export type GetBalancedScorecardsMySubmissionsApiResponse =
  /** status 200 Array of current user BSC submissions */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsMySubmissionsApiArg = void;
export type GetBalancedScorecardsOrgChartByJobDescriptionIdReportsApiResponse =
  /** status 200 Direct reports with BSC scores for a specific job description */ {
    parent?: object;
    directReports?: object[];
  };
export type GetBalancedScorecardsOrgChartByJobDescriptionIdReportsApiArg = {
  jobDescriptionId: string;
  period?: string;
};
export type GetBalancedScorecardsOrgChartApiResponse =
  /** status 200 Org chart with BSC scores for each position */ {
    jobDescription?: object;
    employee?: object;
    latestBSC?: object;
    directReportsCount?: number;
    hasDirectReports?: boolean;
  }[];
export type GetBalancedScorecardsOrgChartApiArg = {
  period?: string;
};
export type GetBalancedScorecardsPendingReviewApiResponse =
  /** status 200 BSC submissions pending review from direct reports */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsPendingReviewApiArg = void;
export type GetBalancedScorecardsTeamSubmissionsApiResponse =
  /** status 200 All BSC submissions from direct reports (all statuses) */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsTeamSubmissionsApiArg = void;
export type PatchBalancedScorecardsByIdApproveApiResponse =
  /** status 200 Approve BSC submission */ BalancedScorecard;
export type PatchBalancedScorecardsByIdApproveApiArg = {
  id: string;
  body: {
    managerComments?: string;
  };
};
export type PatchBalancedScorecardsByIdRejectApiResponse =
  /** status 200 Reject BSC submission */ BalancedScorecard;
export type PatchBalancedScorecardsByIdRejectApiArg = {
  id: string;
  body: {
    managerComments: string;
  };
};
export type PatchBalancedScorecardsByIdRevertToDraftApiResponse =
  /** status 200 Revert BSC submission back to draft (only if not yet approved) */ BalancedScorecard;
export type PatchBalancedScorecardsByIdRevertToDraftApiArg = {
  id: string;
};
export type PatchBalancedScorecardsByIdSubmitApiResponse =
  /** status 200 Submit BSC for manager review */ BalancedScorecard;
export type PatchBalancedScorecardsByIdSubmitApiArg = {
  id: string;
};
export type PatchBalancedScorecardsByIdApiResponse =
  /** status 204 No Content */ any;
export type PatchBalancedScorecardsByIdApiArg = {
  id: string;
  balancedScorecardPartial: BalancedScorecardPartial;
};
export type GetBalancedScorecardsByIdApiResponse =
  /** status 200 BalancedScorecard model instance */ BalancedScorecardWithRelations;
export type GetBalancedScorecardsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteBalancedScorecardsByIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteBalancedScorecardsByIdApiArg = {
  id: string;
};
export type PostBalancedScorecardsApiResponse =
  /** status 200 BalancedScorecard model instance */ BalancedScorecard;
export type PostBalancedScorecardsApiArg = {
  newBalancedScorecard: NewBalancedScorecard;
};
export type GetBalancedScorecardsApiResponse =
  /** status 200 Array of BalancedScorecard model instances */ BalancedScorecardWithRelations[];
export type GetBalancedScorecardsApiArg = {
  filter?: any;
};
export type GetBomByDevelopmentByDevelopmentIdApiResponse =
  /** status 200 Array of BillOfMaterial model instances filtered by developmentId */ BillOfMaterialWithRelations[];
export type GetBomByDevelopmentByDevelopmentIdApiArg = {
  developmentId: string;
};
export type GetBomByProjectByProjectIdApiResponse =
  /** status 200 Array of BillOfMaterial model instances filtered by projectId */ BillOfMaterialWithRelations[];
export type GetBomByProjectByProjectIdApiArg = {
  projectId: string;
};
export type GetBomCountApiResponse =
  /** status 200 BillOfMaterial model count */ LoopbackCount;
export type GetBomCountApiArg = {
  where?: any;
};
export type PostBomExternalItemMappingUploadApiResponse =
  /** status 200 Upload External BOM Excel and insert new mappings */ {
    inserted?: number;
    skipped?: number;
    total?: number;
  };
export type PostBomExternalItemMappingUploadApiArg = {
  body: object;
};
export type PatchBomByIdApiResponse = unknown;
export type PatchBomByIdApiArg = {
  id: string;
  billOfMaterialPartial: BillOfMaterialPartial;
};
export type GetBomByIdApiResponse =
  /** status 200 BillOfMaterial model instance */ BillOfMaterialWithRelations;
export type GetBomByIdApiArg = {
  id: string;
};
export type DeleteBomByIdApiResponse = unknown;
export type DeleteBomByIdApiArg = {
  id: string;
};
export type PostBomApiResponse =
  /** status 200 BillOfMaterial model instance */ BillOfMaterial;
export type PostBomApiArg = {
  newBillOfMaterial: NewBillOfMaterial;
};
export type GetBomApiResponse =
  /** status 200 Array of BillOfMaterial model instances */ BillOfMaterialWithRelations[];
export type GetBomApiArg = {
  filter?: any;
};
export type GetBomItemAuditTrailsByBomItemByBomItemIdApiResponse =
  /** status 200 Bom item audit trails by bomItemId */ BomItemAuditTrailWithRelations[];
export type GetBomItemAuditTrailsByBomItemByBomItemIdApiArg = {
  bomItemId: string;
  limit?: number;
  skip?: number;
};
export type PatchBomItemAuditTrailsByIdFirstApprovalApiResponse = unknown;
export type PatchBomItemAuditTrailsByIdFirstApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PatchBomItemAuditTrailsByIdSecondApprovalApiResponse = unknown;
export type PatchBomItemAuditTrailsByIdSecondApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PostBomItemAuditTrailsApiResponse =
  /** status 200 BomItemAuditTrail model instance */ BomItemAuditTrail;
export type PostBomItemAuditTrailsApiArg = {
  newBomItemAuditTrail: NewBomItemAuditTrail;
};
export type GetBomItemsByBomByBomIdApiResponse =
  /** status 200 Array of BomItem model instances filtered by bomId */ BomItemWithRelations[];
export type GetBomItemsByBomByBomIdApiArg = {
  bomId: string;
  projectId?: string;
  developmentId?: string;
  bomName?: string;
  projectName?: string;
  developmentName?: string;
  itemCode?: string;
  isService?: boolean;
  isVat?: boolean;
  itemDescription?: string;
  itemUnit?: string;
  itemBudgetedCost?: number;
  itemQuantity?: number;
  itemCurrentValue?: number;
  initialQuantity?: number;
  itemInitialValue?: number;
  limit?: number;
  skip?: number;
};
export type GetBomItemsByProjectByProjectIdApiResponse =
  /** status 200 Array of BomItem model instances filtered by projectId */ BomItemWithRelations[];
export type GetBomItemsByProjectByProjectIdApiArg = {
  projectId: string;
  limit?: number;
  skip?: number;
};
export type GetBomItemsCountApiResponse =
  /** status 200 BomItem model count */ LoopbackCount;
export type GetBomItemsCountApiArg = {
  where?: any;
};
export type PatchBomItemsByIdFirstApprovalApiResponse = unknown;
export type PatchBomItemsByIdFirstApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PatchBomItemsByIdSecondApprovalApiResponse = unknown;
export type PatchBomItemsByIdSecondApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PutBomItemsByIdApiResponse = unknown;
export type PutBomItemsByIdApiArg = {
  id: string;
  body: object;
};
export type PatchBomItemsByIdApiResponse = unknown;
export type PatchBomItemsByIdApiArg = {
  id: string;
  body: {
    [key: string]: any;
  };
};
export type GetBomItemsByIdApiResponse =
  /** status 200 BomItem model instance */ BomItemWithRelations;
export type GetBomItemsByIdApiArg = {
  id: string;
};
export type DeleteBomItemsByIdApiResponse = unknown;
export type DeleteBomItemsByIdApiArg = {
  id: string;
};
export type PostBomItemsApiResponse =
  /** status 200 BomItem model instance */ BomItem;
export type PostBomItemsApiArg = {
  newBomItem: NewBomItem;
};
export type GetBomItemsApiResponse =
  /** status 200 Array of BomItem model instances */ BomItemWithRelations[];
export type GetBomItemsApiArg = {
  filter?: any;
};
export type GetBusinessUnitsActiveApiResponse =
  /** status 200 Array of active BusinessUnit model instances */ BusinessUnitWithRelations[];
export type GetBusinessUnitsActiveApiArg = void;
export type GetBusinessUnitsCountApiResponse =
  /** status 200 BusinessUnit model count */ LoopbackCount;
export type GetBusinessUnitsCountApiArg = {
  where?: any;
};
export type PostBusinessUnitsSeedDefaultsApiResponse =
  /** status 200 Seed default business units */ {
    created?: number;
    skipped?: number;
  };
export type PostBusinessUnitsSeedDefaultsApiArg = void;
export type PatchBusinessUnitsByIdApiResponse =
  /** status 204 No Content */ any;
export type PatchBusinessUnitsByIdApiArg = {
  id: string;
  businessUnitPartial: BusinessUnitPartial;
};
export type GetBusinessUnitsByIdApiResponse =
  /** status 200 BusinessUnit model instance */ BusinessUnitWithRelations;
export type GetBusinessUnitsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteBusinessUnitsByIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteBusinessUnitsByIdApiArg = {
  id: string;
};
export type PostBusinessUnitsApiResponse =
  /** status 200 BusinessUnit model instance */ BusinessUnit;
export type PostBusinessUnitsApiArg = {
  newBusinessUnit: NewBusinessUnit;
};
export type GetBusinessUnitsApiResponse =
  /** status 200 Array of BusinessUnit model instances */ BusinessUnitWithRelations[];
export type GetBusinessUnitsApiArg = {
  filter?: any;
};
export type GetCashbookAccountBalancesApiResponse = /** status 200 OK */ any;
export type GetCashbookAccountBalancesApiArg = {
  asAtDate?: string;
};
export type PostCashbookApiResponse = /** status 200 OK */ any;
export type PostCashbookApiArg = {
  body: object;
};
export type GetCashbookApiResponse = /** status 200 OK */ any;
export type GetCashbookApiArg = {
  account?: string;
  fromDate?: string;
  toDate?: string;
  developmentId?: string;
};
export type GetCashflowForecastApiResponse = /** status 200 OK */ any;
export type GetCashflowForecastApiArg = {
  monthsAhead?: number;
  developmentId?: string;
};
export type GetCashflowVarianceApiResponse = /** status 200 OK */ any;
export type GetCashflowVarianceApiArg = {
  month?: string;
};
export type GetCashflowVarianceHistoryApiResponse = /** status 200 OK */ any;
export type GetCashflowVarianceHistoryApiArg = {
  months?: number;
};
export type GetCastingToolPeriodByReviewPeriodApiResponse =
  /** status 200 CastingTool model instance for period */ CastingTool;
export type GetCastingToolPeriodByReviewPeriodApiArg = {
  reviewPeriod: string;
};
export type PatchCastingToolByIdApiResponse =
  /** status 200 CastingTool PATCH success */ CastingTool;
export type PatchCastingToolByIdApiArg = {
  id: string;
  castingToolPartialExcludingIdUserIdCreatedAt: CastingToolPartialExcludingIdUserIdCreatedAt;
};
export type GetCastingToolByIdApiResponse =
  /** status 200 CastingTool model instance */ CastingTool;
export type GetCastingToolByIdApiArg = {
  id: string;
};
export type PostCastingToolApiResponse =
  /** status 200 CastingTool model instance */ CastingTool;
export type PostCastingToolApiArg = {
  newCastingTool: NewCastingTool;
};
export type GetCastingToolsAllApiResponse =
  /** status 200 Array of all CastingTool instances with user info */ CastingTool[];
export type GetCastingToolsAllApiArg = {
  reviewPeriod?: string;
};
export type GetCastingToolsDepartmentByDepartmentApiResponse =
  /** status 200 Department employees with casting tool status */ object[];
export type GetCastingToolsDepartmentByDepartmentApiArg = {
  department: string;
  reviewPeriod?: string;
};
export type GetCastingToolsDepartmentStatsApiResponse =
  /** status 200 Department completion statistics */ {
    department?: string;
    totalEmployees?: number;
    completedThisMonth?: number;
    completionRate?: number;
    reviewPeriod?: string;
  }[];
export type GetCastingToolsDepartmentStatsApiArg = {
  reviewPeriod?: string;
};
export type GetCastingToolsMyApiResponse =
  /** status 200 Array of my CastingTool instances */ CastingTool[];
export type GetCastingToolsMyApiArg = void;
export type GetCastingToolsByUserByUserIdApiResponse =
  /** status 200 Array of CastingTool instances for a user */ CastingTool[];
export type GetCastingToolsByUserByUserIdApiArg = {
  userId: string;
};
export type GetCeoDashboardBscPerspectivesApiResponse =
  /** status 200 OK */ any;
export type GetCeoDashboardBscPerspectivesApiArg = {
  period?: string;
};
export type GetCeoDashboardDepartmentsByDepartmentEmployeesApiResponse =
  /** status 200 OK */ any;
export type GetCeoDashboardDepartmentsByDepartmentEmployeesApiArg = {
  department: string;
  period?: string;
};
export type GetCeoDashboardDepartmentsByDepartmentApiResponse =
  /** status 200 OK */ any;
export type GetCeoDashboardDepartmentsByDepartmentApiArg = {
  department: string;
  period?: string;
};
export type GetCeoDashboardDepartmentsApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardDepartmentsApiArg = {
  period?: string;
};
export type GetCeoDashboardEmployeesByEmployeeIdApiResponse =
  /** status 200 OK */ any;
export type GetCeoDashboardEmployeesByEmployeeIdApiArg = {
  employeeId: string;
  period?: string;
};
export type GetCeoDashboardEmployeesApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardEmployeesApiArg = {
  period?: string;
};
export type GetCeoDashboardLifeWheelApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardLifeWheelApiArg = {
  period?: string;
};
export type GetCeoDashboardNeedsAttentionApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardNeedsAttentionApiArg = {
  period?: string;
};
export type GetCeoDashboardOrganizationApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardOrganizationApiArg = {
  period?: string;
};
export type GetCeoDashboardTopPerformersApiResponse = /** status 200 OK */ any;
export type GetCeoDashboardTopPerformersApiArg = {
  limit?: number;
  period?: string;
};
export type PostClientApiResponse = /** status 200 Create client */ Client;
export type PostClientApiArg = {
  clientData: ClientData;
};
export type GetClientsApiResponse =
  /** status 200 Array of Client model instances */ ClientWithRelations[];
export type GetClientsApiArg = {
  filter?: any;
};
export type GetCompetenciesActiveApiResponse =
  /** status 200 Array of active Competency model instances */ CompetencyWithRelations[];
export type GetCompetenciesActiveApiArg = void;
export type GetCompetenciesByCategoryByCategoryApiResponse =
  /** status 200 Competencies by category */ CompetencyWithRelations[];
export type GetCompetenciesByCategoryByCategoryApiArg = {
  category: string;
};
export type GetCompetenciesCountApiResponse =
  /** status 200 Competency model count */ LoopbackCount;
export type GetCompetenciesCountApiArg = {
  where?: any;
};
export type PostCompetenciesSeedDefaultsApiResponse =
  /** status 200 Seed default competencies */ {
    created?: number;
    skipped?: number;
  };
export type PostCompetenciesSeedDefaultsApiArg = void;
export type PatchCompetenciesByIdApiResponse = /** status 204 No Content */ any;
export type PatchCompetenciesByIdApiArg = {
  id: string;
  competencyPartial: CompetencyPartial;
};
export type GetCompetenciesByIdApiResponse =
  /** status 200 Competency model instance */ CompetencyWithRelations;
export type GetCompetenciesByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteCompetenciesByIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteCompetenciesByIdApiArg = {
  id: string;
};
export type PostCompetenciesApiResponse =
  /** status 200 Competency model instance */ Competency;
export type PostCompetenciesApiArg = {
  newCompetency: NewCompetency;
};
export type GetCompetenciesApiResponse =
  /** status 200 Array of Competency model instances */ CompetencyWithRelations[];
export type GetCompetenciesApiArg = {
  filter?: any;
};
export type PostComsBlocksByBlockIdBaselineActualsApiResponse =
  /** status 200 Baseline import result */ object;
export type PostComsBlocksByBlockIdBaselineActualsApiArg = {
  blockId: string;
  body: {
    overwrite?: boolean;
    items?: {
      sharedItemId?: string;
      itemCode?: string;
      billNumber?: number;
      description?: string;
      unit?: string;
      plannedQty?: number;
      openingActualQty?: number;
    }[];
  };
};
export type GetComsBlocksByBlockIdEvmOverviewApiResponse = unknown;
export type GetComsBlocksByBlockIdEvmOverviewApiArg = {
  blockId: string;
};
export type GetComsBlocksByBlockIdHasActualsApiResponse = unknown;
export type GetComsBlocksByBlockIdHasActualsApiArg = {
  blockId: string;
};
export type GetComsBlocksByIdStatsApiResponse = unknown;
export type GetComsBlocksByIdStatsApiArg = {
  id: string;
};
export type PostComsBlocksByBlockIdUploadAuditApiResponse = unknown;
export type PostComsBlocksByBlockIdUploadAuditApiArg = {
  blockId: string;
  body: {
    action?: string;
    diff?: object;
  };
};
export type GetComsBlocksByBlockIdUploadAuditApiResponse = unknown;
export type GetComsBlocksByBlockIdUploadAuditApiArg = {
  blockId: string;
};
export type PatchComsBlocksByIdApiResponse = unknown;
export type PatchComsBlocksByIdApiArg = {
  id: string;
  comsBlockPartial: ComsBlockPartial;
};
export type GetComsBlocksByIdApiResponse =
  /** status 200 ComsBlock */ ComsBlock;
export type GetComsBlocksByIdApiArg = {
  id: string;
};
export type DeleteComsBlocksByIdApiResponse = unknown;
export type DeleteComsBlocksByIdApiArg = {
  id: string;
};
export type PostComsBlocksApiResponse = /** status 200 ComsBlock */ ComsBlock;
export type PostComsBlocksApiArg = {
  newComsBlock: NewComsBlock;
};
export type GetComsBlocksApiResponse =
  /** status 200 Array of ComsBlock */ ComsBlock[];
export type GetComsBlocksApiArg = void;
export type PatchComsCatalogByIdApiResponse = unknown;
export type PatchComsCatalogByIdApiArg = {
  id: string;
  comsCatalogItemPartial: ComsCatalogItemPartial;
};
export type GetComsCatalogByIdApiResponse =
  /** status 200 ComsCatalogItem */ ComsCatalogItem;
export type GetComsCatalogByIdApiArg = {
  id: string;
};
export type DeleteComsCatalogByIdApiResponse = unknown;
export type DeleteComsCatalogByIdApiArg = {
  id: string;
};
export type PostComsCatalogApiResponse =
  /** status 200 ComsCatalogItem */ ComsCatalogItem;
export type PostComsCatalogApiArg = {
  newComsCatalogItem: NewComsCatalogItem;
};
export type GetComsCatalogApiResponse =
  /** status 200 Array of ComsCatalogItem */ ComsCatalogItem[];
export type GetComsCatalogApiArg = {
  blockId?: string;
  type?: string;
  catalogueType?: string;
};
export type DeleteComsMatDeliveriesByIdApiResponse = unknown;
export type DeleteComsMatDeliveriesByIdApiArg = {
  id: string;
};
export type PostComsMatDeliveriesApiResponse =
  /** status 200 ComsMatDelivery */ ComsMatDelivery;
export type PostComsMatDeliveriesApiArg = {
  newComsMatDelivery: NewComsMatDelivery;
};
export type GetComsMatDeliveriesApiResponse =
  /** status 200 Array of ComsMatDelivery */ ComsMatDelivery[];
export type GetComsMatDeliveriesApiArg = {
  blockId?: string;
  budgetItemId?: string;
};
export type PostComsMonthlyReportRecordsBackfillApiResponse = unknown;
export type PostComsMonthlyReportRecordsBackfillApiArg = {
  body: {
    blockId: string;
  };
};
export type PostComsMonthlyReportRecordsGenerateApiResponse = unknown;
export type PostComsMonthlyReportRecordsGenerateApiArg = {
  body: {
    blockId: string;
    monthStart: string;
    monthEnd: string;
    force?: boolean;
  };
};
export type PostComsMonthlyReportRecordsRegenerateForDateApiResponse = unknown;
export type PostComsMonthlyReportRecordsRegenerateForDateApiArg = {
  body: {
    blockId: string;
    date: string;
  };
};
export type PatchComsMonthlyReportRecordsByIdApiResponse = unknown;
export type PatchComsMonthlyReportRecordsByIdApiArg = {
  id: string;
  body: {
    reviewTrail?: any;
  };
};
export type GetComsMonthlyReportRecordsByIdApiResponse =
  /** status 200 ComsMonthlyReportRecord */ ComsMonthlyReportRecord;
export type GetComsMonthlyReportRecordsByIdApiArg = {
  id: string;
};
export type DeleteComsMonthlyReportRecordsByIdApiResponse = unknown;
export type DeleteComsMonthlyReportRecordsByIdApiArg = {
  id: string;
};
export type GetComsMonthlyReportRecordsApiResponse = unknown;
export type GetComsMonthlyReportRecordsApiArg = {
  blockId?: string;
};
export type GetComsReportsMonthlyApiResponse = unknown;
export type GetComsReportsMonthlyApiArg = {
  blockId?: string;
  from?: string;
  to?: string;
};
export type GetComsReportsWorkDoneApiResponse = unknown;
export type GetComsReportsWorkDoneApiArg = {
  blockId?: string;
};
export type PatchComsReportsByIdApiResponse = unknown;
export type PatchComsReportsByIdApiArg = {
  id: string;
  comsDailyReportPartial: ComsDailyReportPartial;
};
export type GetComsReportsByIdApiResponse =
  /** status 200 ComsDailyReport */ ComsDailyReport;
export type GetComsReportsByIdApiArg = {
  id: string;
};
export type DeleteComsReportsByIdApiResponse = unknown;
export type DeleteComsReportsByIdApiArg = {
  id: string;
};
export type PostComsReportsApiResponse =
  /** status 200 ComsDailyReport */ ComsDailyReport;
export type PostComsReportsApiArg = {
  newComsDailyReport: NewComsDailyReport;
};
export type GetComsReportsApiResponse =
  /** status 200 Array of ComsDailyReport */ ComsDailyReport[];
export type GetComsReportsApiArg = {
  blockId?: string;
};
export type PostComsWeeklyReportsBackfillApiResponse = unknown;
export type PostComsWeeklyReportsBackfillApiArg = {
  body: {
    blockId: string;
  };
};
export type PostComsWeeklyReportsGenerateApiResponse = unknown;
export type PostComsWeeklyReportsGenerateApiArg = {
  body: {
    blockId: string;
    weekStart: string;
    weekEnd: string;
    force?: boolean;
  };
};
export type PostComsWeeklyReportsRegenerateForDateApiResponse = unknown;
export type PostComsWeeklyReportsRegenerateForDateApiArg = {
  body: {
    blockId: string;
    date: string;
  };
};
export type PatchComsWeeklyReportsByIdApiResponse = unknown;
export type PatchComsWeeklyReportsByIdApiArg = {
  id: string;
  body: {
    reviewTrail?: any;
    status?: string;
    actions?: any;
  };
};
export type GetComsWeeklyReportsByIdApiResponse =
  /** status 200 ComsWeeklyReport */ ComsWeeklyReport;
export type GetComsWeeklyReportsByIdApiArg = {
  id: string;
};
export type DeleteComsWeeklyReportsByIdApiResponse = unknown;
export type DeleteComsWeeklyReportsByIdApiArg = {
  id: string;
};
export type GetComsWeeklyReportsApiResponse = unknown;
export type GetComsWeeklyReportsApiArg = {
  blockId?: string;
};
export type GetContractItemAuditTrailsByContractItemByContractItemIdApiResponse =
  /** status 200 Contract item audit trails by contractItemId */ ContractItemAuditTrailWithRelations[];
export type GetContractItemAuditTrailsByContractItemByContractItemIdApiArg = {
  contractItemId: string;
  limit?: number;
  skip?: number;
};
export type PatchContractItemAuditTrailsByIdFirstApprovalApiResponse = unknown;
export type PatchContractItemAuditTrailsByIdFirstApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PatchContractItemAuditTrailsByIdSecondApprovalApiResponse = unknown;
export type PatchContractItemAuditTrailsByIdSecondApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PostContractItemAuditTrailsApiResponse =
  /** status 200 ContractItemAuditTrail model instance */ ContractItemAuditTrail;
export type PostContractItemAuditTrailsApiArg = {
  newContractItemAuditTrail: NewContractItemAuditTrail;
};
export type GetContractItemsByContractByContractIdApiResponse =
  /** status 200 Array of ContractItem model instances filtered by contractId */ ContractItemWithRelations[];
export type GetContractItemsByContractByContractIdApiArg = {
  contractId: string;
  supplierId?: string;
  contractName?: string;
  supplierName?: string;
  itemCode?: string;
  isService?: boolean;
  isVat?: boolean;
  itemDescription?: string;
  itemUnit?: string;
  itemBudgetedCost?: number;
  itemQuantity?: number;
  itemCurrentValue?: number;
  initialQuantity?: number;
  itemInitialValue?: number;
  limit?: number;
  skip?: number;
};
export type GetContractItemsCountApiResponse =
  /** status 200 ContractItem model count */ LoopbackCount;
export type GetContractItemsCountApiArg = {
  where?: any;
};
export type PatchContractItemsByIdFirstApprovalApiResponse = unknown;
export type PatchContractItemsByIdFirstApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PatchContractItemsByIdSecondApprovalApiResponse = unknown;
export type PatchContractItemsByIdSecondApprovalApiArg = {
  id: string;
  body: {
    comment?: string;
  };
};
export type PutContractItemsByIdApiResponse = unknown;
export type PutContractItemsByIdApiArg = {
  id: string;
  body: object;
};
export type PatchContractItemsByIdApiResponse = unknown;
export type PatchContractItemsByIdApiArg = {
  id: string;
  body: {
    [key: string]: any;
  };
};
export type GetContractItemsByIdApiResponse =
  /** status 200 ContractItem model instance */ ContractItemWithRelations;
export type GetContractItemsByIdApiArg = {
  id: string;
};
export type DeleteContractItemsByIdApiResponse = unknown;
export type DeleteContractItemsByIdApiArg = {
  id: string;
};
export type PostContractItemsApiResponse =
  /** status 200 ContractItem model instance */ ContractItem;
export type PostContractItemsApiArg = {
  newContractItem: NewContractItem;
};
export type GetContractItemsApiResponse =
  /** status 200 Array of ContractItem model instances */ ContractItemWithRelations[];
export type GetContractItemsApiArg = {
  filter?: any;
};
export type PostCreateGrvApiResponse =
  /** status 200 GRV model instance */ NewGrv;
export type PostCreateGrvApiArg = {
  newGrv: NewGrv;
};
export type PostCreateProcurementProcessApiResponse =
  /** status 200 Procurement Process model instance */ NewProcurementProcess;
export type PostCreateProcurementProcessApiArg = {
  newProcurementProcess: NewProcurementProcess;
};
export type PostCreatePurchaseOrderApiResponse =
  /** status 200 Purchase Order model instance */ NewPurchaseOrder;
export type PostCreatePurchaseOrderApiArg = {
  newPurchaseOrder: NewPurchaseOrder;
};
export type PostCreateRequisitionApiResponse =
  /** status 200 Requisition */ Requisition;
export type PostCreateRequisitionApiArg = {
  requisitionData: RequisitionData;
};
export type PostCreateRequisitionReviewApiResponse =
  /** status 200 Requisition Review */ RequisitionReview;
export type PostCreateRequisitionReviewApiArg = {
  requisitionReviewData: RequisitionReviewData;
};
export type GetCreditorsAgeAnalysisReportPdfApiResponse = unknown;
export type GetCreditorsAgeAnalysisReportPdfApiArg = {
  developmentId?: string;
  asAtDate?: string;
};
export type GetCreditorsAgeAnalysisApiResponse = /** status 200 OK */ any;
export type GetCreditorsAgeAnalysisApiArg = {
  developmentId?: string;
  asAtDate?: string;
};
export type GetCreditorsCountApiResponse =
  /** status 200 Creditor model count */ LoopbackCount;
export type GetCreditorsCountApiArg = {
  where?: any;
};
export type GetCreditorsByIdFullApiResponse = /** status 200 OK */ any;
export type GetCreditorsByIdFullApiArg = {
  id: string;
};
export type PostCreditorsByIdInvoicesApiResponse = /** status 200 OK */ any;
export type PostCreditorsByIdInvoicesApiArg = {
  id: string;
  body: object;
};
export type GetCreditorsByIdInvoicesApiResponse = /** status 200 OK */ any;
export type GetCreditorsByIdInvoicesApiArg = {
  id: string;
};
export type PostCreditorsByIdPaymentsApiResponse = /** status 200 OK */ any;
export type PostCreditorsByIdPaymentsApiArg = {
  id: string;
  body: object;
};
export type GetCreditorsByIdPaymentsApiResponse = /** status 200 OK */ any;
export type GetCreditorsByIdPaymentsApiArg = {
  id: string;
};
export type PatchCreditorsByIdApiResponse = /** status 204 No Content */ any;
export type PatchCreditorsByIdApiArg = {
  id: string;
  creditorPartial: CreditorPartial;
};
export type GetCreditorsByIdApiResponse =
  /** status 200 Creditor model instance */ CreditorWithRelations;
export type GetCreditorsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteCreditorsByIdApiResponse = /** status 204 No Content */ any;
export type DeleteCreditorsByIdApiArg = {
  id: string;
};
export type PostCreditorsApiResponse =
  /** status 200 Creditor model instance */ Creditor;
export type PostCreditorsApiArg = {
  newCreditor: NewCreditor;
};
export type GetCreditorsApiResponse =
  /** status 200 Array of Creditor model instances */ CreditorWithRelations[];
export type GetCreditorsApiArg = {
  filter?: any;
};
export type GetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesApiResponse =
  unknown;
export type GetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesApiArg =
  {
    sourceId: string;
    dimensionId: string;
  };
export type GetDashboardDataSourcesByIdDimensionsApiResponse = unknown;
export type GetDashboardDataSourcesByIdDimensionsApiArg = {
  id: string;
};
export type GetDashboardDataSourcesByIdMetricsApiResponse = unknown;
export type GetDashboardDataSourcesByIdMetricsApiArg = {
  id: string;
};
export type GetDashboardDataSourcesApiResponse =
  /** status 200 Available data sources */ {
    id?: string;
    name?: string;
    description?: string;
    metrics?: any;
    dimensions?: any;
  }[];
export type GetDashboardDataSourcesApiArg = void;
export type GetDashboardLayoutsByIdApiResponse = unknown;
export type GetDashboardLayoutsByIdApiArg = {
  id: string;
};
export type GetDashboardLayoutsApiResponse =
  /** status 200 Array of layout templates */ object[];
export type GetDashboardLayoutsApiArg = void;
export type PostDashboardsByIdDataApiResponse = /** status 200 Widget data */ {
  widgets?: {
    [key: string]: any;
  };
  fetchedAt?: string;
};
export type PostDashboardsByIdDataApiArg = {
  id: string;
  body: {
    /** Optional: specific widget IDs to fetch data for */
    widgetIds?: string[];
    timeRange?: {
      start?: string;
      end?: string;
    };
  };
};
export type PostDashboardsByIdDrilldownApiResponse =
  /** status 200 Drill-down records */ {
    records?: object[];
    total?: number;
    columns?: object[];
  };
export type PostDashboardsByIdDrilldownApiArg = {
  id: string;
  body: {
    widgetId: string;
    drillDownValue?: string;
    timeRange?: {
      start?: string;
      end?: string;
    };
    limit?: number;
  };
};
export type PostDashboardsByIdPermissionsApiResponse =
  /** status 200 Updated permissions */ {
    roles?: string[];
    users?: string[];
  };
export type PostDashboardsByIdPermissionsApiArg = {
  id: string;
  body: {
    roles?: string[];
    users?: string[];
  };
};
export type PutDashboardsByIdApiResponse =
  /** status 200 Dashboard model instance */ Dashboard;
export type PutDashboardsByIdApiArg = {
  id: string;
  dashboardPartialExcludingIdCreatedAtCreatedBy: DashboardPartialExcludingIdCreatedAtCreatedBy;
};
export type GetDashboardsByIdApiResponse =
  /** status 200 Dashboard model instance */ Dashboard;
export type GetDashboardsByIdApiArg = {
  id: string;
};
export type DeleteDashboardsByIdApiResponse = unknown;
export type DeleteDashboardsByIdApiArg = {
  id: string;
};
export type PostDashboardsApiResponse =
  /** status 200 Dashboard model instance */ Dashboard;
export type PostDashboardsApiArg = {
  newDashboard: NewDashboard;
};
export type GetDashboardsApiResponse =
  /** status 200 Array of Dashboard model instances */ Dashboard[];
export type GetDashboardsApiArg = {
  publishedOnly?: boolean;
  includeOwn?: boolean;
};
export type PatchDebtorInvoicesByIdApiResponse =
  /** status 204 No Content */ any;
export type PatchDebtorInvoicesByIdApiArg = {
  id: string;
  body: object;
};
export type DeleteDebtorInvoicesByIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteDebtorInvoicesByIdApiArg = {
  id: string;
};
export type GetDebtorInvoicesApiResponse = /** status 200 OK */ any;
export type GetDebtorInvoicesApiArg = {
  developmentId?: string;
  status?: string;
  invoiceType?: string;
  startDate?: string;
  endDate?: string;
};
export type GetDebtorsAgeAnalysisReportPdfApiResponse = unknown;
export type GetDebtorsAgeAnalysisReportPdfApiArg = {
  developmentId?: string;
  asAtDate?: string;
  hideZeroBalance?: boolean;
};
export type GetDebtorsAgeAnalysisApiResponse = /** status 200 OK */ any;
export type GetDebtorsAgeAnalysisApiArg = {
  developmentId?: string;
  asAtDate?: string;
  hideZeroBalance?: boolean;
};
export type GetDebtorsAgingFromExcelApiResponse = /** status 200 OK */ any;
export type GetDebtorsAgingFromExcelApiArg = {
  excelPath?: string;
  asAtDate?: string;
};
export type PatchDebtorsBulkAgeApiResponse = /** status 200 OK */ any;
export type PatchDebtorsBulkAgeApiArg = {
  body: {
    debtorIds: string[];
    remarks?: string;
  };
};
export type GetDebtorsComprehensiveAgingApiResponse = /** status 200 OK */ any;
export type GetDebtorsComprehensiveAgingApiArg = {
  asAtDate?: string;
};
export type GetDebtorsCountApiResponse =
  /** status 200 Debtor model count */ LoopbackCount;
export type GetDebtorsCountApiArg = {
  where?: any;
};
export type GetDebtorsDebugAgedCountApiResponse = /** status 200 OK */ any;
export type GetDebtorsDebugAgedCountApiArg = void;
export type PatchDebtorsDebugClearAllAgedApiResponse = /** status 200 OK */ any;
export type PatchDebtorsDebugClearAllAgedApiArg = void;
export type GetDebtorsDebugClearAllAgedApiResponse = /** status 200 OK */ any;
export type GetDebtorsDebugClearAllAgedApiArg = void;
export type GetDebtorsByIdFullApiResponse = /** status 200 OK */ any;
export type GetDebtorsByIdFullApiArg = {
  id: string;
};
export type PostDebtorsByIdInvoicesApiResponse = /** status 200 OK */ any;
export type PostDebtorsByIdInvoicesApiArg = {
  id: string;
  body: object;
};
export type GetDebtorsByIdInvoicesApiResponse = /** status 200 OK */ any;
export type GetDebtorsByIdInvoicesApiArg = {
  id: string;
};
export type GetDebtorsByDebtorIdPaymentsApiResponse = unknown;
export type GetDebtorsByDebtorIdPaymentsApiArg = {
  debtorId: string;
  filter?: any;
};
export type PostDebtorsByIdReceiptsApiResponse = /** status 200 OK */ any;
export type PostDebtorsByIdReceiptsApiArg = {
  id: string;
  body: object;
};
export type GetDebtorsByIdReceiptsApiResponse = /** status 200 OK */ any;
export type GetDebtorsByIdReceiptsApiArg = {
  id: string;
};
export type PostDebtorsByIdStatementEmailApiResponse = /** status 200 OK */ any;
export type PostDebtorsByIdStatementEmailApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDebtorsByIdStatementPdfApiResponse = unknown;
export type GetDebtorsByIdStatementPdfApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDebtorsByIdStatementApiResponse = /** status 200 OK */ any;
export type GetDebtorsByIdStatementApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDebtorsByDebtorIdTransactionsAllApiResponse = unknown;
export type GetDebtorsByDebtorIdTransactionsAllApiArg = {
  debtorId: string;
};
export type GetDebtorsByDebtorIdTransactionsSummaryApiResponse = unknown;
export type GetDebtorsByDebtorIdTransactionsSummaryApiArg = {
  debtorId: string;
};
export type GetDebtorsByDebtorIdVatInvoicesApiResponse = unknown;
export type GetDebtorsByDebtorIdVatInvoicesApiArg = {
  debtorId: string;
  filter?: any;
};
export type GetDebtorsByDebtorIdVatPaymentsApiResponse = unknown;
export type GetDebtorsByDebtorIdVatPaymentsApiArg = {
  debtorId: string;
  filter?: any;
};
export type PostDebtorsByIdVatStatementEmailApiResponse =
  /** status 200 OK */ any;
export type PostDebtorsByIdVatStatementEmailApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDebtorsByIdVatStatementPdfApiResponse = unknown;
export type GetDebtorsByIdVatStatementPdfApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDebtorsByIdVatStatementApiResponse = /** status 200 OK */ any;
export type GetDebtorsByIdVatStatementApiArg = {
  id: string;
  fromDate?: string;
  toDate?: string;
};
export type PatchDebtorsByIdApiResponse = /** status 204 No Content */ any;
export type PatchDebtorsByIdApiArg = {
  id: string;
  debtorPartial: DebtorPartial;
};
export type GetDebtorsByIdApiResponse =
  /** status 200 Debtor model instance */ DebtorWithRelations;
export type GetDebtorsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteDebtorsByIdApiResponse = /** status 204 No Content */ any;
export type DeleteDebtorsByIdApiArg = {
  id: string;
};
export type PostDebtorsApiResponse =
  /** status 200 Debtor model instance */ Debtor;
export type PostDebtorsApiArg = {
  newDebtor: NewDebtor;
};
export type GetDebtorsApiResponse =
  /** status 200 Array of Debtor model instances */ DebtorWithRelations[];
export type GetDebtorsApiArg = {
  filter?: any;
};
export type PostDevelopmentApiResponse =
  /** status 200 Development */ Development;
export type PostDevelopmentApiArg = {
  developmentData: DevelopmentData;
};
export type GetDevelopmentsCountApiResponse =
  /** status 200 Development model count */ LoopbackCount;
export type GetDevelopmentsCountApiArg = {
  where?: any;
};
export type GetDevelopmentsProjectsApiResponse =
  /** status 200 Array of projects from all Development model instances */ {
    projectId?: string;
    name?: string;
  }[];
export type GetDevelopmentsProjectsApiArg = void;
export type PutDevelopmentsByIdApiResponse = unknown;
export type PutDevelopmentsByIdApiArg = {
  id: string;
  development: Development;
};
export type PatchDevelopmentsByIdApiResponse = unknown;
export type PatchDevelopmentsByIdApiArg = {
  id: string;
  developmentPartial: DevelopmentPartial;
};
export type GetDevelopmentsByIdApiResponse =
  /** status 200 Development model instance */ DevelopmentWithRelations;
export type GetDevelopmentsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteDevelopmentsByIdApiResponse = unknown;
export type DeleteDevelopmentsByIdApiArg = {
  id: string;
};
export type PatchDevelopmentsApiResponse =
  /** status 200 Development PATCH success count */ LoopbackCount;
export type PatchDevelopmentsApiArg = {
  where?: any;
  developmentPartial: DevelopmentPartial;
};
export type GetDevelopmentsApiResponse =
  /** status 200 Array of Development model instances */ DevelopmentWithRelations[];
export type GetDevelopmentsApiArg = void;
export type PatchEmployeeReviewByIdCompleteGoalApiResponse =
  /** status 200 Goal updated with actual percentage */ EmployeeReview;
export type PatchEmployeeReviewByIdCompleteGoalApiArg = {
  id: string;
  body: {
    actualPercentage?: number;
    completed?: boolean;
  };
};
export type PatchEmployeeReviewByIdApiResponse = unknown;
export type PatchEmployeeReviewByIdApiArg = {
  id: string;
  employeeReviewPartial: EmployeeReviewPartial;
};
export type GetEmployeeReviewByIdApiResponse =
  /** status 200 Employee Review model instance */ EmployeeReviewWithRelations;
export type GetEmployeeReviewByIdApiArg = {
  id: string;
};
export type GetEmployeeReviewsGoalStatisticsApiResponse =
  /** status 200 Goal completion statistics */ {
    totalGoals?: number;
    completedGoals?: number;
    pendingGoals?: number;
    completionRate?: number;
    byMonth?: {
      month?: string;
      total?: number;
      completed?: number;
      pending?: number;
    }[];
    byDepartment?: {
      department?: string;
      total?: number;
      completed?: number;
      pending?: number;
    }[];
  };
export type GetEmployeeReviewsGoalStatisticsApiArg = {
  period?: string;
};
export type GetEmployeeReviewsByUserByUserIdApiResponse =
  /** status 200 Array of Employee Reviews for a specific User */ EmployeeReviewWithRelations[];
export type GetEmployeeReviewsByUserByUserIdApiArg = {
  userId: string;
};
export type PatchExternalItemMapsByIdApiResponse = unknown;
export type PatchExternalItemMapsByIdApiArg = {
  id: string;
  body: {
    itemCode?: string;
    description?: string;
    quantityUnit?: string;
  };
};
export type GetExternalItemMapsApiResponse =
  /** status 200 Array of ExternalItemMap model instances including filters */ ExternalItemMapWithRelations[];
export type GetExternalItemMapsApiArg = {
  itemCode?: string;
  description?: string;
  quantityUnit?: string;
  externalItemCode?: string;
  externalDescription?: string;
  externalQuantityUnit?: string;
  limit?: number;
  skip?: number;
};
export type GetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodApiResponse =
  /** status 200 Feedback Survey Draft */ FeedbackSurveyDraft;
export type GetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodApiArg = {
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
};
export type PutFeedbackSurveyDraftApiResponse =
  /** status 200 Feedback Survey Draft */ FeedbackSurveyDraft;
export type PutFeedbackSurveyDraftApiArg = {
  feedbackSurveyDraftData: FeedbackSurveyDraftData;
};
export type GetFeedbackSurveyMySubmissionsApiResponse =
  /** status 200 Array of Feedback Surveys submitted by current user */ FeedbackSurvey[];
export type GetFeedbackSurveyMySubmissionsApiArg = void;
export type GetFeedbackSurveyByIdApiResponse =
  /** status 200 Feedback Survey model instance */ FeedbackSurveyWithRelations;
export type GetFeedbackSurveyByIdApiArg = {
  id: string;
};
export type PostFeedbackSurveyApiResponse =
  /** status 200 Feedback Survey */ FeedbackSurvey;
export type PostFeedbackSurveyApiArg = {
  feedbackSurveyData: FeedbackSurveyData;
};
export type PatchFinanceAccountsByIdApiResponse = unknown;
export type PatchFinanceAccountsByIdApiArg = {
  id: string;
  accountPartial: AccountPartial;
};
export type GetFinanceAccountsByIdApiResponse =
  /** status 200 Account */ Account;
export type GetFinanceAccountsByIdApiArg = {
  id: string;
};
export type PostFinanceAccountsApiResponse =
  /** status 201 Account created */ Account;
export type PostFinanceAccountsApiArg = {
  newAccount: NewAccount;
};
export type GetFinanceAccountsApiResponse =
  /** status 200 Array of Accounts */ Account[];
export type GetFinanceAccountsApiArg = {
  accountType?: string;
  department?: string;
  isActive?: boolean;
};
export type PostFinanceBudgetsByIdActivateApiResponse =
  /** status 200 Budget activated */ Budget;
export type PostFinanceBudgetsByIdActivateApiArg = {
  id: string;
};
export type PostFinanceBudgetsByIdApproveApiResponse =
  /** status 200 Budget approved */ Budget;
export type PostFinanceBudgetsByIdApproveApiArg = {
  id: string;
};
export type GetFinanceBudgetsByIdUtilizationApiResponse = unknown;
export type GetFinanceBudgetsByIdUtilizationApiArg = {
  id: string;
};
export type PatchFinanceBudgetsByIdApiResponse = unknown;
export type PatchFinanceBudgetsByIdApiArg = {
  id: string;
  budgetPartial: BudgetPartial;
};
export type GetFinanceBudgetsByIdApiResponse = /** status 200 Budget */ Budget;
export type GetFinanceBudgetsByIdApiArg = {
  id: string;
};
export type PostFinanceBudgetsApiResponse =
  /** status 201 Budget created */ Budget;
export type PostFinanceBudgetsApiArg = {
  newBudget: NewBudget;
};
export type GetFinanceBudgetsApiResponse =
  /** status 200 Array of Budgets */ Budget[];
export type GetFinanceBudgetsApiArg = {
  fiscalYear?: string;
  department?: string;
  status?: string;
  budgetType?: string;
};
export type GetFinanceDashboardApiResponse = /** status 200 OK */ any;
export type GetFinanceDashboardApiArg = {
  developmentId?: string;
};
export type PostFinanceExpenseReportsByIdAddExpenseApiResponse =
  /** status 200 Expense added */ ExpenseReport;
export type PostFinanceExpenseReportsByIdAddExpenseApiArg = {
  id: string;
  body: {
    expenseDate: string;
    category: string;
    description: string;
    vendor?: string;
    amount: number;
    currency?: string;
    exchangeRate?: number;
    receiptNumber?: string;
  };
};
export type PostFinanceExpenseReportsByIdApproveApiResponse =
  /** status 200 Expense Report approved */ ExpenseReport;
export type PostFinanceExpenseReportsByIdApproveApiArg = {
  id: string;
  body: {
    approvedAmount?: number;
  };
};
export type PostFinanceExpenseReportsByIdReimburseApiResponse =
  /** status 200 Expense Report reimbursed */ ExpenseReport;
export type PostFinanceExpenseReportsByIdReimburseApiArg = {
  id: string;
  body: {
    paymentMethod: string;
    paymentReference: string;
  };
};
export type PostFinanceExpenseReportsByIdRejectApiResponse =
  /** status 200 Expense Report rejected */ ExpenseReport;
export type PostFinanceExpenseReportsByIdRejectApiArg = {
  id: string;
  body: {
    reason: string;
  };
};
export type PostFinanceExpenseReportsByIdSubmitApiResponse =
  /** status 200 Expense Report submitted */ ExpenseReport;
export type PostFinanceExpenseReportsByIdSubmitApiArg = {
  id: string;
};
export type PatchFinanceExpenseReportsByIdApiResponse = unknown;
export type PatchFinanceExpenseReportsByIdApiArg = {
  id: string;
  expenseReportPartial: ExpenseReportPartial;
};
export type GetFinanceExpenseReportsByIdApiResponse =
  /** status 200 Expense Report */ ExpenseReport;
export type GetFinanceExpenseReportsByIdApiArg = {
  id: string;
};
export type PostFinanceExpenseReportsApiResponse =
  /** status 201 Expense Report created */ ExpenseReport;
export type PostFinanceExpenseReportsApiArg = {
  newExpenseReport: NewExpenseReport;
};
export type GetFinanceExpenseReportsApiResponse =
  /** status 200 Array of Expense Reports */ ExpenseReport[];
export type GetFinanceExpenseReportsApiArg = {
  status?: string;
  department?: string;
  reportType?: string;
  myReportsOnly?: boolean;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  skip?: number;
};
export type GetFinanceInvoicesAccountsPayableSummaryApiResponse = unknown;
export type GetFinanceInvoicesAccountsPayableSummaryApiArg = void;
export type GetFinanceInvoicesAccountsReceivableSummaryApiResponse = unknown;
export type GetFinanceInvoicesAccountsReceivableSummaryApiArg = void;
export type PostFinanceInvoicesByIdApproveApiResponse =
  /** status 200 Invoice approved */ Invoice;
export type PostFinanceInvoicesByIdApproveApiArg = {
  id: string;
};
export type PostFinanceInvoicesByIdRecordPaymentApiResponse =
  /** status 200 Payment recorded */ Invoice;
export type PostFinanceInvoicesByIdRecordPaymentApiArg = {
  id: string;
  body: {
    amount: number;
    paymentMethod: string;
    referenceNumber?: string;
    notes?: string;
  };
};
export type PatchFinanceInvoicesByIdApiResponse = unknown;
export type PatchFinanceInvoicesByIdApiArg = {
  id: string;
  invoicePartial: InvoicePartial;
};
export type GetFinanceInvoicesByIdApiResponse =
  /** status 200 Invoice */ Invoice;
export type GetFinanceInvoicesByIdApiArg = {
  id: string;
};
export type PostFinanceInvoicesApiResponse =
  /** status 201 Invoice created */ Invoice;
export type PostFinanceInvoicesApiArg = {
  newInvoice: NewInvoice;
};
export type GetFinanceInvoicesApiResponse =
  /** status 200 Array of Invoices */ Invoice[];
export type GetFinanceInvoicesApiArg = {
  invoiceType?: string;
  status?: string;
  department?: string;
  partyName?: string;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  skip?: number;
};
export type GetFinanceMonthlyInstalmentsApiResponse = /** status 200 OK */ any;
export type GetFinanceMonthlyInstalmentsApiArg = {
  developmentId?: string;
  month?: string;
};
export type GetFinanceReportsExpenseSummaryByCategoryApiResponse = unknown;
export type GetFinanceReportsExpenseSummaryByCategoryApiArg = {
  department?: string;
  startDate?: string;
  endDate?: string;
};
export type GetFinanceReportsExpenseSummaryByEmployeeApiResponse = unknown;
export type GetFinanceReportsExpenseSummaryByEmployeeApiArg = {
  department?: string;
  startDate?: string;
  endDate?: string;
};
export type GetFinanceReportsGeneralLedgerByAccountIdApiResponse = unknown;
export type GetFinanceReportsGeneralLedgerByAccountIdApiArg = {
  accountId: string;
  startDate?: string;
  endDate?: string;
};
export type GetFinanceReportsTrialBalanceApiResponse = unknown;
export type GetFinanceReportsTrialBalanceApiArg = void;
export type PostFinanceTransactionsByIdApproveApiResponse =
  /** status 200 Transaction approved */ FinancialTransaction;
export type PostFinanceTransactionsByIdApproveApiArg = {
  id: string;
};
export type PostFinanceTransactionsByIdPostApiResponse =
  /** status 200 Transaction posted */ FinancialTransaction;
export type PostFinanceTransactionsByIdPostApiArg = {
  id: string;
};
export type PostFinanceTransactionsByIdReverseApiResponse =
  /** status 200 Transaction reversed */ FinancialTransaction;
export type PostFinanceTransactionsByIdReverseApiArg = {
  id: string;
  body: {
    reason: string;
  };
};
export type GetFinanceTransactionsByIdApiResponse =
  /** status 200 Transaction */ FinancialTransaction;
export type GetFinanceTransactionsByIdApiArg = {
  id: string;
};
export type PostFinanceTransactionsApiResponse =
  /** status 201 Transaction created */ FinancialTransaction;
export type PostFinanceTransactionsApiArg = {
  newTransaction: NewTransaction;
};
export type GetFinanceTransactionsApiResponse =
  /** status 200 Array of Transactions */ FinancialTransaction[];
export type GetFinanceTransactionsApiArg = {
  transactionType?: string;
  status?: string;
  department?: string;
  isPosted?: boolean;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  skip?: number;
};
export type PostGetSignedUrlApiResponse =
  /** status 200 Get Signed URL for S3 upload */ {
    url?: string;
  };
export type PostGetSignedUrlApiArg = {
  body: {
    fileName: string;
    fileType: string;
  };
};
export type GetGradingConfigActiveApiResponse =
  /** status 200 Active GradingConfig model instance */ GradingConfig;
export type GetGradingConfigActiveApiArg = void;
export type PostGradingConfigResetToDefaultApiResponse =
  /** status 200 Reset to default configuration */ GradingConfig;
export type PostGradingConfigResetToDefaultApiArg = void;
export type PatchGradingConfigByIdApiResponse =
  /** status 204 No Content */ any;
export type PatchGradingConfigByIdApiArg = {
  id: string;
  gradingConfigPartial: GradingConfigPartial;
};
export type PostGradingConfigApiResponse =
  /** status 200 GradingConfig model instance */ GradingConfig;
export type PostGradingConfigApiArg = {
  newGradingConfig: NewGradingConfig;
};
export type GetGradingConfigApiResponse =
  /** status 200 Array of GradingConfig model instances */ GradingConfig[];
export type GetGradingConfigApiArg = {
  filter?: any;
};
export type GetGrvsDropdownApiResponse =
  /** status 200 Array of GRVs model instances for dropdown */ GrvWithRelations[];
export type GetGrvsDropdownApiArg = void;
export type PatchGrvsByIdApiResponse = unknown;
export type PatchGrvsByIdApiArg = {
  id: string;
  grvPartial: GrvPartial;
};
export type GetGrvsByIdApiResponse =
  /** status 200 GRV model instance */ GrvWithRelations;
export type GetGrvsByIdApiArg = {
  id: string;
};
export type GetGrvsApiResponse =
  /** status 200 Array of GRVs model instances */ GrvWithRelations[];
export type GetGrvsApiArg = {
  grvNumber?: string;
  status?: boolean;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  skip?: number;
};
export type PostImportCreditorsApiResponse =
  /** status 200 Import creditors from CSV/Excel file */ {
    imported?: number;
    errors?: {
      row?: number;
      error?: string;
    }[];
  };
export type PostImportCreditorsApiArg = void;
export type PostImportDebtorInvoicesApiResponse = unknown;
export type PostImportDebtorInvoicesApiArg = void;
export type PostImportDebtorsApiResponse =
  /** status 200 Import debtors from CSV/Excel file */ {
    imported?: number;
    errors?: {
      row?: number;
      error?: string;
    }[];
  };
export type PostImportDebtorsApiArg = void;
export type PostImportPaymentsApiResponse = unknown;
export type PostImportPaymentsApiArg = void;
export type PostImportReceiptsApiResponse = unknown;
export type PostImportReceiptsApiArg = void;
export type PostImportTakeOnTransactionsApiResponse = unknown;
export type PostImportTakeOnTransactionsApiArg = void;
export type GetImportTemplatesCreditorsApiResponse = unknown;
export type GetImportTemplatesCreditorsApiArg = void;
export type GetImportTemplatesDebtorInvoicesApiResponse = unknown;
export type GetImportTemplatesDebtorInvoicesApiArg = void;
export type GetImportTemplatesDebtorsApiResponse = unknown;
export type GetImportTemplatesDebtorsApiArg = void;
export type GetImportTemplatesPaymentsApiResponse = unknown;
export type GetImportTemplatesPaymentsApiArg = void;
export type GetImportTemplatesReceiptsApiResponse = unknown;
export type GetImportTemplatesReceiptsApiArg = void;
export type GetImportTemplatesTakeOnTransactionsApiResponse = unknown;
export type GetImportTemplatesTakeOnTransactionsApiArg = void;
export type GetImportTemplatesVatInvoicesApiResponse = unknown;
export type GetImportTemplatesVatInvoicesApiArg = void;
export type GetImportTemplatesVatPaymentsApiResponse = unknown;
export type GetImportTemplatesVatPaymentsApiArg = void;
export type PostImportVatInvoicesApiResponse = unknown;
export type PostImportVatInvoicesApiArg = void;
export type PostImportVatPaymentsApiResponse = unknown;
export type PostImportVatPaymentsApiArg = void;
export type GetInventoriesCountApiResponse =
  /** status 200 Inventory model count */ LoopbackCount;
export type GetInventoriesCountApiArg = {
  where?: any;
};
export type GetInventoriesByIdApiResponse =
  /** status 200 Inventory model instance */ InventoryWithRelations;
export type GetInventoriesByIdApiArg = {
  id: string;
};
export type DeleteInventoriesByIdApiResponse = unknown;
export type DeleteInventoriesByIdApiArg = {
  id: string;
};
export type PostInventoriesApiResponse =
  /** status 200 Inventory model instance */ Inventory;
export type PostInventoriesApiArg = {
  newInventory: NewInventory;
};
export type GetInventoriesApiResponse =
  /** status 200 Array of Inventory model instances */ InventoryWithRelations[];
export type GetInventoriesApiArg = {
  filter?: any;
};
export type PatchInviteMarkAsScannedByIdApiResponse = unknown;
export type PatchInviteMarkAsScannedByIdApiArg = {
  id: string;
};
export type GetInviteByIdApiResponse =
  /** status 200 Invite model instance */ InviteWithRelations;
export type GetInviteByIdApiArg = {
  id: string;
};
export type GetInvitesApiResponse = /** status 200 Invite model instance */ any;
export type GetInvitesApiArg = {
  timeZone?: string;
};
export type GetItemCategoriesCountApiResponse =
  /** status 200 ItemCategory model count */ LoopbackCount;
export type GetItemCategoriesCountApiArg = {
  where?: any;
};
export type GetItemCategoriesByIdApiResponse =
  /** status 200 ItemCategory model instance */ ItemCategoryWithRelations;
export type GetItemCategoriesByIdApiArg = {
  id: string;
};
export type DeleteItemCategoriesByIdApiResponse = unknown;
export type DeleteItemCategoriesByIdApiArg = {
  id: string;
};
export type PostItemCategoriesApiResponse =
  /** status 200 ItemCategory model instance */ ItemCategory;
export type PostItemCategoriesApiArg = {
  newItemCategory: NewItemCategory;
};
export type GetItemCategoriesApiResponse =
  /** status 200 Array of ItemCategory model instances */ ItemCategoryWithRelations[];
export type GetItemCategoriesApiArg = {
  filter?: any;
};
export type GetItemLocationsCountApiResponse =
  /** status 200 ItemLocation model count */ LoopbackCount;
export type GetItemLocationsCountApiArg = {
  where?: any;
};
export type GetItemLocationsByIdApiResponse =
  /** status 200 ItemLocation model instance */ ItemLocationWithRelations;
export type GetItemLocationsByIdApiArg = {
  id: string;
};
export type DeleteItemLocationsByIdApiResponse = unknown;
export type DeleteItemLocationsByIdApiArg = {
  id: string;
};
export type PostItemLocationsApiResponse =
  /** status 200 ItemLocation model instance */ ItemLocation;
export type PostItemLocationsApiArg = {
  newItemLocation: NewItemLocation;
};
export type GetItemLocationsApiResponse =
  /** status 200 Array of ItemLocation model instances with relations */ ItemLocationWithRelations[];
export type GetItemLocationsApiArg = {
  itemCode?: string;
  itemDescription?: string;
  locationCode?: string;
  locationDescription?: string;
  developmentAllocation?: string;
  projectAllocation?: string;
  supplier?: string;
  purchaseOrderNumber?: string;
  currency?: string;
  rate?: number;
  itemDiscount?: number;
  vat?: number;
  limit?: number;
  skip?: number;
};
export type GetItemTransfersCountApiResponse =
  /** status 200 ItemTransfer model count */ LoopbackCount;
export type GetItemTransfersCountApiArg = {
  where?: any;
};
export type GetItemTransfersByIdApiResponse =
  /** status 200 ItemTransfer model instance */ ItemTransferWithRelations;
export type GetItemTransfersByIdApiArg = {
  id: string;
};
export type DeleteItemTransfersByIdApiResponse = unknown;
export type DeleteItemTransfersByIdApiArg = {
  id: string;
};
export type PostItemTransfersApiResponse =
  /** status 200 ItemTransfer model instance */ ItemTransfer;
export type PostItemTransfersApiArg = {
  newItemTransfer: NewItemTransfer;
};
export type GetItemTransfersApiResponse =
  /** status 200 Array of ItemTransfer model instances including relations */ ItemTransferWithRelations[];
export type GetItemTransfersApiArg = {
  title?: string;
  transferredBy?: string;
  transferType?: string;
  purchaseOrderNumber?: string;
  procurementProcessId?: string;
  quotationNumber?: string;
  currency?: string;
  transferredDate?: string;
  isService?: boolean;
  sourceLocationType?: string;
  destinationLocationType?: string;
  reasonForTransfer?: string;
  grvNumber?: string;
  givNumber?: string;
  supplier?: string;
  limit?: number;
  skip?: number;
  fromDate?: string;
  toDate?: string;
};
export type GetItemsCountApiResponse =
  /** status 200 Item model count */ LoopbackCount;
export type GetItemsCountApiArg = {
  where?: any;
};
export type GetItemsDropdownApiResponse =
  /** status 200 Array of Item model instances including relations for dropdown */ ItemWithRelations[];
export type GetItemsDropdownApiArg = void;
export type GetItemsByIdApiResponse =
  /** status 200 Item model instance */ ItemWithRelations;
export type GetItemsByIdApiArg = {
  id: string;
};
export type DeleteItemsByIdApiResponse = unknown;
export type DeleteItemsByIdApiArg = {
  id: string;
};
export type PostItemsApiResponse = /** status 200 Item model instance */ Item;
export type PostItemsApiArg = {
  newItem: NewItem;
};
export type GetItemsApiResponse =
  /** status 200 Array of Item model instances including relations */ ItemWithRelations[];
export type GetItemsApiArg = {
  itemCode?: string;
  description?: string;
  quantityUnit?: string;
  inventoryCode?: string;
  inventoryDescription?: string;
  categoryCode?: string;
  categoryDescription?: string;
  limit?: number;
  skip?: number;
};
export type PostItemsIssuedApiResponse =
  /** status 200 Item Issues model instance */ ItemIssued;
export type PostItemsIssuedApiArg = {
  newItemsIssued: NewItemsIssued;
};
export type GetItemsIssuedApiResponse =
  /** status 200 Array of Items Issued model instances with relations */ ItemIssuedWithRelations[];
export type GetItemsIssuedApiArg = {
  itemCode?: string;
  itemDescription?: string;
  unitName?: string;
  locationDescription?: string;
  developmentAllocation?: string;
  projectAllocation?: string;
  correctProjectAllocation?: string;
  isIncorrectIssue?: boolean;
  supplier?: string;
  purchaseOrderNumber?: string;
  currency?: string;
  rate?: number;
  itemDiscount?: number;
  vat?: number;
  limit?: number;
  skip?: number;
};
export type GetJobDescriptionsActiveApiResponse =
  /** status 200 Array of active JobDescription model instances */ JobDescriptionWithRelations[];
export type GetJobDescriptionsActiveApiArg = void;
export type GetJobDescriptionsByDepartmentByDepartmentApiResponse =
  /** status 200 JobDescriptions by department */ JobDescriptionWithRelations[];
export type GetJobDescriptionsByDepartmentByDepartmentApiArg = {
  department: string;
};
export type GetJobDescriptionsCountApiResponse =
  /** status 200 JobDescription model count */ LoopbackCount;
export type GetJobDescriptionsCountApiArg = {
  where?: any;
};
export type GetJobDescriptionsDepartmentsApiResponse =
  /** status 200 Get unique list of departments */ string[];
export type GetJobDescriptionsDepartmentsApiArg = void;
export type GetJobDescriptionsGradesApiResponse =
  /** status 200 Get unique list of grades */ string[];
export type GetJobDescriptionsGradesApiArg = void;
export type PostJobDescriptionsMyApiResponse =
  /** status 200 Create or update current user's JobDescription */ JobDescriptionWithRelations;
export type PostJobDescriptionsMyApiArg = {
  newMyJobDescription: NewMyJobDescription;
};
export type PatchJobDescriptionsMyApiResponse =
  /** status 200 Update current user's JobDescription */ JobDescriptionWithRelations;
export type PatchJobDescriptionsMyApiArg = {
  jobDescriptionPartial: JobDescriptionPartial;
};
export type GetJobDescriptionsMyApiResponse =
  /** status 200 Current user's JobDescription */ JobDescriptionWithRelations;
export type GetJobDescriptionsMyApiArg = void;
export type DeleteJobDescriptionsMyApiResponse =
  /** status 204 No Content */ any;
export type DeleteJobDescriptionsMyApiArg = void;
export type PostJobDescriptionsRecalculateAllCountsApiResponse =
  /** status 200 Recalculate all reports counts for all active job descriptions */ {
    updated?: number;
  };
export type PostJobDescriptionsRecalculateAllCountsApiArg = void;
export type GetJobDescriptionsTeamApiResponse =
  /** status 200 JobDescriptions for users reporting to the current user (manager view) */ JobDescriptionWithRelations[];
export type GetJobDescriptionsTeamApiArg = void;
export type GetJobDescriptionsUserByUserIdApiResponse =
  /** status 200 JobDescription for a specific user */ JobDescriptionWithRelations;
export type GetJobDescriptionsUserByUserIdApiArg = {
  userId: string;
};
export type PostJobDescriptionsByIdAssignApiResponse =
  /** status 200 Assign a user to a JobDescription */ JobDescription;
export type PostJobDescriptionsByIdAssignApiArg = {
  id: string;
  body: {
    userId: string;
  };
};
export type GetJobDescriptionsByIdReportsCountsApiResponse =
  /** status 200 Get reports counts for a job description */ {
    directReportsCount?: number;
    indirectReportsCount?: number;
  };
export type GetJobDescriptionsByIdReportsCountsApiArg = {
  id: string;
};
export type PostJobDescriptionsByIdUnassignApiResponse =
  /** status 204 No Content */ any;
export type PostJobDescriptionsByIdUnassignApiArg = {
  id: string;
};
export type PutJobDescriptionsByIdApiResponse =
  /** status 204 No Content */ any;
export type PutJobDescriptionsByIdApiArg = {
  id: string;
  jobDescription: JobDescription;
};
export type PatchJobDescriptionsByIdApiResponse =
  /** status 204 No Content */ any;
export type PatchJobDescriptionsByIdApiArg = {
  id: string;
  jobDescriptionPartial: JobDescriptionPartial;
};
export type GetJobDescriptionsByIdApiResponse =
  /** status 200 JobDescription model instance */ JobDescriptionWithRelations;
export type GetJobDescriptionsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteJobDescriptionsByIdApiResponse =
  /** status 204 No Content */ any;
export type DeleteJobDescriptionsByIdApiArg = {
  id: string;
};
export type PostJobDescriptionsApiResponse =
  /** status 200 JobDescription model instance */ JobDescription;
export type PostJobDescriptionsApiArg = {
  newJobDescription: NewJobDescription;
};
export type GetJobDescriptionsApiResponse =
  /** status 200 Array of JobDescription model instances */ JobDescriptionWithRelations[];
export type GetJobDescriptionsApiArg = {
  filter?: any;
};
export type PostKnowledgeBaseApiResponse =
  /** status 200 Knowledge base entry model instance */ KnowledgeBaseEntry;
export type PostKnowledgeBaseApiArg = {
  newKnowledgeBaseEntry: NewKnowledgeBaseEntry;
};
export type GetKnowledgeBaseApiResponse =
  /** status 200 Invite model instance */ KnowledgeBaseEntry[];
export type GetKnowledgeBaseApiArg = void;
export type PostLabourAttendanceBatchApiResponse = unknown;
export type PostLabourAttendanceBatchApiArg = {
  body: object;
};
export type GetLabourAttendanceApiResponse = unknown;
export type GetLabourAttendanceApiArg = {
  from?: string;
  to?: string;
};
export type PatchLabourBlocksByIdApiResponse = unknown;
export type PatchLabourBlocksByIdApiArg = {
  id: string;
  body: object;
};
export type DeleteLabourBlocksByIdApiResponse = unknown;
export type DeleteLabourBlocksByIdApiArg = {
  id: string;
};
export type PostLabourBlocksApiResponse = unknown;
export type PostLabourBlocksApiArg = {
  body: object;
};
export type GetLabourBlocksApiResponse = unknown;
export type GetLabourBlocksApiArg = void;
export type GetLabourReportsDailyApiResponse = unknown;
export type GetLabourReportsDailyApiArg = {
  date?: string;
};
export type GetLabourReportsDashboardApiResponse = unknown;
export type GetLabourReportsDashboardApiArg = void;
export type GetLabourReportsPayrollApiResponse = unknown;
export type GetLabourReportsPayrollApiArg = {
  from?: string;
  to?: string;
};
export type GetLabourReportsRangeApiResponse = unknown;
export type GetLabourReportsRangeApiArg = {
  from?: string;
  to?: string;
};
export type PostLabourWorkersImportOdooApiResponse =
  /** status 200 Odoo import result */ object;
export type PostLabourWorkersImportOdooApiArg = void;
export type PatchLabourWorkersByIdApiResponse = unknown;
export type PatchLabourWorkersByIdApiArg = {
  id: string;
  body: object;
};
export type DeleteLabourWorkersByIdApiResponse = unknown;
export type DeleteLabourWorkersByIdApiArg = {
  id: string;
};
export type PostLabourWorkersApiResponse = unknown;
export type PostLabourWorkersApiArg = {
  body: object;
};
export type GetLabourWorkersApiResponse = unknown;
export type GetLabourWorkersApiArg = {
  active?: boolean;
};
export type GetLifeWheelByIdApiResponse =
  /** status 200 Life Wheel model instance */ LifeWheelWithRelations;
export type GetLifeWheelByIdApiArg = {
  id: string;
};
export type GetLifeWheelsByUserByUserIdApiResponse =
  /** status 200 Array of Life Wheels for a specific User */ LifeWheelWithRelations[];
export type GetLifeWheelsByUserByUserIdApiArg = {
  userId: string;
};
export type GetOrgChartDepartmentByDepartmentApiResponse =
  /** status 200 Get department structure */ object[];
export type GetOrgChartDepartmentByDepartmentApiArg = {
  department: string;
};
export type GetOrgChartSupervisorsApiResponse =
  /** status 200 Get potential supervisors for dropdown */ object[];
export type GetOrgChartSupervisorsApiArg = {
  excludeUserId?: string;
};
export type GetOrgChartUserByUserIdDirectReportsApiResponse =
  /** status 200 Get direct reports for a user */ object[];
export type GetOrgChartUserByUserIdDirectReportsApiArg = {
  userId: string;
};
export type GetOrgChartUserByUserIdReportingChainApiResponse =
  /** status 200 Get reporting chain for a user (path to CEO) */ object[];
export type GetOrgChartUserByUserIdReportingChainApiArg = {
  userId: string;
};
export type GetOrgChartUserByUserIdApiResponse =
  /** status 200 Get org chart starting from a specific user */ object;
export type GetOrgChartUserByUserIdApiArg = {
  userId: string;
};
export type GetOrgChartApiResponse =
  /** status 200 Get full organization chart */ object[];
export type GetOrgChartApiArg = void;
export type GetPasswordResetIsResetLinkValidByResetIdApiResponse = unknown;
export type GetPasswordResetIsResetLinkValidByResetIdApiArg = {
  resetId: string;
};
export type PostPasswordResetRequestByUserEmailApiResponse = unknown;
export type PostPasswordResetRequestByUserEmailApiArg = {
  userEmail: string;
};
export type PostPasswordResetResetPasswordApiResponse = unknown;
export type PostPasswordResetResetPasswordApiArg = {
  /** The input for the reset password function */
  body: {
    resetRequestId: string;
    password: string;
  };
};
export type PatchPaymentRequisitionsByIdApiResponse = unknown;
export type PatchPaymentRequisitionsByIdApiArg = {
  id: string;
  paymentRequisitionPartial: PaymentRequisitionPartial;
};
export type PostPaymentRequisitionsApiResponse =
  /** status 201 Payment Requisition created */ PaymentRequisition;
export type PostPaymentRequisitionsApiArg = {
  newPaymentRequisition: NewPaymentRequisition;
};
export type GetPaymentRequisitionsApiResponse =
  /** status 200 Array of Payment Requisitions */ PaymentRequisitionWithRelations[];
export type GetPaymentRequisitionsApiArg = {
  title?: string;
  supplierName?: string;
  reqNumber?: string;
  development?: string;
  project?: string;
  department?: string;
  currency?: string;
  referenceNumber?: string;
  batchNumber?: string;
  paymentMethod?: string;
  paymentType?: string;
  status?: string;
  priority?: string;
  amount?: string;
  purchaseOrderNumber?: string;
  procurementProcessId?: string;
  reviewedByEmail?: string;
  fromDate?: string;
  toDate?: string;
  isOutstandingPayment?: boolean;
  reportByEmail?: boolean;
  notReviewedOnly?: boolean;
  reportName?: string;
  limit?: number;
  skip?: number;
};
export type GetPaymentsCountApiResponse = unknown;
export type GetPaymentsCountApiArg = {
  where?: any;
};
export type PatchPaymentsByIdApiResponse = unknown;
export type PatchPaymentsByIdApiArg = {
  id: string;
  paymentPartial: PaymentPartial;
};
export type GetPaymentsByIdApiResponse = unknown;
export type GetPaymentsByIdApiArg = {
  id: string;
};
export type DeletePaymentsByIdApiResponse = unknown;
export type DeletePaymentsByIdApiArg = {
  id: string;
};
export type PostPaymentsApiResponse = unknown;
export type PostPaymentsApiArg = {
  newPayment: NewPayment;
};
export type GetPaymentsApiResponse = unknown;
export type GetPaymentsApiArg = {
  filter?: any;
};
export type PostPayrollUploadApiResponse =
  /** status 200 Payroll voucher PDF upload response */ {
    message?: string;
    pdfUrl?: string;
  };
export type PostPayrollUploadApiArg = {
  /** Link to the Excel file containing payroll data */
  body: {
    excelFile?: string;
    paymentDesc?: string;
  };
};
export type GetPearReviewsAdminAllApiResponse =
  /** status 200 Array of all PEAR Review instances (admin only) */ PearReview[];
export type GetPearReviewsAdminAllApiArg = {
  reviewPeriod?: string;
  status?: string;
};
export type GetPearReviewsByEmployeeByEmployeeIdApiResponse =
  /** status 200 Array of PEARReview instances for specified employee */ PearReview[];
export type GetPearReviewsByEmployeeByEmployeeIdApiArg = {
  employeeId: string;
};
export type GetPearReviewsCountApiResponse =
  /** status 200 PEARReview model count */ LoopbackCount;
export type GetPearReviewsCountApiArg = {
  where?: any;
};
export type GetPearReviewsMyDirectReportsApiResponse =
  /** status 200 Array of PEAR Reviews from direct reports */ PearReview[];
export type GetPearReviewsMyDirectReportsApiArg = void;
export type GetPearReviewsMyReviewsApiResponse =
  /** status 200 Array of PEARReview instances for current user */ PearReview[];
export type GetPearReviewsMyReviewsApiArg = void;
export type GetPearReviewsRatingScaleApiResponse =
  /** status 200 PEAR performance rating scale */ any;
export type GetPearReviewsRatingScaleApiArg = void;
export type GetPearReviewsSummaryApiResponse =
  /** status 200 PEAR Review summary data */ {
    employeeId?: string;
    employeeName?: string;
    designation?: string;
    reviewPeriod?: string;
    overallScore?: number;
    finalGrade?: string;
  }[];
export type GetPearReviewsSummaryApiArg = {
  reviewPeriod?: string;
};
export type GetPearReviewsTemplateApiResponse =
  /** status 200 Default PEAR Review criteria template */ object;
export type GetPearReviewsTemplateApiArg = void;
export type PostPearReviewsByIdApproveApiResponse =
  /** status 200 PEAR Review approved */ PearReview;
export type PostPearReviewsByIdApproveApiArg = {
  id: string;
};
export type PatchPearReviewsByIdManagerEditApiResponse =
  /** status 200 PEAR Review manager edit success */ PearReview;
export type PatchPearReviewsByIdManagerEditApiArg = {
  id: string;
  pearReviewPartial: PearReviewPartial;
};
export type PostPearReviewsByIdSubmitApiResponse =
  /** status 200 PEAR Review submitted for approval */ PearReview;
export type PostPearReviewsByIdSubmitApiArg = {
  id: string;
};
export type PatchPearReviewsByIdApiResponse = /** status 204 No Content */ any;
export type PatchPearReviewsByIdApiArg = {
  id: string;
  pearReviewPartial: PearReviewPartial;
};
export type GetPearReviewsByIdApiResponse =
  /** status 200 PEARReview model instance */ PearReviewWithRelations;
export type GetPearReviewsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeletePearReviewsByIdApiResponse = /** status 204 No Content */ any;
export type DeletePearReviewsByIdApiArg = {
  id: string;
};
export type PostPearReviewsApiResponse =
  /** status 200 PEARReview model instance */ PearReview;
export type PostPearReviewsApiArg = {
  newPearReview: NewPearReview;
};
export type GetPearReviewsApiResponse =
  /** status 200 Array of PEARReview model instances */ PearReviewWithRelations[];
export type GetPearReviewsApiArg = {
  filter?: any;
};
export type PostPerformanceAssessmentAlertsSmokeTestApiResponse = unknown;
export type PostPerformanceAssessmentAlertsSmokeTestApiArg = {
  trigger?: string;
};
export type GetPerformanceRatingsApiResponse =
  /** status 200 Get performance rating scale */ {
    grade?: string;
    minPercentage?: number;
    maxPercentage?: number;
    bonusEntitlement?: number;
    description?: string;
    colorCode?: string;
  }[];
export type GetPerformanceRatingsApiArg = void;
export type PostPettyCashBulkApproveApiResponse = unknown;
export type PostPettyCashBulkApproveApiArg = {
  body: object;
};
export type PostPettyCashMigratePaymentRequisitionsApiResponse = unknown;
export type PostPettyCashMigratePaymentRequisitionsApiArg = {
  body: object;
};
export type GetPettyCashSummaryDashboardApiResponse = unknown;
export type GetPettyCashSummaryDashboardApiArg = void;
export type PatchPettyCashSummarySettingsApiResponse = unknown;
export type PatchPettyCashSummarySettingsApiArg = {
  body: object;
};
export type GetPettyCashSummarySettingsApiResponse = unknown;
export type GetPettyCashSummarySettingsApiArg = void;
export type PostPettyCashByIdApproveApiResponse = unknown;
export type PostPettyCashByIdApproveApiArg = {
  id: string;
  body: object;
};
export type GetPettyCashByIdAuditLogApiResponse = unknown;
export type GetPettyCashByIdAuditLogApiArg = {
  id: string;
};
export type PostPettyCashByIdCancelApiResponse = unknown;
export type PostPettyCashByIdCancelApiArg = {
  id: string;
  body: object;
};
export type PostPettyCashByIdHoldApiResponse = unknown;
export type PostPettyCashByIdHoldApiArg = {
  id: string;
  body: object;
};
export type PostPettyCashByIdMarkPaidApiResponse = unknown;
export type PostPettyCashByIdMarkPaidApiArg = {
  id: string;
  body: object;
};
export type PostPettyCashByIdMoreInfoApiResponse = unknown;
export type PostPettyCashByIdMoreInfoApiArg = {
  id: string;
  body: object;
};
export type PatchPettyCashByIdPaymentDetailsApiResponse = unknown;
export type PatchPettyCashByIdPaymentDetailsApiArg = {
  id: string;
  body: object;
};
export type PostPettyCashByIdPrepareApiResponse = unknown;
export type PostPettyCashByIdPrepareApiArg = {
  id: string;
};
export type PostPettyCashByIdRejectApiResponse = unknown;
export type PostPettyCashByIdRejectApiArg = {
  id: string;
  body: object;
};
export type PostPettyCashByIdSubmitApiResponse = unknown;
export type PostPettyCashByIdSubmitApiArg = {
  id: string;
};
export type PostPettyCashByIdUploadApiResponse = unknown;
export type PostPettyCashByIdUploadApiArg = {
  id: string;
};
export type PatchPettyCashByIdUrgencyApiResponse = unknown;
export type PatchPettyCashByIdUrgencyApiArg = {
  id: string;
  body: object;
};
export type PatchPettyCashByIdApiResponse = unknown;
export type PatchPettyCashByIdApiArg = {
  id: string;
  body: object;
};
export type GetPettyCashByIdApiResponse = unknown;
export type GetPettyCashByIdApiArg = {
  id: string;
};
export type PostPettyCashApiResponse = unknown;
export type PostPettyCashApiArg = {
  body: object;
};
export type GetPettyCashApiResponse = unknown;
export type GetPettyCashApiArg = void;
export type GetPingApiResponse = /** status 200 Ping Response */ PingResponse;
export type GetPingApiArg = void;
export type GetProcurementContractsBySupplierBySupplierIdApiResponse =
  /** status 200 Array of ProcurementContract model instances filtered by supplierId */ ProcurementContractWithRelations[];
export type GetProcurementContractsBySupplierBySupplierIdApiArg = {
  supplierId: string;
};
export type GetProcurementContractsCountApiResponse =
  /** status 200 ProcurementContract model count */ LoopbackCount;
export type GetProcurementContractsCountApiArg = {
  where?: any;
};
export type PatchProcurementContractsByIdApiResponse = unknown;
export type PatchProcurementContractsByIdApiArg = {
  id: string;
  procurementContractPartial: ProcurementContractPartial;
};
export type GetProcurementContractsByIdApiResponse =
  /** status 200 ProcurementContract model instance */ ProcurementContractWithRelations;
export type GetProcurementContractsByIdApiArg = {
  id: string;
};
export type DeleteProcurementContractsByIdApiResponse = unknown;
export type DeleteProcurementContractsByIdApiArg = {
  id: string;
};
export type PostProcurementContractsApiResponse =
  /** status 200 ProcurementContract model instance */ ProcurementContract;
export type PostProcurementContractsApiArg = {
  newProcurementContract: NewProcurementContract;
};
export type GetProcurementContractsApiResponse =
  /** status 200 Array of ProcurementContract model instances */ ProcurementContractWithRelations[];
export type GetProcurementContractsApiArg = {
  filter?: any;
};
export type PutProcurementProcessesByIdApiResponse =
  /** status 200 Procurement Process PUT success */ UpdatedProcurementProcess;
export type PutProcurementProcessesByIdApiArg = {
  id: string;
  procurementProcessPartial: ProcurementProcessPartial;
};
export type PatchProcurementProcessesByIdApiResponse = unknown;
export type PatchProcurementProcessesByIdApiArg = {
  id: string;
  procurementProcessPartial: ProcurementProcessPartial;
};
export type GetProcurementProcessesByIdApiResponse =
  /** status 200 Procurement Process model instance */ ProcurementProcessWithRelations;
export type GetProcurementProcessesByIdApiArg = {
  id: string;
};
export type DeleteProcurementProcessesByIdApiResponse = unknown;
export type DeleteProcurementProcessesByIdApiArg = {
  id: string;
};
export type GetProcurementProcessesApiResponse =
  /** status 200 Array of Procurement Process model instances */ ProcurementProcessWithRelations[];
export type GetProcurementProcessesApiArg = {
  currentTask?: string;
  requestType?: string;
  limit?: number;
  skip?: number;
  title?: string;
  approved?: boolean;
  development?: string;
  reqNumber?: string;
  fromDate?: string;
  toDate?: string;
  rejectedBy?: string;
  approvedBy?: string;
  reportByEmail?: boolean;
  reportName?: string;
  procurementOfficer?: string;
  procurementProcessId?: string;
};
export type GetPropertiesApiResponse =
  /** status 200 Array of Property model instances with related Client data */ PropertyWithRelations[];
export type GetPropertiesApiArg = {
  filter?: any;
};
export type PostPropertyApiResponse =
  /** status 200 Create property */ Property;
export type PostPropertyApiArg = {
  propertyData: PropertyData;
};
export type GetProtrackDashboardApiResponse = unknown;
export type GetProtrackDashboardApiArg = void;
export type PatchProtrackHandoversByIdApiResponse = unknown;
export type PatchProtrackHandoversByIdApiArg = {
  id: string;
  proTrackHandoverPartial: ProTrackHandoverPartial;
};
export type GetProtrackHandoversByIdApiResponse =
  /** status 200 ProTrackHandover */ ProTrackHandover;
export type GetProtrackHandoversByIdApiArg = {
  id: string;
};
export type DeleteProtrackHandoversByIdApiResponse = unknown;
export type DeleteProtrackHandoversByIdApiArg = {
  id: string;
};
export type PostProtrackHandoversApiResponse =
  /** status 200 ProTrackHandover */ ProTrackHandover;
export type PostProtrackHandoversApiArg = {
  newProTrackHandover: NewProTrackHandover;
};
export type GetProtrackHandoversApiResponse =
  /** status 200 Array of ProTrackHandover */ ProTrackHandover[];
export type GetProtrackHandoversApiArg = {
  blockId?: string;
  status?: string;
};
export type PatchProtrackMilestonesByIdApiResponse = unknown;
export type PatchProtrackMilestonesByIdApiArg = {
  id: string;
  proTrackMilestonePartial: ProTrackMilestonePartial;
};
export type GetProtrackMilestonesByIdApiResponse =
  /** status 200 ProTrackMilestone */ ProTrackMilestone;
export type GetProtrackMilestonesByIdApiArg = {
  id: string;
};
export type DeleteProtrackMilestonesByIdApiResponse = unknown;
export type DeleteProtrackMilestonesByIdApiArg = {
  id: string;
};
export type PostProtrackMilestonesApiResponse =
  /** status 200 ProTrackMilestone */ ProTrackMilestone;
export type PostProtrackMilestonesApiArg = {
  newProTrackMilestone: NewProTrackMilestone;
};
export type GetProtrackMilestonesApiResponse =
  /** status 200 Array of ProTrackMilestone */ ProTrackMilestone[];
export type GetProtrackMilestonesApiArg = {
  blockId?: string;
};
export type GetProtrackProjectsPortfolioApiResponse = unknown;
export type GetProtrackProjectsPortfolioApiArg = void;
export type PatchProtrackProjectsByIdApiResponse = unknown;
export type PatchProtrackProjectsByIdApiArg = {
  id: string;
  proTrackProjectPartial: ProTrackProjectPartial;
};
export type GetProtrackProjectsByIdApiResponse =
  /** status 200 ProTrackProject */ ProTrackProject;
export type GetProtrackProjectsByIdApiArg = {
  id: string;
};
export type DeleteProtrackProjectsByIdApiResponse = unknown;
export type DeleteProtrackProjectsByIdApiArg = {
  id: string;
};
export type PostProtrackProjectsApiResponse =
  /** status 200 ProTrackProject */ ProTrackProject;
export type PostProtrackProjectsApiArg = {
  newProTrackProject: NewProTrackProject;
};
export type GetProtrackProjectsApiResponse =
  /** status 200 Array of ProTrackProject */ ProTrackProject[];
export type GetProtrackProjectsApiArg = {
  siteId?: string;
  overallStatus?: string;
};
export type PatchProtrackSnagsByIdApiResponse = unknown;
export type PatchProtrackSnagsByIdApiArg = {
  id: string;
  proTrackSnagPartial: ProTrackSnagPartial;
};
export type GetProtrackSnagsByIdApiResponse =
  /** status 200 ProTrackSnag */ ProTrackSnag;
export type GetProtrackSnagsByIdApiArg = {
  id: string;
};
export type DeleteProtrackSnagsByIdApiResponse = unknown;
export type DeleteProtrackSnagsByIdApiArg = {
  id: string;
};
export type PostProtrackSnagsApiResponse =
  /** status 200 ProTrackSnag */ ProTrackSnag;
export type PostProtrackSnagsApiArg = {
  newProTrackSnag: NewProTrackSnag;
};
export type GetProtrackSnagsApiResponse =
  /** status 200 Array of ProTrackSnag */ ProTrackSnag[];
export type GetProtrackSnagsApiArg = {
  blockId?: string;
  status?: string;
};
export type PatchPurchaseOrdersByIdUpdateCodesApiResponse = unknown;
export type PatchPurchaseOrdersByIdUpdateCodesApiArg = {
  id: string;
  body: {
    backOrderItemPatches: {
      description: string;
      itemCode: string;
    }[];
  };
};
export type PatchPurchaseOrdersByIdApiResponse = unknown;
export type PatchPurchaseOrdersByIdApiArg = {
  id: string;
  purchaseOrderPartial: PurchaseOrderPartial;
};
export type GetPurchaseOrdersByIdApiResponse =
  /** status 200 Purchase Order model instance */ PurchaseOrderWithRelations;
export type GetPurchaseOrdersByIdApiArg = {
  id: string;
};
export type DeletePurchaseOrdersByIdApiResponse = unknown;
export type DeletePurchaseOrdersByIdApiArg = {
  id: string;
};
export type GetPurchaseOrdersApiResponse =
  /** status 200 Array of Purchase Order model instances */ PurchaseOrderWithRelations[];
export type GetPurchaseOrdersApiArg = {
  amount?: string;
  title?: string;
  supplierName?: string;
  purchaseOrderNumber?: string;
  reqNumber?: string;
  procurementProcessId?: string;
  development?: string;
  project?: string;
  itemCode?: string;
  currency?: string;
  status?: string;
  latestAction?: string;
  limit?: number;
  skip?: number;
  fromDate?: string;
  toDate?: string;
  backOrder?: boolean;
  detailed?: boolean;
  reportByEmail?: boolean;
  reportName?: string;
};
export type GetQuotationsUploadProgressCountApiResponse =
  /** status 200 QuotationsUploadProgress model count */ LoopbackCount;
export type GetQuotationsUploadProgressCountApiArg = {
  where?: any;
};
export type GetQuotationsUploadProgressByIdApiResponse =
  /** status 200 QuotationsUploadProgress model instance */ QuotationsUploadProgressWithRelations;
export type GetQuotationsUploadProgressByIdApiArg = {
  id: string;
};
export type DeleteQuotationsUploadProgressByIdApiResponse = unknown;
export type DeleteQuotationsUploadProgressByIdApiArg = {
  id: string;
};
export type PostQuotationsUploadProgressApiResponse =
  /** status 200 QuotationsUploadProgress model instance */ QuotationsUploadProgress;
export type PostQuotationsUploadProgressApiArg = {
  newQuotationsUploadProgress: NewQuotationsUploadProgress;
};
export type GetQuotationsUploadProgressApiResponse =
  /** status 200 Array of QuotationsUploadProgress model instances */ QuotationsUploadProgressWithRelations[];
export type GetQuotationsUploadProgressApiArg = {
  reqNumber?: string;
};
export type GetReceiptsNextNumberApiResponse = /** status 200 OK */ any;
export type GetReceiptsNextNumberApiArg = void;
export type PatchReceiptsByIdApiResponse = /** status 204 No Content */ any;
export type PatchReceiptsByIdApiArg = {
  id: string;
  body: object;
};
export type DeleteReceiptsByIdApiResponse = /** status 204 No Content */ any;
export type DeleteReceiptsByIdApiArg = {
  id: string;
};
export type GetReceiptsApiResponse = /** status 200 OK */ any;
export type GetReceiptsApiArg = {
  developmentId?: string;
  startDate?: string;
  endDate?: string;
  receiptType?: string;
  paymentType?: string;
};
export type GetRequisitionByIdApiResponse =
  /** status 200 Requisition model instance */ RequisitionWithRelations;
export type GetRequisitionByIdApiArg = {
  id: string;
};
export type GetRequisitionReviewByIdApiResponse =
  /** status 200 Requisition Review model instance */ RequisitionReviewWithRelations;
export type GetRequisitionReviewByIdApiArg = {
  id: string;
};
export type GetRequisitionReviewsApiResponse =
  /** status 200 Array of RequisitionReview model instances */ RequisitionReviewWithRelations[];
export type GetRequisitionReviewsApiArg = void;
export type GetRequisitionsNewApiResponse =
  /** status 200 Requisitions model instance */ any;
export type GetRequisitionsNewApiArg = {
  site?: string;
};
export type GetRequisitionsApiResponse =
  /** status 200 Array of Requisition model instances */ RequisitionWithRelations[];
export type GetRequisitionsApiArg = void;
export type GetSheqDashboardApiResponse = unknown;
export type GetSheqDashboardApiArg = {
  blockId?: string;
};
export type PatchSheqHealthRecordsByIdApiResponse = unknown;
export type PatchSheqHealthRecordsByIdApiArg = {
  id: string;
  body: object;
};
export type GetSheqHealthRecordsByIdApiResponse = unknown;
export type GetSheqHealthRecordsByIdApiArg = {
  id: string;
};
export type DeleteSheqHealthRecordsByIdApiResponse = unknown;
export type DeleteSheqHealthRecordsByIdApiArg = {
  id: string;
};
export type PostSheqHealthRecordsApiResponse = unknown;
export type PostSheqHealthRecordsApiArg = {
  body: object;
};
export type GetSheqHealthRecordsApiResponse = unknown;
export type GetSheqHealthRecordsApiArg = {
  blockId?: string;
  workerId?: string;
  checkType?: string;
  fitStatus?: string;
  from?: string;
  to?: string;
  followUpRequired?: boolean;
};
export type PatchSheqIncidentsByIdApiResponse = unknown;
export type PatchSheqIncidentsByIdApiArg = {
  id: string;
  body: object;
};
export type GetSheqIncidentsByIdApiResponse = unknown;
export type GetSheqIncidentsByIdApiArg = {
  id: string;
};
export type DeleteSheqIncidentsByIdApiResponse = unknown;
export type DeleteSheqIncidentsByIdApiArg = {
  id: string;
};
export type PostSheqIncidentsApiResponse = unknown;
export type PostSheqIncidentsApiArg = {
  body: object;
};
export type GetSheqIncidentsApiResponse = unknown;
export type GetSheqIncidentsApiArg = {
  blockId?: string;
  status?: string;
  type?: string;
  from?: string;
  to?: string;
};
export type PatchSheqInspectionsByIdApiResponse = unknown;
export type PatchSheqInspectionsByIdApiArg = {
  id: string;
  body: object;
};
export type GetSheqInspectionsByIdApiResponse = unknown;
export type GetSheqInspectionsByIdApiArg = {
  id: string;
};
export type DeleteSheqInspectionsByIdApiResponse = unknown;
export type DeleteSheqInspectionsByIdApiArg = {
  id: string;
};
export type PostSheqInspectionsApiResponse = unknown;
export type PostSheqInspectionsApiArg = {
  body: object;
};
export type GetSheqInspectionsApiResponse = unknown;
export type GetSheqInspectionsApiArg = {
  blockId?: string;
  type?: string;
  outcome?: string;
  from?: string;
  to?: string;
};
export type PatchSheqPpeCatalogueByIdApiResponse = unknown;
export type PatchSheqPpeCatalogueByIdApiArg = {
  id: string;
  body: object;
};
export type DeleteSheqPpeCatalogueByIdApiResponse = unknown;
export type DeleteSheqPpeCatalogueByIdApiArg = {
  id: string;
};
export type PostSheqPpeCatalogueApiResponse = unknown;
export type PostSheqPpeCatalogueApiArg = {
  body: object;
};
export type GetSheqPpeCatalogueApiResponse = unknown;
export type GetSheqPpeCatalogueApiArg = void;
export type PostSheqPpeExpireApiResponse = unknown;
export type PostSheqPpeExpireApiArg = void;
export type PatchSheqPpeRecordsByIdReturnApiResponse = unknown;
export type PatchSheqPpeRecordsByIdReturnApiArg = {
  id: string;
  body: object;
};
export type PatchSheqPpeRecordsByIdApiResponse = unknown;
export type PatchSheqPpeRecordsByIdApiArg = {
  id: string;
  body: object;
};
export type GetSheqPpeRecordsByIdApiResponse = unknown;
export type GetSheqPpeRecordsByIdApiArg = {
  id: string;
};
export type DeleteSheqPpeRecordsByIdApiResponse = unknown;
export type DeleteSheqPpeRecordsByIdApiArg = {
  id: string;
};
export type PostSheqPpeRecordsApiResponse = unknown;
export type PostSheqPpeRecordsApiArg = {
  body: object;
};
export type GetSheqPpeRecordsApiResponse = unknown;
export type GetSheqPpeRecordsApiArg = {
  blockId?: string;
  status?: string;
  workerId?: string;
  from?: string;
  to?: string;
};
export type GetSheqPpeWorkerByWorkerIdHoldingsApiResponse = unknown;
export type GetSheqPpeWorkerByWorkerIdHoldingsApiArg = {
  workerId: string;
};
export type GetSheqReportsExpiringApiResponse = unknown;
export type GetSheqReportsExpiringApiArg = {
  days?: number;
  blockId?: string;
};
export type GetSheqReportsIncidentsSummaryApiResponse = unknown;
export type GetSheqReportsIncidentsSummaryApiArg = {
  from?: string;
  to?: string;
  blockId?: string;
};
export type PatchSheqSopsByIdApiResponse = unknown;
export type PatchSheqSopsByIdApiArg = {
  id: string;
  body: object;
};
export type GetSheqSopsByIdApiResponse = unknown;
export type GetSheqSopsByIdApiArg = {
  id: string;
};
export type DeleteSheqSopsByIdApiResponse = unknown;
export type DeleteSheqSopsByIdApiArg = {
  id: string;
};
export type PostSheqSopsApiResponse = unknown;
export type PostSheqSopsApiArg = {
  body: object;
};
export type GetSheqSopsApiResponse = unknown;
export type GetSheqSopsApiArg = {
  category?: string;
  status?: string;
  blockId?: string;
};
export type PostSpearReviewByIdApproveApiResponse =
  /** status 200 SPEAR Review approved */ EmployeeReview;
export type PostSpearReviewByIdApproveApiArg = {
  id: string;
  body: {
    managerOverallComments?: string;
  };
};
export type PatchSpearReviewByIdGoalStatusApiResponse =
  /** status 200 Goal status updated */ EmployeeReview;
export type PatchSpearReviewByIdGoalStatusApiArg = {
  id: string;
  body: {
    managerStatus: "pending" | "approved" | "disputed";
    managerComment?: string;
  };
};
export type PatchSpearReviewByIdManagerEditApiResponse =
  /** status 200 SPEAR Review manager edit success */ EmployeeReview;
export type PatchSpearReviewByIdManagerEditApiArg = {
  id: string;
  employeeReviewPartialExcludingIdUserIdReviewPeriodCreatedAt: EmployeeReviewPartialExcludingIdUserIdReviewPeriodCreatedAt;
};
export type PostSpearReviewByIdRejectApiResponse =
  /** status 200 SPEAR Review rejected */ EmployeeReview;
export type PostSpearReviewByIdRejectApiArg = {
  id: string;
  body: {
    managerOverallComments: string;
  };
};
export type PostSpearReviewByIdSubmitApiResponse =
  /** status 200 SPEAR Review submitted for approval */ EmployeeReview;
export type PostSpearReviewByIdSubmitApiArg = {
  id: string;
};
export type GetSpearReviewsMyDirectReportsApiResponse =
  /** status 200 Array of SPEAR reviews from direct reports */ EmployeeReviewWithRelations[];
export type GetSpearReviewsMyDirectReportsApiArg = void;
export type GetStakeholdersByTypeByTypeApiResponse =
  /** status 200 Array of Stakeholder model instances filtered by type */ StakeholderWithRelations[];
export type GetStakeholdersByTypeByTypeApiArg = {
  type: string;
};
export type GetStakeholdersCountApiResponse =
  /** status 200 Stakeholder model count */ LoopbackCount;
export type GetStakeholdersCountApiArg = {
  where?: any;
};
export type PatchStakeholdersByIdApiResponse = unknown;
export type PatchStakeholdersByIdApiArg = {
  id: string;
  stakeholderPartial: StakeholderPartial;
};
export type GetStakeholdersByIdApiResponse =
  /** status 200 Stakeholder model instance */ StakeholderWithRelations;
export type GetStakeholdersByIdApiArg = {
  id: string;
};
export type DeleteStakeholdersByIdApiResponse = unknown;
export type DeleteStakeholdersByIdApiArg = {
  id: string;
};
export type PostStakeholdersApiResponse =
  /** status 200 Stakeholder model instance */ Stakeholder;
export type PostStakeholdersApiArg = {
  newStakeholder: NewStakeholder;
};
export type GetStakeholdersApiResponse =
  /** status 200 Array of Stakeholder model instances */ StakeholderWithRelations[];
export type GetStakeholdersApiArg = {
  limit?: number;
  skip?: number;
  name?: string;
  type?: string;
  supplierCode?: string;
  customerCode?: string;
  tin?: string;
  paymentTerms?: string;
  rating?: number;
  latestAction?: string;
  isTaxClearanceValid?: boolean;
  isStakeholderVerified?: boolean;
};
export type PostStatementsBulkSendApiResponse = /** status 200 OK */ any;
export type PostStatementsBulkSendApiArg = {
  body: {
    developmentId?: string;
    fromDate?: string;
    toDate?: string;
  };
};
export type GetStatementsLogsApiResponse = /** status 200 OK */ any;
export type GetStatementsLogsApiArg = {
  debtorId?: string;
  limit?: number;
};
export type PutSupervisorsByIdApiResponse = unknown;
export type PutSupervisorsByIdApiArg = {
  id: string;
  supervisorPartial: SupervisorPartial;
};
export type PatchSupervisorsByIdApiResponse = unknown;
export type PatchSupervisorsByIdApiArg = {
  id: string;
  supervisorPartial: SupervisorPartial;
};
export type DeleteSupervisorsByIdApiResponse = unknown;
export type DeleteSupervisorsByIdApiArg = {
  id: string;
};
export type PostSupervisorsApiResponse =
  /** status 200 Supervisor model instance */ Supervisor;
export type PostSupervisorsApiArg = {
  supervisorData: SupervisorData;
};
export type GetSupervisorsApiResponse =
  /** status 200 Array of Supervisor model instances with related User and Supervisee data */ SupervisorWithRelations[];
export type GetSupervisorsApiArg = {
  filter?: any;
};
export type PostUnitApiResponse = /** status 200 Unit */ Unit;
export type PostUnitApiArg = {
  unitData: UnitData;
};
export type GetUnitsByProjectByProjectIdApiResponse =
  /** status 200 Array of Unit model instances by projectId */ UnitWithRelations[];
export type GetUnitsByProjectByProjectIdApiArg = {
  projectId: string;
  filter?: any;
};
export type GetUnitsCountApiResponse =
  /** status 200 Unit model count */ LoopbackCount;
export type GetUnitsCountApiArg = {
  where?: any;
};
export type PutUnitsByIdApiResponse = unknown;
export type PutUnitsByIdApiArg = {
  id: string;
  unit: Unit;
};
export type PatchUnitsByIdApiResponse = unknown;
export type PatchUnitsByIdApiArg = {
  id: string;
  unitPartial: UnitPartial;
};
export type GetUnitsByIdApiResponse =
  /** status 200 Unit model instance */ UnitWithRelations;
export type GetUnitsByIdApiArg = {
  id: string;
  filter?: any;
};
export type DeleteUnitsByIdApiResponse = unknown;
export type DeleteUnitsByIdApiArg = {
  id: string;
};
export type PatchUnitsApiResponse =
  /** status 200 Unit PATCH success count */ LoopbackCount;
export type PatchUnitsApiArg = {
  where?: any;
  unitPartial: UnitPartial;
};
export type GetUnitsApiResponse =
  /** status 200 Array of Unit model instances */ UnitWithRelations[];
export type GetUnitsApiArg = {
  developmentId?: string;
  projectId?: string;
  unitName?: string;
  limit?: number;
  skip?: number;
};
export type PatchUserByIdApiResponse = unknown;
export type PatchUserByIdApiArg = {
  id: string;
  body: {
    name?: string;
    department?: string;
    roles?: string[];
    isActive?: boolean;
  };
};
export type GetUserByIdApiResponse =
  /** status 200 A specified user user */ User;
export type GetUserByIdApiArg = {
  id: string;
};
export type DeleteUserByIdApiResponse = unknown;
export type DeleteUserByIdApiArg = {
  id: string;
};
export type PostUsersAdminCreateApiResponse =
  /** status 200 User created by admin */ User;
export type PostUsersAdminCreateApiArg = {
  body: {
    email: string;
    name: string;
    password: string;
    department?: string;
    gender: string;
    roles?: string[];
  };
};
export type PostUsersAdminResetPasswordByIdApiResponse =
  /** status 200 Password reset successful */ {
    success?: boolean;
    message?: string;
  };
export type PostUsersAdminResetPasswordByIdApiArg = {
  id: string;
  body: {
    newPassword: string;
  };
};
export type GetUsersCountApiResponse =
  /** status 200 User model count */ LoopbackCount;
export type GetUsersCountApiArg = {
  where?: any;
};
export type PostUsersLoginApiResponse =
  /** status 200 User with tokens (tokens provided for browsers blocking third-party cookies) */ {
    user?: User;
    accessToken?: string;
    refreshToken?: string;
  };
export type PostUsersLoginApiArg = {
  /** The input of login function */
  body: {
    email: string;
    password: string;
  };
};
export type PostUsersLogoutApiResponse = unknown;
export type PostUsersLogoutApiArg = void;
export type GetUsersMeApiResponse = /** status 200 The current user */ User;
export type GetUsersMeApiArg = void;
export type PostUsersRefreshTokenApiResponse =
  /** status 200 New access and refresh tokens */ {
    accessToken?: string;
    refreshToken?: string;
  };
export type PostUsersRefreshTokenApiArg = {
  /** Refresh token request (for browsers blocking third-party cookies) */
  body: {
    refreshToken: string;
  };
};
export type PostUsersResetPasswordApiResponse = /** status 200 User */ User;
export type PostUsersResetPasswordApiArg = {
  /** The input of password reset function */
  body: {
    password: string;
    repeatPassword: string;
  };
};
export type PostUsersApiResponse = /** status 200 User */ User;
export type PostUsersApiArg = {
  userWithPassword: UserWithPassword;
};
export type GetUsersApiResponse = /** status 200 All users */ User[];
export type GetUsersApiArg = void;
export type GetUsersWithReviewsApiResponse =
  /** status 200 Array of users who have submitted an employee review */ User[];
export type GetUsersWithReviewsApiArg = void;
export type GetVatInvoicesCountApiResponse = unknown;
export type GetVatInvoicesCountApiArg = {
  where?: any;
};
export type PatchVatInvoicesByIdApiResponse = unknown;
export type PatchVatInvoicesByIdApiArg = {
  id: string;
  vatInvoicePartial: VatInvoicePartial;
};
export type GetVatInvoicesByIdApiResponse = unknown;
export type GetVatInvoicesByIdApiArg = {
  id: string;
};
export type DeleteVatInvoicesByIdApiResponse = unknown;
export type DeleteVatInvoicesByIdApiArg = {
  id: string;
};
export type PostVatInvoicesApiResponse = unknown;
export type PostVatInvoicesApiArg = {
  newVatInvoice: NewVatInvoice;
};
export type GetVatInvoicesApiResponse = unknown;
export type GetVatInvoicesApiArg = {
  filter?: any;
};
export type GetVatPaymentsCountApiResponse = unknown;
export type GetVatPaymentsCountApiArg = {
  where?: any;
};
export type PatchVatPaymentsByIdApiResponse = unknown;
export type PatchVatPaymentsByIdApiArg = {
  id: string;
  vatPaymentPartial: VatPaymentPartial;
};
export type GetVatPaymentsByIdApiResponse = unknown;
export type GetVatPaymentsByIdApiArg = {
  id: string;
};
export type DeleteVatPaymentsByIdApiResponse = unknown;
export type DeleteVatPaymentsByIdApiArg = {
  id: string;
};
export type PostVatPaymentsApiResponse = unknown;
export type PostVatPaymentsApiArg = {
  newVatPayment: NewVatPayment;
};
export type GetVatPaymentsApiResponse = unknown;
export type GetVatPaymentsApiArg = {
  filter?: any;
};
export type GetVatReturnByVatPeriodApiResponse = /** status 200 OK */ any;
export type GetVatReturnByVatPeriodApiArg = {
  vatPeriod: string;
  developmentId?: string;
};
export type GetVatStatementsClientsApiResponse = /** status 200 OK */ any;
export type GetVatStatementsClientsApiArg = void;
export type GetVatTransactionsByPeriodByVatPeriodApiResponse =
  /** status 200 OK */ any;
export type GetVatTransactionsByPeriodByVatPeriodApiArg = {
  vatPeriod: string;
  developmentId?: string;
};
export type GetVatTransactionsPeriodsApiResponse = /** status 200 OK */ any;
export type GetVatTransactionsPeriodsApiArg = void;
export type PostVatTransactionsApiResponse = /** status 200 OK */ any;
export type PostVatTransactionsApiArg = {
  body: object;
};
export type GetVirtualWarehouseSummaryApiResponse =
  /** status 200 Virtual warehouse totals derived from contract items and their orders */ {
    [key: string]: any;
  };
export type GetVirtualWarehouseSummaryApiArg = {
  contractId?: string;
  contractItemId?: string;
  fromDate?: string;
  toDate?: string;
  currency?: string;
};
export type GetWhoAmIApiResponse = /** status 200 Return current user */ {
  token?: string;
};
export type GetWhoAmIApiArg = void;
export type FeedbackSurveyResponse = {
  questionId: string;
  responseBoolean?: boolean;
  /** Rating from 1 (Very Poor) to 10 (Outstanding) */
  responseRating?: number;
  responseText?: string;
};
export type FeedbackSurveyWithRelations = {
  id?: string;
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
  /** Status of the survey: draft or submitted */
  status?: "draft" | "submitted";
  lastSavedAt?: string;
  responses: FeedbackSurveyResponse[];
};
export type LoopbackCount = {
  count?: number;
};
export type Project = {
  id?: string;
  name: string;
  description?: string;
  status: string;
  startDate?: string;
};
export type DevelopmentWithRelations = {
  id?: string;
  name: string;
  description?: string;
  projects: Project[];
};
export type InventoryLocationWithRelations = {
  id?: string;
  locationCode: string;
  developmentId?: string;
  description?: string;
  development?: DevelopmentWithRelations;
};
export type InventoryLocation = {
  id?: string;
  locationCode: string;
  developmentId?: string;
  description?: string;
};
export type NewInventoryLocation = {
  locationCode: string;
  developmentId?: string;
  description?: string;
};
export type UpdateAccessApplication = {
  id?: string;
  userId?: string;
  purposeOfVisit: string;
  approved?: boolean;
  developmentId?: string;
  proposedDateOfVisit?: string;
  proposedTimeOfVisit?: string;
  proposedTimeToLeave?: string;
  [key: string]: any;
};
export type UserCredentialsWithRelations = {
  id?: string;
  password: string;
  userId: string;
};
export type UserRefreshTokenWithRelations = {
  id?: string;
  ttl: number;
  creation?: string;
  userId: string;
};
export type UserWithRelations = {
  id?: string;
  email?: string;
  name?: string;
  department?: string;
  gender?: string;
  jobTitle?: any;
  idNumber?: any;
  roles?: string[];
  previousToken?: string;
  reportsToUserId?: string | null;
  jobDescriptionId?: string | null;
  grade?: string | null;
  hireDate?: string | null;
  employeeNumber?: string | null;
  isActive?: boolean;
  userCredentials?: UserCredentialsWithRelations;
  userRefreshTokens?: UserRefreshTokenWithRelations[];
};
export type AccessApplicationWithRelations = {
  id?: string;
  userId?: string;
  purposeOfVisit: string;
  approved?: boolean;
  developmentId?: string;
  proposedDateOfVisit?: string;
  proposedTimeOfVisit?: string;
  proposedTimeToLeave?: string;
  user?: UserWithRelations;
  development?: DevelopmentWithRelations;
  [key: string]: any;
};
export type AccessApplication = {
  id?: string;
  userId?: string;
  purposeOfVisit: string;
  approved?: boolean;
  developmentId?: string;
  proposedDateOfVisit?: string;
  proposedTimeOfVisit?: string;
  proposedTimeToLeave?: string;
  [key: string]: any;
};
export type NewAccessApplication = {
  userId?: string;
  purposeOfVisit: string;
  approved?: boolean;
  developmentId?: string;
  proposedDateOfVisit?: string;
  proposedTimeOfVisit?: string;
  proposedTimeToLeave?: string;
  [key: string]: any;
};
export type AccessLogWithRelations = {
  id?: string;
  accessApplication: AccessApplication;
  date: string;
  timeIn: string;
  timeOut?: string;
};
export type AccessLog = {
  id?: string;
  accessApplication: AccessApplication;
  date: string;
  timeIn: string;
  timeOut?: string;
};
export type NewAccessLog = {
  accessApplication: AccessApplication;
  date: string;
  timeIn: string;
  timeOut?: string;
};
export type PerformanceItem = {
  ranking?: number;
  title?: string;
  rating?: string;
  managerRating?: string;
};
export type MonthlyIncentiveGoal = {
  description: string;
  measure?: string;
  targetPercentage?: number;
  actualPercentage?: number;
  completed?: boolean;
  completedAt?: string;
  completedByUserId?: string;
  completedByUserName?: string;
  managerStatus?: "pending" | "approved" | "disputed";
  managerComment?: string;
  managerReviewedAt?: string;
};
export type EmployeeReview = {
  id?: string;
  reviewPeriod: string;
  accomplishments?: PerformanceItem[];
  quarterlyGoals?: PerformanceItem[];
  monthlyGoals?: PerformanceItem[];
  monthlyIncentiveGoal?: MonthlyIncentiveGoal;
  areaToImprove: string;
  quarterlyObjective: string;
  examplesOfExcellence: string;
  mainGoalToAchieve: string;
  turnUpOnTime: boolean;
  dailyCheckIn: boolean;
  reportsOnTime: boolean;
  userId?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  managerId?: string;
  managerName?: string;
  managerOverallComments?: string | null;
  managerAccomplishmentsComments?: string | null;
  managerGoalsComments?: string | null;
  managerEditedAt?: string;
  submittedAt?: string;
  approvedAt?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type EmployeeReviewData = {
  reviewPeriod: string;
  accomplishments?: PerformanceItem[];
  quarterlyGoals?: PerformanceItem[];
  monthlyGoals?: PerformanceItem[];
  monthlyIncentiveGoal?: MonthlyIncentiveGoal;
  areaToImprove: string;
  quarterlyObjective: string;
  examplesOfExcellence: string;
  mainGoalToAchieve: string;
  turnUpOnTime: boolean;
  dailyCheckIn: boolean;
  reportsOnTime: boolean;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  managerId?: string;
  managerName?: string;
  managerOverallComments?: string | null;
  managerAccomplishmentsComments?: string | null;
  managerGoalsComments?: string | null;
  managerEditedAt?: string;
  submittedAt?: string;
  approvedAt?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type Invite = {
  id?: string;
  isPermanentVisitor: boolean;
  visitorName: string;
  visitorEmail: string;
  visitorWhatsApp: string;
  meetingWith?: string;
  meetingDateTime?: string;
  meetingCreatedBy?: string;
  scanned?: boolean;
  idNumber: string;
  idCardImageFilename?: string;
};
export type InviteData = {
  isPermanentVisitor: boolean;
  visitorName: string;
  visitorEmail: string;
  visitorWhatsApp: string;
  meetingWith?: string;
  meetingDateTime?: string;
  meetingCreatedBy?: string;
  scanned?: boolean;
  idNumber: string;
  idCardImageFilename?: string;
};
export type LifeWheelResponse = {
  current: number[];
  desired: number[];
};
export type LifeWheel = {
  id?: string;
  userId: string;
  reviewPeriod: string;
  responses: LifeWheelResponse[];
};
export type LifeWheelData = {
  userId: string;
  reviewPeriod: string;
  responses: LifeWheelResponse[];
};
export type DepositPayment = {
  date: string;
  receiptNumber: string;
  amount: number;
};
export type InstallmentPayment = {
  date?: string;
  paymentAmount?: number;
};
export type Agreement = {
  id?: string;
  clientName: string;
  clientIdNumber: string;
  clientCompanyName?: string;
  clientAddress: string;
  company: any;
  representedBy: any;
  purchasePrice: number;
  unitNumber: string;
  landShare?: string;
  clientDob?: string;
  block?: string;
  paymentsToDate: DepositPayment[];
  vatPaymentOption?: "NO_VAT" | "PART_VAT" | "FULL_VAT";
  vatPaidAmount?: number;
  vatPaidDate?: string;
  firstInstallmentPaymentDate: string;
  lastInstallmentPaymentDate: string;
  numberOfInterestFreeMonths: number;
  installmentPaymentsDue?: InstallmentPayment[];
  remainingAmount?: number;
  remainingAmountWithInterest?: number;
  monthlyCapitalPayment?: number;
  monthlyInstallmentAmount?: number;
  propertyDescription: string;
  unitArea: number;
  chargeInterest: boolean;
  interestRate?: number;
  contractReference: string;
};
export type AgreementData = {
  clientName: string;
  clientIdNumber: string;
  clientCompanyName?: string;
  clientAddress: string;
  company: any;
  representedBy: any;
  purchasePrice: number;
  unitNumber: string;
  landShare?: string;
  clientDob?: string;
  block?: string;
  paymentsToDate: DepositPayment[];
  vatPaymentOption?: "NO_VAT" | "PART_VAT" | "FULL_VAT";
  vatPaidAmount?: number;
  vatPaidDate?: string;
  firstInstallmentPaymentDate: string;
  lastInstallmentPaymentDate: string;
  numberOfInterestFreeMonths: number;
  installmentPaymentsDue?: InstallmentPayment[];
  remainingAmount?: number;
  remainingAmountWithInterest?: number;
  monthlyCapitalPayment?: number;
  monthlyInstallmentAmount?: number;
  propertyDescription: string;
  unitArea: number;
  chargeInterest: boolean;
  interestRate?: number;
  contractReference: string;
};
export type LifeWheelWithRelations = {
  id?: string;
  userId: string;
  reviewPeriod: string;
  responses: LifeWheelResponse[];
};
export type EmployeeReviewWithRelations = {
  id?: string;
  reviewPeriod: string;
  accomplishments?: PerformanceItem[];
  quarterlyGoals?: PerformanceItem[];
  monthlyGoals?: PerformanceItem[];
  monthlyIncentiveGoal?: MonthlyIncentiveGoal;
  areaToImprove: string;
  quarterlyObjective: string;
  examplesOfExcellence: string;
  mainGoalToAchieve: string;
  turnUpOnTime: boolean;
  dailyCheckIn: boolean;
  reportsOnTime: boolean;
  userId?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  managerId?: string;
  managerName?: string;
  managerOverallComments?: string | null;
  managerAccomplishmentsComments?: string | null;
  managerGoalsComments?: string | null;
  managerEditedAt?: string;
  submittedAt?: string;
  approvedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  user?: UserWithRelations;
};
export type BsckraScore = {
  objective: string;
  measure: string;
  weight: number;
  unitOfMeasure: string;
  /** maximize = higher is better (sales), minimize = lower is better (costs) */
  measurementDirection?: "maximize" | "minimize";
  /** Flag for extra duties beyond normal job scope */
  isExtraDuty?: boolean;
  targetValue?: number;
  targetDescription?: string;
  actualValue?: number;
  actualDescription?: string;
  performance?: number;
  score?: number;
  weightedScore?: number;
  managerComments?: string;
  managerAdjustedScore?: number;
};
export type BscPerspectiveScore = {
  name: string;
  weight: number;
  kraScores?: BsckraScore[];
  perspectiveTotal?: number;
};
export type BalancedScorecardWithRelations = {
  id?: string;
  reviewPeriod: string;
  periodType: string;
  employeeId?: string;
  employeeName?: string;
  jobDescriptionId?: string;
  jobDescriptionTitle?: string;
  perspectives?: BscPerspectiveScore[];
  totalWeightedScore?: number;
  rawTotalWeightedScore?: number;
  overallPerformance?: number;
  finalGrade?: string;
  bonusEntitlement?: number;
  status?: string;
  employeeComments?: string;
  managerId?: string;
  managerName?: string;
  managerComments?: string;
  managerAdjustedScore?: number;
  managerAdjustmentNotes?: string;
  submittedAt?: string;
  reviewedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  employee?: UserWithRelations;
};
export type BalancedScorecard = {
  id?: string;
  reviewPeriod: string;
  periodType: string;
  employeeId?: string;
  employeeName?: string;
  jobDescriptionId?: string;
  jobDescriptionTitle?: string;
  perspectives?: BscPerspectiveScore[];
  totalWeightedScore?: number;
  rawTotalWeightedScore?: number;
  overallPerformance?: number;
  finalGrade?: string;
  bonusEntitlement?: number;
  status?: string;
  employeeComments?: string;
  managerId?: string;
  managerName?: string;
  managerComments?: string;
  managerAdjustedScore?: number;
  managerAdjustmentNotes?: string;
  submittedAt?: string;
  reviewedAt?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type BalancedScorecardPartial = {
  id?: string;
  reviewPeriod?: string;
  periodType?: string;
  employeeId?: string;
  employeeName?: string;
  jobDescriptionId?: string;
  jobDescriptionTitle?: string;
  perspectives?: BscPerspectiveScore[];
  totalWeightedScore?: number;
  rawTotalWeightedScore?: number;
  overallPerformance?: number;
  finalGrade?: string;
  bonusEntitlement?: number;
  status?: string;
  employeeComments?: string;
  managerId?: string;
  managerName?: string;
  managerComments?: string;
  managerAdjustedScore?: number;
  managerAdjustmentNotes?: string;
  submittedAt?: string;
  reviewedAt?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewBalancedScorecard = {
  reviewPeriod: string;
  periodType: string;
  employeeId?: string;
  employeeName?: string;
  jobDescriptionId?: string;
  jobDescriptionTitle?: string;
  perspectives?: BscPerspectiveScore[];
  totalWeightedScore?: number;
  rawTotalWeightedScore?: number;
  overallPerformance?: number;
  finalGrade?: string;
  bonusEntitlement?: number;
  status?: string;
  employeeComments?: string;
  managerId?: string;
  managerName?: string;
  managerComments?: string;
  managerAdjustedScore?: number;
  managerAdjustmentNotes?: string;
  submittedAt?: string;
  reviewedAt?: string;
};
export type EntityIdentity = {
  id?: any;
  name?: any;
};
export type Attachment = {
  name: string;
  url: string;
  [key: string]: any;
};
export type BillOfMaterialWithRelations = {
  id?: string;
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalBudget?: number;
};
export type BillOfMaterialPartial = {
  id?: string;
  title?: string;
  development?: EntityIdentity;
  project?: EntityIdentity;
  attachments?: Attachment[];
  active?: boolean;
  totalBudget?: number;
};
export type BillOfMaterial = {
  id?: string;
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalBudget?: number;
};
export type NewBillOfMaterial = {
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalBudget?: number;
};
export type Quantity = {
  quantityValue: any;
  quantityUnit: string;
  [key: string]: any;
};
export type RequisitionItem = {
  description?: string;
  itemCode?: any;
  quantity: Quantity;
  unit?: EntityIdentity;
  procured?: boolean;
  rate?: any;
  totalCostPerItem?: number;
  discountPerItem?: any;
  VAT?: boolean;
  [key: string]: any;
};
export type Quotation = {
  quotationNumber?: any;
  deliveryLeadTime?: any;
  paymentUpfrontPercentage?: any;
  termsAndConditionsTemplate?: any;
  termsAndConditions?: any;
  currency?: any;
  paymentTerms: string;
  remarks: string;
  supplier: EntityIdentity;
  attachments?: Attachment[];
  selected?: any;
  quotationItems?: RequisitionItem[];
  totalVAT?: number;
  totalb4VAT?: number;
  grandTotal?: number;
  totalDiscount?: number;
  [key: string]: any;
};
export type Review = {
  user?: object | null;
  comment?: string | null;
  approved?: boolean | null;
  dateReviewed?: any;
  quotations?: Quotation[];
  [key: string]: any;
};
export type BomItemAuditTrailWithRelations = {
  id?: string;
  bomItemId: string;
  oldBomItem?: object;
  newBomItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type BomItemAuditTrail = {
  id?: string;
  bomItemId: string;
  oldBomItem?: object;
  newBomItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type NewBomItemAuditTrail = {
  bomItemId: string;
  oldBomItem?: object;
  newBomItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type BomItemWithRelations = {
  id?: string;
  bomId: string;
  bomName: string;
  projectName: string;
  projectId?: string;
  developmentName: string;
  developmentId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type BomItem = {
  id?: string;
  bomId: string;
  bomName: string;
  projectName: string;
  projectId?: string;
  developmentName: string;
  developmentId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type NewBomItem = {
  bomId: string;
  bomName: string;
  projectName: string;
  projectId?: string;
  developmentName: string;
  developmentId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type BusinessUnitWithRelations = {
  id?: string;
  name: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;
};
export type BusinessUnitPartial = {
  id?: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;
};
export type BusinessUnit = {
  id?: string;
  name: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;
};
export type NewBusinessUnit = {
  name: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  updatedAt?: string;
};
export type CastingToolEntries = {
  alert?: string;
  curious?: string;
  responsive?: string;
  resourceful?: string;
  faster?: string;
  easier?: string;
  bigger?: string;
  better?: string;
  newCommitment?: string;
  newCourage?: string;
  newCapability?: string;
  newConfidence?: string;
  showUpOnTime?: string;
  doWhatYouSay?: string;
  finishWhatYouStart?: string;
  sayPleaseThankYou?: string;
};
export type CastingTool = {
  id?: string;
  userId: string;
  reviewPeriod: string;
  entries: CastingToolEntries;
  createdAt?: string;
  updatedAt?: string;
};
export type CastingToolPartialExcludingIdUserIdCreatedAt = {
  reviewPeriod?: string;
  entries?: CastingToolEntries;
  updatedAt?: string;
};
export type NewCastingTool = {
  reviewPeriod: string;
  entries: CastingToolEntries;
};
export type Client = {
  id?: string;
  clientName: string;
  clientIdNumber: string;
  clientEmail: string;
};
export type ClientData = {
  clientName: string;
  clientIdNumber: string;
  clientEmail: string;
};
export type ClientWithRelations = {
  id?: string;
  clientName: string;
  clientIdNumber: string;
  clientEmail: string;
};
export type CompetencyLevel = {
  level: number;
  name: string;
  description?: string;
};
export type CompetencyWithRelations = {
  id?: string;
  name: string;
  definition?: string;
  category?: string;
  levels?: CompetencyLevel[];
  isActive?: boolean;
  createdAt?: string;
};
export type CompetencyPartial = {
  id?: string;
  name?: string;
  definition?: string;
  category?: string;
  levels?: CompetencyLevel[];
  isActive?: boolean;
  createdAt?: string;
};
export type Competency = {
  id?: string;
  name: string;
  definition?: string;
  category?: string;
  levels?: CompetencyLevel[];
  isActive?: boolean;
  createdAt?: string;
};
export type NewCompetency = {
  name: string;
  definition?: string;
  category?: string;
  levels?: CompetencyLevel[];
  isActive?: boolean;
};
export type ComsBlockPartial = {
  id?: string;
  code?: string;
  name?: string;
  description?: string;
  development?: string;
  createdAt?: string;
  projectType?: string;
  openingActualCost?: number;
  openingActualCostMaterials?: number;
  openingActualCostLabour?: number;
  openingActualCostEquipment?: number;
  openingActualCostDate?: string;
  openingProfitLoss?: number;
  profitStartingBaseline?: number;
  floatingLabourAllocation?: number;
  floatingLabourNote?: string;
  floatingLabourEntries?: object[];
  pettyCashAllocation?: number;
  pettyCashNote?: string;
  pettyCashEntries?: object[];
};
export type ComsBlock = {
  id?: string;
  code: string;
  name: string;
  description?: string;
  development?: string;
  createdAt?: string;
  projectType?: string;
  openingActualCost?: number;
  openingActualCostMaterials?: number;
  openingActualCostLabour?: number;
  openingActualCostEquipment?: number;
  openingActualCostDate?: string;
  openingProfitLoss?: number;
  profitStartingBaseline?: number;
  floatingLabourAllocation?: number;
  floatingLabourNote?: string;
  floatingLabourEntries?: object[];
  pettyCashAllocation?: number;
  pettyCashNote?: string;
  pettyCashEntries?: object[];
};
export type NewComsBlock = {
  code: string;
  name: string;
  description?: string;
  development?: string;
  createdAt?: string;
  projectType?: string;
  openingActualCost?: number;
  openingActualCostMaterials?: number;
  openingActualCostLabour?: number;
  openingActualCostEquipment?: number;
  openingActualCostDate?: string;
  openingProfitLoss?: number;
  profitStartingBaseline?: number;
  floatingLabourAllocation?: number;
  floatingLabourNote?: string;
  floatingLabourEntries?: object[];
  pettyCashAllocation?: number;
  pettyCashNote?: string;
  pettyCashEntries?: object[];
};
export type ComsCatalogItemPartial = {
  id?: string;
  blockId?: string;
  catalogueType?: string;
  itemCode?: string;
  sharedItemId?: string;
  type?: string;
  name?: string;
  unit?: string;
  defaultRate?: number;
  billNumber?: number;
  plannedQty?: number;
  markComplete?: boolean;
  openingActualQty?: number;
  markCompleteAdjQty?: number;
  displayOrder?: number;
  section?: string;
};
export type ComsCatalogItem = {
  id?: string;
  blockId?: string;
  catalogueType?: string;
  itemCode?: string;
  sharedItemId?: string;
  type: string;
  name: string;
  unit: string;
  defaultRate?: number;
  billNumber?: number;
  plannedQty?: number;
  markComplete?: boolean;
  openingActualQty?: number;
  markCompleteAdjQty?: number;
  displayOrder?: number;
  section?: string;
};
export type NewComsCatalogItem = {
  blockId?: string;
  catalogueType?: string;
  itemCode?: string;
  sharedItemId?: string;
  type: string;
  name: string;
  unit: string;
  defaultRate?: number;
  billNumber?: number;
  plannedQty?: number;
  markComplete?: boolean;
  openingActualQty?: number;
  markCompleteAdjQty?: number;
  displayOrder?: number;
  section?: string;
};
export type ComsMatDelivery = {
  id?: string;
  blockId: string;
  budgetItemId: string;
  deliveryDate: string;
  orderNo?: string;
  qtyReceived?: number;
  isOpeningBalance?: boolean;
};
export type NewComsMatDelivery = {
  blockId: string;
  budgetItemId: string;
  deliveryDate: string;
  orderNo?: string;
  qtyReceived?: number;
  isOpeningBalance?: boolean;
};
export type ComsMonthlyReportRecord = {
  id?: string;
  blockId: string;
  monthStart: string;
  monthEnd: string;
  monthLabel?: string;
  status?: string;
  workDone?: object[];
  materialsUsed?: object[];
  dailyLabour?: object[];
  dailyEquipment?: object[];
  periodWorkDoneTotal?: number;
  periodMaterials?: number;
  periodLabour?: number;
  periodEquipment?: number;
  periodRevenue?: number;
  periodProfitLoss?: number;
  reportsCount?: number;
  bac?: number;
  ev?: number;
  ac?: number;
  cv?: number;
  cpi?: number;
  eac?: number;
  vac?: number;
  tcpi?: number;
  evmNarrative?: string;
  reviewTrail?: object[];
  createdAt?: string;
  [key: string]: any;
};
export type ComsDailyReportPartial = {
  id?: string;
  blockId?: string;
  reportDate?: string;
  notes?: string;
  activities?: object[];
  materials?: object[];
  labour?: object[];
  equipment?: object[];
  [key: string]: any;
};
export type ComsDailyReport = {
  id?: string;
  blockId: string;
  reportDate: string;
  notes?: string;
  activities?: object[];
  materials?: object[];
  labour?: object[];
  equipment?: object[];
  [key: string]: any;
};
export type NewComsDailyReport = {
  blockId: string;
  reportDate: string;
  notes?: string;
  activities?: object[];
  materials?: object[];
  labour?: object[];
  equipment?: object[];
  [key: string]: any;
};
export type ComsWeeklyReport = {
  id?: string;
  blockId: string;
  weekStart: string;
  weekEnd: string;
  status?: string;
  workDone?: object[];
  materialsUsed?: object[];
  dailyLabour?: object[];
  dailyEquipment?: object[];
  periodWorkDoneTotal?: number;
  periodMaterials?: number;
  periodLabour?: number;
  periodEquipment?: number;
  periodRevenue?: number;
  periodProfitLoss?: number;
  bac?: number;
  ev?: number;
  ac?: number;
  cv?: number;
  cpi?: number;
  eac?: number;
  vac?: number;
  tcpi?: number;
  evmNarrative?: string;
  reviewTrail?: object[];
  actions?: object[];
  createdAt?: string;
  [key: string]: any;
};
export type ContractItemAuditTrailWithRelations = {
  id?: string;
  contractItemId: string;
  oldContractItem?: object;
  newContractItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type ContractItemAuditTrail = {
  id?: string;
  contractItemId: string;
  oldContractItem?: object;
  newContractItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type NewContractItemAuditTrail = {
  contractItemId: string;
  oldContractItem?: object;
  newContractItem: object;
  auditTrigger?: string;
  purchaseOrderNumber?: string;
  firstApproval?: Review;
  secondApproval?: Review;
  user?: object;
  attachments?: Attachment[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type ContractItemWithRelations = {
  id?: string;
  contractId: string;
  contractName: string;
  supplierName: string;
  supplierId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type ContractItem = {
  id?: string;
  contractId: string;
  contractName: string;
  supplierName: string;
  supplierId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type NewContractItem = {
  contractId: string;
  contractName: string;
  supplierName: string;
  supplierId?: string;
  itemCode: string;
  isService: boolean;
  isVAT?: boolean;
  itemDescription: string;
  itemUnit: string;
  itemBudgetedCost: number;
  itemQuantity: number;
  itemCurrentValue: number;
  initialQuantity: number;
  itemInitialValue: number;
  procuredQuantity?: number;
  procuredValue?: number;
  user?: object;
  isApproved?: boolean;
  firstApproval?: Review;
  secondApproval?: Review;
  [key: string]: any;
};
export type NewGrv = {
  purchaseOrderId?: string;
  procurementProcessId?: string;
  date?: string;
  grvNumber?: string;
  grvDetails?: Quotation;
  status: boolean;
};
export type Requisition = {
  id?: string;
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  totalCost?: number;
  reqNumber: string;
  approved?: boolean;
  items: RequisitionItem[];
  documents?: Attachment[];
};
export type User = {
  id?: string;
  email?: string;
  name?: string;
  department?: string;
  gender?: string;
  jobTitle?: any;
  idNumber?: any;
  roles?: string[];
  previousToken?: string;
  reportsToUserId?: string | null;
  jobDescriptionId?: string | null;
  grade?: string | null;
  hireDate?: string | null;
  employeeNumber?: string | null;
  isActive?: boolean;
};
export type NewProcurementProcess = {
  currentTask: string;
  currentTaskOwner: string;
  previousTask: string;
  initiatedDate: string;
  lastActionedDate: string;
  status: string;
  requestType?: string;
  requisition: Requisition;
  siteManagerReview?: Review;
  projectManagerReview?: Review;
  cpoReview?: Review;
  pcReview?: Review;
  pmReview?: Review;
  proChairReview?: Review;
  projAdminReview?: Review;
  cfoReview?: Review;
  cooReview?: Review;
  ceoReview?: Review;
  pcToUploadQuotations?: Review;
  initiatedByUser?: User;
  requisitionDocument?: Attachment;
  purchaseOrderDocument?: Attachment;
  splitPurchaseOrder?: any;
  priority?: "Standard" | "Urgent" | "Critical";
  urgentMarkedBy?: User;
  urgentMarkedAt?: string;
};
export type Action = {
  user: {
    id?: string;
    email?: string;
    name?: string;
    department?: string;
    gender?: string;
    jobTitle?: string;
    roles?: string[];
  };
  requestedAction?: string;
  createdAt: any;
  [key: string]: any;
};
export type Note = {
  comment?: string;
  attachments?: Attachment[];
  action: Action;
  isTaxClearance: boolean;
  taxClearanceExpiryDate?: any;
  [key: string]: any;
};
export type NewPurchaseOrder = {
  procurementProcessId?: string;
  title: string;
  date: string;
  quotation: Quotation;
  purchaseOrderNumber: string;
  reqNumber: string;
  development: string;
  project: string;
  status: string;
  expectedDeliveryDate: any;
  itemsReceived?: RequisitionItem[];
  backOrderItems?: RequisitionItem[];
  paid: number;
  balance: number;
  fullFilledValue: number;
  backOrderValue: number;
  bomSavings?: number;
  contractVariance?: number;
  procurementOfficerName?: string;
  procurementOfficer?: object;
  paymentStatus?: string;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  statusModified?: Action;
};
export type RequisitionData = {
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  totalCost?: number;
  reqNumber: string;
  approved?: boolean;
  items: RequisitionItem[];
  documents?: Attachment[];
};
export type Comment = {
  user?: object;
  comment: string;
};
export type RequisitionReview = {
  id?: string;
  comment: Comment;
  approved: boolean;
};
export type RequisitionReviewData = {
  comment: Comment;
  approved: boolean;
};
export type CreditorPartial = {
  id?: string;
  developmentId?: string;
  developmentName?: string;
  fullName?: string;
  contactPhone?: string;
  email?: string;
  contactPerson?: string;
  address?: string;
  vatNumber?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  paymentTerms?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalPaid?: number;
  balanceDue?: number;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type CreditorInvoiceWithRelations = {
  id?: string;
  creditorId: string;
  developmentId?: string;
  invoiceNo: string;
  invoiceDate: string;
  dueDate?: string;
  description?: string;
  amountExcl?: number;
  vatRate?: number;
  vatAmount?: number;
  amountIncl: number;
  status?: "pending" | "partial" | "paid" | "overdue" | "cancelled";
  amountPaid?: number;
  outstanding?: number;
  reference?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type CreditorPaymentWithRelations = {
  id?: string;
  creditorId: string;
  developmentId?: string;
  paymentDate: string;
  paymentNo?: string;
  amount: number;
  paymentMethod?: "bank" | "cash" | "ecocash" | "cheque" | "rtgs";
  reference?: string;
  invoiceId?: string;
  notes?: string;
  createdBy?: string;
  voided?: boolean;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type CreditorWithRelations = {
  id?: string;
  developmentId?: string;
  developmentName?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  contactPerson?: string;
  address?: string;
  vatNumber?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  paymentTerms?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalPaid?: number;
  balanceDue?: number;
  createdAt?: string;
  updatedAt?: string;
  invoices?: CreditorInvoiceWithRelations[];
  payments?: CreditorPaymentWithRelations[];
  [key: string]: any;
};
export type Creditor = {
  id?: string;
  developmentId?: string;
  developmentName?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  contactPerson?: string;
  address?: string;
  vatNumber?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  paymentTerms?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalPaid?: number;
  balanceDue?: number;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type NewCreditor = {
  developmentId?: string;
  developmentName?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  contactPerson?: string;
  address?: string;
  vatNumber?: string;
  bankName?: string;
  bankAccountNumber?: string;
  bankBranchCode?: string;
  paymentTerms?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalPaid?: number;
  balanceDue?: number;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type WidgetPosition = {
  x: number;
  y: number;
  width: number;
  height: number;
  [key: string]: any;
};
export type WidgetDisplayOptions = {
  showLegend?: boolean;
  colorScheme?: string;
  decimalPlaces?: number;
  prefix?: string;
  suffix?: string;
  backgroundColor?: string;
  textColor?: string;
  [key: string]: any;
};
export type WidgetConfig = {
  metric?: string;
  aggregation?: "sum" | "avg" | "count" | "min" | "max";
  groupBy?: string;
  filters?: object;
  limit?: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  unit?: string;
  displayOptions?: WidgetDisplayOptions;
  [key: string]: any;
};
export type DashboardWidget = {
  id: string;
  name: string;
  type:
    | "scorecard"
    | "piechart"
    | "linegraph"
    | "bargraph"
    | "table"
    | "gauge"
    | "areachart"
    | "donutchart";
  position: WidgetPosition;
  dataSource: string;
  config: WidgetConfig;
  description?: string;
  [key: string]: any;
};
export type DashboardPermissions = {
  roles?: string[];
  users?: string[];
  [key: string]: any;
};
export type DashboardMetadata = {
  tags?: string[];
  icon?: string;
  color?: string;
  category?: string;
  [key: string]: any;
};
export type ViewSettings = {
  /** Font size multiplier (1 = 100%) */
  fontSize?: number;
  /** Default time frame for data queries */
  defaultTimeFrame?:
    | "this_month"
    | "last_month"
    | "this_quarter"
    | "last_quarter"
    | "this_year"
    | "last_year"
    | "last_30_days"
    | "last_90_days"
    | "year_to_date"
    | "all_time";
  [key: string]: any;
};
export type Dashboard = {
  id?: string;
  name: string;
  description?: string;
  layoutId: string;
  widgets?: DashboardWidget[];
  refreshInterval: number;
  isPublished?: boolean;
  createdBy: string;
  permissions: DashboardPermissions;
  metadata?: DashboardMetadata;
  viewSettings?: ViewSettings;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type DashboardPartialExcludingIdCreatedAtCreatedBy = {
  name?: string;
  description?: string;
  layoutId?: string;
  widgets?: DashboardWidget[];
  refreshInterval?: number;
  isPublished?: boolean;
  permissions?: DashboardPermissions;
  metadata?: DashboardMetadata;
  viewSettings?: ViewSettings;
  updatedAt?: string;
  [key: string]: any;
};
export type NewDashboard = {
  name: string;
  description?: string;
  layoutId: string;
  widgets?: DashboardWidget[];
  refreshInterval: number;
  isPublished?: boolean;
  permissions: DashboardPermissions;
  metadata?: DashboardMetadata;
  viewSettings?: ViewSettings;
  [key: string]: any;
};
export type DebtorPartial = {
  id?: string;
  developmentId?: string;
  developmentName?: string;
  unitRef?: string;
  fullName?: string;
  contactPhone?: string;
  email?: string;
  secondaryEmail?: string;
  tertiaryEmail?: string;
  idNumber?: string;
  propertyType?: "Residential" | "Commercial" | "Industrial" | "Land" | "Other";
  purchasePrice?: number;
  depositPaid?: number;
  monthlyInstalment?: number;
  interestRate?: number;
  firstPaymentDate?: string;
  salesRep?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalReceipts?: number;
  balance?: number;
  createdAt?: string;
  updatedAt?: string;
  markedForAging?: boolean;
  markedForAgingAt?: string;
  ageRemarks?: string;
  [key: string]: any;
};
export type DebtorInvoiceWithRelations = {
  id?: string;
  debtorId: string;
  developmentId?: string;
  invoiceNo: string;
  invoiceDate: string;
  dueDate?: string;
  description?: string;
  amountExcl?: number;
  vatRate?: number;
  vatAmount?: number;
  amountIncl: number;
  status?: "pending" | "partial" | "paid" | "overdue" | "cancelled";
  amountPaid?: number;
  outstanding?: number;
  reference?: string;
  createdAt?: string;
  updatedAt?: string;
  invoiceType?: "installment" | "interest" | "vat" | "other";
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  lastReceiptId?: string;
  lastReceiptNo?: string;
  createdBy?: string;
  [key: string]: any;
};
export type ReceiptWithRelations = {
  id?: string;
  debtorId: string;
  developmentId?: string;
  receiptDate: string;
  receiptNo: string;
  amount: number;
  receiptType?: "payment" | "vat";
  vatAmount?: number;
  allocation?: string;
  cashbook?: "bank" | "cash" | "ecocash" | "swipe";
  reference?: string;
  notes?: string;
  paymentType?: "installment" | "interest" | "vat" | "other";
  createdBy?: string;
  voided?: boolean;
  voidedAt?: string;
  voidedBy?: string;
  createdAt?: string;
  updatedAt?: string;
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  [key: string]: any;
};
export type AmortisationScheduleWithRelations = {
  id?: string;
  debtorId: string;
  periodDate: string;
  instalment: number;
  interest?: number;
  principal?: number;
  openingBalance: number;
  closingBalance: number;
  paid?: boolean;
  amountPaid?: number;
  paidDate?: string;
  receiptId?: string;
  receiptNo?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
};
export type DebtorWithRelations = {
  id?: string;
  developmentId: string;
  developmentName?: string;
  unitRef?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  secondaryEmail?: string;
  tertiaryEmail?: string;
  idNumber?: string;
  propertyType?: "Residential" | "Commercial" | "Industrial" | "Land" | "Other";
  purchasePrice?: number;
  depositPaid?: number;
  monthlyInstalment?: number;
  interestRate?: number;
  firstPaymentDate?: string;
  salesRep?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalReceipts?: number;
  balance?: number;
  createdAt?: string;
  updatedAt?: string;
  markedForAging?: boolean;
  markedForAgingAt?: string;
  ageRemarks?: string;
  invoices?: DebtorInvoiceWithRelations[];
  receipts?: ReceiptWithRelations[];
  amortisationSchedule?: AmortisationScheduleWithRelations[];
  [key: string]: any;
};
export type Debtor = {
  id?: string;
  developmentId: string;
  developmentName?: string;
  unitRef?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  secondaryEmail?: string;
  tertiaryEmail?: string;
  idNumber?: string;
  propertyType?: "Residential" | "Commercial" | "Industrial" | "Land" | "Other";
  purchasePrice?: number;
  depositPaid?: number;
  monthlyInstalment?: number;
  interestRate?: number;
  firstPaymentDate?: string;
  salesRep?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalReceipts?: number;
  balance?: number;
  createdAt?: string;
  updatedAt?: string;
  markedForAging?: boolean;
  markedForAgingAt?: string;
  ageRemarks?: string;
  [key: string]: any;
};
export type NewDebtor = {
  developmentId: string;
  developmentName?: string;
  unitRef?: string;
  fullName: string;
  contactPhone?: string;
  email?: string;
  secondaryEmail?: string;
  tertiaryEmail?: string;
  idNumber?: string;
  propertyType?: "Residential" | "Commercial" | "Industrial" | "Land" | "Other";
  purchasePrice?: number;
  depositPaid?: number;
  monthlyInstalment?: number;
  interestRate?: number;
  firstPaymentDate?: string;
  salesRep?: string;
  notes?: string;
  active?: boolean;
  totalInvoiced?: number;
  totalReceipts?: number;
  balance?: number;
  createdAt?: string;
  updatedAt?: string;
  markedForAging?: boolean;
  markedForAgingAt?: string;
  ageRemarks?: string;
  [key: string]: any;
};
export type Development = {
  id?: string;
  name: string;
  description?: string;
  projects: Project[];
};
export type DevelopmentData = {
  name: string;
  description?: string;
  projects: Project[];
};
export type DevelopmentPartial = {
  id?: string;
  name?: string;
  description?: string;
  projects?: Project[];
};
export type EmployeeReviewPartial = {
  id?: string;
  reviewPeriod?: string;
  accomplishments?: PerformanceItem[];
  quarterlyGoals?: PerformanceItem[];
  monthlyGoals?: PerformanceItem[];
  monthlyIncentiveGoal?: MonthlyIncentiveGoal;
  areaToImprove?: string;
  quarterlyObjective?: string;
  examplesOfExcellence?: string;
  mainGoalToAchieve?: string;
  turnUpOnTime?: boolean;
  dailyCheckIn?: boolean;
  reportsOnTime?: boolean;
  userId?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  managerId?: string;
  managerName?: string;
  managerOverallComments?: string | null;
  managerAccomplishmentsComments?: string | null;
  managerGoalsComments?: string | null;
  managerEditedAt?: string;
  submittedAt?: string;
  approvedAt?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ExternalItemMapWithRelations = {
  id?: string;
  itemCode?: string;
  externalItemCode: string;
  description?: string;
  externalDescription: string;
  quantityUnit?: string;
  externalQuantityUnit: string;
};
export type FeedbackSurveyDraft = {
  id?: string;
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
  /** Status of the survey: draft or submitted */
  status?: "draft" | "submitted";
  lastSavedAt?: string;
  responses: FeedbackSurveyResponse[];
};
export type FeedbackSurveyDraftData = {
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
  /** Status of the survey: draft or submitted */
  status?: "draft" | "submitted";
  lastSavedAt?: string;
  responses: FeedbackSurveyResponse[];
};
export type FeedbackSurvey = {
  id?: string;
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
  /** Status of the survey: draft or submitted */
  status?: "draft" | "submitted";
  lastSavedAt?: string;
  responses: FeedbackSurveyResponse[];
};
export type FeedbackSurveyData = {
  userId: string;
  reviewerId: string;
  reviewPeriod: string;
  /** Status of the survey: draft or submitted */
  status?: "draft" | "submitted";
  lastSavedAt?: string;
  responses: FeedbackSurveyResponse[];
};
export type AccountPartial = {
  id?: string;
  accountCode?: string;
  accountName?: string;
  accountType?: "Asset" | "Liability" | "Equity" | "Revenue" | "Expense";
  accountSubType?:
    | "Current Asset"
    | "Fixed Asset"
    | "Current Liability"
    | "Long-term Liability"
    | "Operating Revenue"
    | "Other Revenue"
    | "Operating Expense"
    | "Administrative Expense"
    | "Retained Earnings"
    | "Capital";
  description?: string;
  parentAccountId?: string;
  balance?: number;
  currency?: string;
  isActive?: boolean;
  isSystemAccount?: boolean;
  department?: string;
  dateCreated?: string;
  lastUpdated?: string;
  createdBy?: string;
};
export type Account = {
  id?: string;
  accountCode: string;
  accountName: string;
  accountType: "Asset" | "Liability" | "Equity" | "Revenue" | "Expense";
  accountSubType?:
    | "Current Asset"
    | "Fixed Asset"
    | "Current Liability"
    | "Long-term Liability"
    | "Operating Revenue"
    | "Other Revenue"
    | "Operating Expense"
    | "Administrative Expense"
    | "Retained Earnings"
    | "Capital";
  description?: string;
  parentAccountId?: string;
  balance?: number;
  currency: string;
  isActive?: boolean;
  isSystemAccount?: boolean;
  department: string;
  dateCreated: string;
  lastUpdated: string;
  createdBy?: string;
};
export type NewAccount = {
  accountCode: string;
  accountName: string;
  accountType: "Asset" | "Liability" | "Equity" | "Revenue" | "Expense";
  accountSubType?:
    | "Current Asset"
    | "Fixed Asset"
    | "Current Liability"
    | "Long-term Liability"
    | "Operating Revenue"
    | "Other Revenue"
    | "Operating Expense"
    | "Administrative Expense"
    | "Retained Earnings"
    | "Capital";
  description?: string;
  parentAccountId?: string;
  balance?: number;
  currency: string;
  isActive?: boolean;
  isSystemAccount?: boolean;
  department: string;
  dateCreated: string;
  lastUpdated: string;
  createdBy?: string;
};
export type BudgetAllocation = {
  accountId: string;
  accountCode: string;
  accountName: string;
  category?: string;
  allocatedAmount: number;
  spentAmount?: number;
  committedAmount?: number;
  notes?: string;
};
export type BudgetRevision = {
  revisionDate: string;
  previousAmount: number;
  newAmount: number;
  reason: string;
  revisedBy?: User;
};
export type Budget = {
  id?: string;
  budgetCode: string;
  name: string;
  description?: string;
  budgetType: "Annual" | "Quarterly" | "Monthly" | "Project" | "Department";
  fiscalYear: string;
  fiscalPeriod?: string;
  department: string;
  project?: string;
  development?: string;
  totalAmount: number;
  allocatedAmount?: number;
  spentAmount?: number;
  committedAmount?: number;
  remainingAmount?: number;
  currency: string;
  startDate: string;
  endDate: string;
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Active"
    | "Frozen"
    | "Closed"
    | "Cancelled";
  allocations?: BudgetAllocation[];
  revisions?: BudgetRevision[];
  preparedBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  dateCreated: string;
  lastUpdated: string;
  notes?: string;
};
export type BudgetPartial = {
  id?: string;
  budgetCode?: string;
  name?: string;
  description?: string;
  budgetType?: "Annual" | "Quarterly" | "Monthly" | "Project" | "Department";
  fiscalYear?: string;
  fiscalPeriod?: string;
  department?: string;
  project?: string;
  development?: string;
  totalAmount?: number;
  allocatedAmount?: number;
  spentAmount?: number;
  committedAmount?: number;
  remainingAmount?: number;
  currency?: string;
  startDate?: string;
  endDate?: string;
  status?:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Active"
    | "Frozen"
    | "Closed"
    | "Cancelled";
  allocations?: BudgetAllocation[];
  revisions?: BudgetRevision[];
  preparedBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  dateCreated?: string;
  lastUpdated?: string;
  notes?: string;
};
export type NewBudget = {
  budgetCode: string;
  name: string;
  description?: string;
  budgetType: "Annual" | "Quarterly" | "Monthly" | "Project" | "Department";
  fiscalYear: string;
  fiscalPeriod?: string;
  department: string;
  project?: string;
  development?: string;
  totalAmount: number;
  allocatedAmount?: number;
  spentAmount?: number;
  committedAmount?: number;
  remainingAmount?: number;
  currency: string;
  startDate: string;
  endDate: string;
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Active"
    | "Frozen"
    | "Closed"
    | "Cancelled";
  allocations?: BudgetAllocation[];
  revisions?: BudgetRevision[];
  preparedBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  dateCreated: string;
  lastUpdated: string;
  notes?: string;
};
export type ExpenseItem = {
  expenseDate: string;
  category: string;
  description: string;
  vendor?: string;
  receiptNumber?: string;
  amount: number;
  currency: string;
  exchangeRate?: number;
  convertedAmount?: number;
  accountCode?: string;
  isBillable?: boolean;
  projectCode?: string;
  receipt?: Attachment;
  notes?: string;
};
export type ExpenseReport = {
  id?: string;
  reportNumber: string;
  title: string;
  description?: string;
  reportType:
    | "Travel"
    | "Entertainment"
    | "Office Supplies"
    | "Equipment"
    | "Training"
    | "Meals"
    | "Transportation"
    | "Accommodation"
    | "Other";
  submittedBy: User;
  employeeId: string;
  department: string;
  baseCurrency: string;
  totalAmount: number;
  approvedAmount?: number;
  reimbursedAmount?: number;
  advanceReceived?: number;
  balanceDue?: number;
  periodStart: string;
  periodEnd: string;
  status:
    | "Draft"
    | "Submitted"
    | "Under Review"
    | "Approved"
    | "Rejected"
    | "Processing"
    | "Reimbursed"
    | "Cancelled";
  project?: string;
  development?: string;
  budgetId?: string;
  costCenter?: string;
  expenses?: ExpenseItem[];
  attachments?: Attachment[];
  paymentMethod?: string;
  bankAccount?: string;
  reimbursementDate?: string;
  paymentReference?: string;
  reviewedBy?: User;
  reviewedDate?: string;
  approvedBy?: User;
  approvalDate?: string;
  rejectionReason?: string;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type ExpenseReportPartial = {
  id?: string;
  reportNumber?: string;
  title?: string;
  description?: string;
  reportType?:
    | "Travel"
    | "Entertainment"
    | "Office Supplies"
    | "Equipment"
    | "Training"
    | "Meals"
    | "Transportation"
    | "Accommodation"
    | "Other";
  submittedBy?: User;
  employeeId?: string;
  department?: string;
  baseCurrency?: string;
  totalAmount?: number;
  approvedAmount?: number;
  reimbursedAmount?: number;
  advanceReceived?: number;
  balanceDue?: number;
  periodStart?: string;
  periodEnd?: string;
  status?:
    | "Draft"
    | "Submitted"
    | "Under Review"
    | "Approved"
    | "Rejected"
    | "Processing"
    | "Reimbursed"
    | "Cancelled";
  project?: string;
  development?: string;
  budgetId?: string;
  costCenter?: string;
  expenses?: ExpenseItem[];
  attachments?: Attachment[];
  paymentMethod?: string;
  bankAccount?: string;
  reimbursementDate?: string;
  paymentReference?: string;
  reviewedBy?: User;
  reviewedDate?: string;
  approvedBy?: User;
  approvalDate?: string;
  rejectionReason?: string;
  notes?: string;
  dateCreated?: string;
  lastUpdated?: string;
};
export type NewExpenseReport = {
  reportNumber: string;
  title: string;
  description?: string;
  reportType:
    | "Travel"
    | "Entertainment"
    | "Office Supplies"
    | "Equipment"
    | "Training"
    | "Meals"
    | "Transportation"
    | "Accommodation"
    | "Other";
  submittedBy: User;
  employeeId: string;
  department: string;
  baseCurrency: string;
  totalAmount: number;
  approvedAmount?: number;
  reimbursedAmount?: number;
  advanceReceived?: number;
  balanceDue?: number;
  periodStart: string;
  periodEnd: string;
  status:
    | "Draft"
    | "Submitted"
    | "Under Review"
    | "Approved"
    | "Rejected"
    | "Processing"
    | "Reimbursed"
    | "Cancelled";
  project?: string;
  development?: string;
  budgetId?: string;
  costCenter?: string;
  expenses?: ExpenseItem[];
  attachments?: Attachment[];
  paymentMethod?: string;
  bankAccount?: string;
  reimbursementDate?: string;
  paymentReference?: string;
  reviewedBy?: User;
  reviewedDate?: string;
  approvedBy?: User;
  approvalDate?: string;
  rejectionReason?: string;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type InvoiceLineItem = {
  description: string;
  quantity: number;
  unit?: string;
  unitPrice: number;
  discount?: number;
  taxRate?: number;
  taxAmount?: number;
  lineTotal: number;
  accountCode?: string;
  budgetId?: string;
};
export type InvoicePayment = {
  paymentDate: string;
  amount: number;
  paymentMethod: string;
  referenceNumber?: string;
  notes?: string;
  recordedBy?: User;
};
export type Invoice = {
  id?: string;
  invoiceNumber: string;
  invoiceType: "Payable" | "Receivable";
  externalInvoiceNumber?: string;
  purchaseOrderId?: string;
  purchaseOrderNumber?: string;
  partyName: string;
  partyId?: string;
  partyEmail?: string;
  partyPhone?: string;
  partyAddress?: string;
  partyTaxId?: string;
  currency: string;
  exchangeRate?: number;
  subtotal: number;
  discountAmount?: number;
  taxAmount?: number;
  totalAmount: number;
  paidAmount?: number;
  balanceDue?: number;
  invoiceDate: string;
  dueDate: string;
  paymentTermsDays?: number;
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Sent"
    | "Partially Paid"
    | "Paid"
    | "Overdue"
    | "Cancelled"
    | "Disputed";
  department: string;
  project?: string;
  development?: string;
  budgetId?: string;
  lineItems?: InvoiceLineItem[];
  payments?: InvoicePayment[];
  attachments?: Attachment[];
  createdBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type InvoicePartial = {
  id?: string;
  invoiceNumber?: string;
  invoiceType?: "Payable" | "Receivable";
  externalInvoiceNumber?: string;
  purchaseOrderId?: string;
  purchaseOrderNumber?: string;
  partyName?: string;
  partyId?: string;
  partyEmail?: string;
  partyPhone?: string;
  partyAddress?: string;
  partyTaxId?: string;
  currency?: string;
  exchangeRate?: number;
  subtotal?: number;
  discountAmount?: number;
  taxAmount?: number;
  totalAmount?: number;
  paidAmount?: number;
  balanceDue?: number;
  invoiceDate?: string;
  dueDate?: string;
  paymentTermsDays?: number;
  status?:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Sent"
    | "Partially Paid"
    | "Paid"
    | "Overdue"
    | "Cancelled"
    | "Disputed";
  department?: string;
  project?: string;
  development?: string;
  budgetId?: string;
  lineItems?: InvoiceLineItem[];
  payments?: InvoicePayment[];
  attachments?: Attachment[];
  createdBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  notes?: string;
  dateCreated?: string;
  lastUpdated?: string;
};
export type NewInvoice = {
  invoiceNumber: string;
  invoiceType: "Payable" | "Receivable";
  externalInvoiceNumber?: string;
  purchaseOrderId?: string;
  purchaseOrderNumber?: string;
  partyName: string;
  partyId?: string;
  partyEmail?: string;
  partyPhone?: string;
  partyAddress?: string;
  partyTaxId?: string;
  currency: string;
  exchangeRate?: number;
  subtotal: number;
  discountAmount?: number;
  taxAmount?: number;
  totalAmount: number;
  paidAmount?: number;
  balanceDue?: number;
  invoiceDate: string;
  dueDate: string;
  paymentTermsDays?: number;
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Sent"
    | "Partially Paid"
    | "Paid"
    | "Overdue"
    | "Cancelled"
    | "Disputed";
  department: string;
  project?: string;
  development?: string;
  budgetId?: string;
  lineItems?: InvoiceLineItem[];
  payments?: InvoicePayment[];
  attachments?: Attachment[];
  createdBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type JournalEntryLine = {
  accountId: string;
  accountCode: string;
  accountName: string;
  entryType: "Debit" | "Credit";
  amount: number;
  description?: string;
  costCenter?: string;
};
export type FinancialTransaction = {
  id?: string;
  transactionNumber: string;
  transactionType:
    | "Journal Entry"
    | "Payment"
    | "Receipt"
    | "Transfer"
    | "Adjustment"
    | "Accrual"
    | "Reversal";
  category?:
    | "Invoice Payment"
    | "Expense"
    | "Revenue"
    | "Asset Purchase"
    | "Payroll"
    | "Tax"
    | "Bank Transfer"
    | "Depreciation"
    | "Opening Balance"
    | "Other";
  transactionDate: string;
  fiscalYear?: string;
  fiscalPeriod?: string;
  description: string;
  referenceType?: string;
  referenceId?: string;
  referenceNumber?: string;
  currency: string;
  exchangeRate?: number;
  totalDebit: number;
  totalCredit: number;
  entries?: JournalEntryLine[];
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Posted"
    | "Reversed"
    | "Cancelled";
  isPosted?: boolean;
  postedDate?: string;
  isReversed?: boolean;
  reversalTransactionId?: string;
  department: string;
  project?: string;
  development?: string;
  budgetId?: string;
  createdBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  postedBy?: User;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type NewTransaction = {
  transactionNumber: string;
  transactionType:
    | "Journal Entry"
    | "Payment"
    | "Receipt"
    | "Transfer"
    | "Adjustment"
    | "Accrual"
    | "Reversal";
  category?:
    | "Invoice Payment"
    | "Expense"
    | "Revenue"
    | "Asset Purchase"
    | "Payroll"
    | "Tax"
    | "Bank Transfer"
    | "Depreciation"
    | "Opening Balance"
    | "Other";
  transactionDate: string;
  fiscalYear?: string;
  fiscalPeriod?: string;
  description: string;
  referenceType?: string;
  referenceId?: string;
  referenceNumber?: string;
  currency: string;
  exchangeRate?: number;
  totalDebit: number;
  totalCredit: number;
  entries?: JournalEntryLine[];
  status:
    | "Draft"
    | "Pending Approval"
    | "Approved"
    | "Posted"
    | "Reversed"
    | "Cancelled";
  isPosted?: boolean;
  postedDate?: string;
  isReversed?: boolean;
  reversalTransactionId?: string;
  department: string;
  project?: string;
  development?: string;
  budgetId?: string;
  createdBy?: User;
  approvedBy?: User;
  approvalDate?: string;
  postedBy?: User;
  notes?: string;
  dateCreated: string;
  lastUpdated: string;
};
export type PerformanceRatingEntry = {
  grade: string;
  minPercentage: number;
  maxPercentage: number;
  description?: string;
  colorCode?: string;
};
export type BonusThresholdEntry = {
  minPercentage: number;
  maxPercentage: number;
  bonusEntitlement: number;
};
export type GradingConfig = {
  id?: string;
  /** Configuration type: default, custom */
  configType: string;
  name: string;
  performanceRatings?: PerformanceRatingEntry[];
  bonusThresholds?: BonusThresholdEntry[];
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type GradingConfigPartial = {
  id?: string;
  /** Configuration type: default, custom */
  configType?: string;
  name?: string;
  performanceRatings?: PerformanceRatingEntry[];
  bonusThresholds?: BonusThresholdEntry[];
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewGradingConfig = {
  /** Configuration type: default, custom */
  configType: string;
  name: string;
  performanceRatings?: PerformanceRatingEntry[];
  bonusThresholds?: BonusThresholdEntry[];
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
};
export type ProcurementProcessWithRelations = {
  id?: string;
  currentTask: string;
  currentTaskOwner: string;
  previousTask: string;
  initiatedDate: string;
  lastActionedDate: string;
  status: string;
  requestType?: string;
  requisition: Requisition;
  siteManagerReview?: Review;
  projectManagerReview?: Review;
  cpoReview?: Review;
  pcReview?: Review;
  pmReview?: Review;
  proChairReview?: Review;
  projAdminReview?: Review;
  cfoReview?: Review;
  cooReview?: Review;
  ceoReview?: Review;
  pcToUploadQuotations?: Review;
  initiatedByUser?: User;
  requisitionDocument?: Attachment;
  purchaseOrderDocument?: Attachment;
  splitPurchaseOrder?: any;
  priority?: "Standard" | "Urgent" | "Critical";
  urgentMarkedBy?: User;
  urgentMarkedAt?: string;
};
export type PurchaseOrderWithRelations = {
  id?: string;
  procurementProcessId?: string;
  title: string;
  date: string;
  quotation: Quotation;
  purchaseOrderNumber: string;
  reqNumber: string;
  development: string;
  project: string;
  status: string;
  expectedDeliveryDate: any;
  itemsReceived?: RequisitionItem[];
  backOrderItems?: RequisitionItem[];
  paid: number;
  balance: number;
  fullFilledValue: number;
  backOrderValue: number;
  bomSavings?: number;
  contractVariance?: number;
  procurementOfficerName?: string;
  procurementOfficer?: object;
  paymentStatus?: string;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  statusModified?: Action;
  procurementProcess?: ProcurementProcessWithRelations;
};
export type GrvWithRelations = {
  id?: string;
  purchaseOrderId?: string;
  procurementProcessId?: string;
  date?: string;
  grvNumber?: string;
  grvDetails?: Quotation;
  status: boolean;
  purchaseOrder?: PurchaseOrderWithRelations;
};
export type GrvPartial = {
  id?: string;
  purchaseOrderId?: string;
  procurementProcessId?: string;
  date?: string;
  grvNumber?: string;
  grvDetails?: Quotation;
  status?: boolean;
};
export type InventoryWithRelations = {
  id?: string;
  inventoryCode: string;
  description: string;
};
export type Inventory = {
  id?: string;
  inventoryCode: string;
  description: string;
};
export type NewInventory = {
  inventoryCode: string;
  description: string;
};
export type InviteWithRelations = {
  id?: string;
  isPermanentVisitor: boolean;
  visitorName: string;
  visitorEmail: string;
  visitorWhatsApp: string;
  meetingWith?: string;
  meetingDateTime?: string;
  meetingCreatedBy?: string;
  scanned?: boolean;
  idNumber: string;
  idCardImageFilename?: string;
};
export type ItemCategoryWithRelations = {
  id?: string;
  categoryCode: string;
  description: string;
};
export type ItemCategory = {
  id?: string;
  categoryCode: string;
  description: string;
};
export type NewItemCategory = {
  categoryCode: string;
  description: string;
};
export type ItemLocationWithRelations = {
  id?: string;
  itemCode: string;
  itemDescription: string;
  locationCode: string;
  locationDescription: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  stock: number;
  quantityUnit: string;
  totalValue: number;
};
export type ItemLocation = {
  id?: string;
  itemCode: string;
  itemDescription: string;
  locationCode: string;
  locationDescription: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  stock: number;
  quantityUnit: string;
  totalValue: number;
};
export type NewItemLocation = {
  itemCode: string;
  itemDescription: string;
  locationCode: string;
  locationDescription: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  stock: number;
  quantityUnit: string;
  totalValue: number;
};
export type TargetLocation = {
  units?: EntityIdentity[];
  project?: EntityIdentity;
  development?: EntityIdentity;
  inventoryLocation?: {
    locationId: string;
    locationCode: string;
    description: string;
    developmentId: string;
    developmentName: string;
  };
  supplier?: EntityIdentity;
};
export type ItemTransferWithRelations = {
  id?: string;
  title?: string;
  transferredBy: any;
  transferType?: "Goods Received" | "Goods Issued";
  purchaseOrderNumber?: string;
  procurementProcessId?: string;
  quotationNumber?: any;
  currency?: string;
  transferredDate: string;
  isService: boolean;
  items: {
    itemId?: string;
    itemCode: string;
    description: string;
    reasonForTransfer?: string;
    quantity: {
      quantityValue: number | string;
      quantityUnit: string;
    };
    rate: number;
    totalCostPerItem?: number;
    discountPerItem?: number;
    VAT?: boolean;
  }[];
  reasonForTransfer?: string;
  grvNumber?: string;
  givNumber?: string;
  sourceLocation: TargetLocation;
  sourceLocationType?: string;
  destinationLocationType?: string;
  destinationLocation: TargetLocation;
  documents?: Attachment[];
  grvDocument?: Attachment;
  givDocument?: Attachment;
  totalVAT?: number;
  totalb4VAT?: number;
  grandTotal?: number;
  totalDiscount?: number;
};
export type ItemTransfer = {
  id?: string;
  title?: string;
  transferredBy: any;
  transferType?: "Goods Received" | "Goods Issued";
  purchaseOrderNumber?: string;
  procurementProcessId?: string;
  quotationNumber?: any;
  currency?: string;
  transferredDate: string;
  isService: boolean;
  items: {
    itemId?: string;
    itemCode: string;
    description: string;
    reasonForTransfer?: string;
    quantity: {
      quantityValue: number | string;
      quantityUnit: string;
    };
    rate: number;
    totalCostPerItem?: number;
    discountPerItem?: number;
    VAT?: boolean;
  }[];
  reasonForTransfer?: string;
  grvNumber?: string;
  givNumber?: string;
  sourceLocation: TargetLocation;
  sourceLocationType?: string;
  destinationLocationType?: string;
  destinationLocation: TargetLocation;
  documents?: Attachment[];
  grvDocument?: Attachment;
  givDocument?: Attachment;
  totalVAT?: number;
  totalb4VAT?: number;
  grandTotal?: number;
  totalDiscount?: number;
};
export type NewItemTransfer = {
  title?: string;
  transferredBy: any;
  transferType?: "Goods Received" | "Goods Issued";
  purchaseOrderNumber?: string;
  procurementProcessId?: string;
  quotationNumber?: any;
  currency?: string;
  transferredDate: string;
  isService: boolean;
  items: {
    itemId?: string;
    itemCode: string;
    description: string;
    reasonForTransfer?: string;
    quantity: {
      quantityValue: number | string;
      quantityUnit: string;
    };
    rate: number;
    totalCostPerItem?: number;
    discountPerItem?: number;
    VAT?: boolean;
  }[];
  reasonForTransfer?: string;
  grvNumber?: string;
  givNumber?: string;
  sourceLocation: TargetLocation;
  sourceLocationType?: string;
  destinationLocationType?: string;
  destinationLocation: TargetLocation;
  documents?: Attachment[];
  grvDocument?: Attachment;
  givDocument?: Attachment;
  totalVAT?: number;
  totalb4VAT?: number;
  grandTotal?: number;
  totalDiscount?: number;
};
export type ItemWithRelations = {
  id?: string;
  itemCode: string;
  description: string;
  quantityUnit: string;
  itemCategoryId?: string;
  categoryCode: string;
  categoryDescription: string;
  inventoryCode: string;
  inventoryDescription: string;
  inventoryId?: string;
  isService: boolean;
  itemCategory?: ItemCategoryWithRelations;
  inventory?: InventoryWithRelations;
};
export type Item = {
  id?: string;
  itemCode: string;
  description: string;
  quantityUnit: string;
  itemCategoryId?: string;
  categoryCode: string;
  categoryDescription: string;
  inventoryCode: string;
  inventoryDescription: string;
  inventoryId?: string;
  isService: boolean;
};
export type NewItem = {
  itemCode: string;
  description: string;
  quantityUnit: string;
  itemCategoryId?: string;
  categoryCode: string;
  categoryDescription: string;
  inventoryCode: string;
  inventoryDescription: string;
  inventoryId?: string;
  isService: boolean;
};
export type ItemIssued = {
  id?: string;
  itemCode: string;
  itemDescription: string;
  unitName?: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  isIncorrectIssue?: boolean;
  correctProjectAllocation?: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  quantity: number;
  totalValue: number;
};
export type NewItemsIssued = {
  itemCode: string;
  itemDescription: string;
  unitName?: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  isIncorrectIssue?: boolean;
  correctProjectAllocation?: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  quantity: number;
  totalValue: number;
};
export type ItemIssuedWithRelations = {
  id?: string;
  itemCode: string;
  itemDescription: string;
  unitName?: string;
  developmentAllocation: EntityIdentity;
  projectAllocation: EntityIdentity;
  isIncorrectIssue?: boolean;
  correctProjectAllocation?: EntityIdentity;
  rate: number;
  itemDiscount: number;
  VAT: number;
  supplier: string;
  purchaseOrderNumber: string;
  currency: string;
  quantity: number;
  totalValue: number;
};
export type AuthorityLimit = {
  category: string;
  description: string;
  monetaryLimit?: number;
  currency?: string;
  headcountLimit?: number;
  salaryBandLimit?: string;
  unitLimit?: number;
  unitType?: string;
  contractDurationLimit?: string;
  contractValueLimit?: number;
  accessLevel?: string;
  systemScope?: string;
  approvalRequired?: string;
};
export type Qualification = {
  name: string;
  level?: string;
  field?: string;
  isRequired?: boolean;
};
export type ProfessionalRegistration = {
  body: string;
  membershipType?: string;
  isRequired?: boolean;
};
export type BscPerspective = {
  name: string;
  kras?: string[];
};
export type JobDescriptionWithRelations = {
  id?: string;
  title: string;
  grade?: string;
  department?: string | null;
  /** Business unit this job description belongs to */
  businessUnit?: string;
  jobPurpose?: string;
  /** Job title of supervisor (e.g., "CTO", "CFO") - denormalized for display */
  reportsTo?: string;
  /** ID of the JobDescription this position reports to */
  reportsToJobDescriptionId?: string;
  /** User ID of the supervisor (auto-populated from supervisor JD assignment) */
  reportsToUserId?: string;
  directReportsCount?: number;
  indirectReportsCount?: number;
  limitsToAuthority?: AuthorityLimit[];
  minimumQualifications?: Qualification[];
  minimumJobKnowledge?: string[];
  minimumExperienceYears?: string;
  minimumExperienceDescription?: string;
  professionalRegistrations?: ProfessionalRegistration[];
  otherRequirements?: string[];
  bscPerspectives?: BscPerspective[];
  requiredCompetencies?: string[];
  /** User ID assigned to this job description */
  assignedUserId?: string;
  /** Name of the user assigned to this job description (denormalized for display) */
  assignedUserName?: string;
  /** User ID of the creator (for ownership/permissions) */
  createdByUserId?: string;
  /** Name of the creator (denormalized for display) */
  createdByName?: string;
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewMyJobDescription = {
  title: string;
  grade?: string;
  department?: string | null;
  /** Business unit this job description belongs to */
  businessUnit?: string;
  jobPurpose?: string;
  /** Job title of supervisor (e.g., "CTO", "CFO") - denormalized for display */
  reportsTo?: string;
  /** ID of the JobDescription this position reports to */
  reportsToJobDescriptionId?: string;
  /** User ID of the supervisor (auto-populated from supervisor JD assignment) */
  reportsToUserId?: string;
  directReportsCount?: number;
  indirectReportsCount?: number;
  limitsToAuthority?: AuthorityLimit[];
  minimumQualifications?: Qualification[];
  minimumJobKnowledge?: string[];
  minimumExperienceYears?: string;
  minimumExperienceDescription?: string;
  professionalRegistrations?: ProfessionalRegistration[];
  otherRequirements?: string[];
  bscPerspectives?: BscPerspective[];
  requiredCompetencies?: string[];
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
};
export type JobDescriptionPartial = {
  id?: string;
  title?: string;
  grade?: string;
  department?: string | null;
  /** Business unit this job description belongs to */
  businessUnit?: string;
  jobPurpose?: string;
  /** Job title of supervisor (e.g., "CTO", "CFO") - denormalized for display */
  reportsTo?: string;
  /** ID of the JobDescription this position reports to */
  reportsToJobDescriptionId?: string;
  /** User ID of the supervisor (auto-populated from supervisor JD assignment) */
  reportsToUserId?: string;
  directReportsCount?: number;
  indirectReportsCount?: number;
  limitsToAuthority?: AuthorityLimit[];
  minimumQualifications?: Qualification[];
  minimumJobKnowledge?: string[];
  minimumExperienceYears?: string;
  minimumExperienceDescription?: string;
  professionalRegistrations?: ProfessionalRegistration[];
  otherRequirements?: string[];
  bscPerspectives?: BscPerspective[];
  requiredCompetencies?: string[];
  /** User ID assigned to this job description */
  assignedUserId?: string;
  /** Name of the user assigned to this job description (denormalized for display) */
  assignedUserName?: string;
  /** User ID of the creator (for ownership/permissions) */
  createdByUserId?: string;
  /** Name of the creator (denormalized for display) */
  createdByName?: string;
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type JobDescription = {
  id?: string;
  title: string;
  grade?: string;
  department?: string | null;
  /** Business unit this job description belongs to */
  businessUnit?: string;
  jobPurpose?: string;
  /** Job title of supervisor (e.g., "CTO", "CFO") - denormalized for display */
  reportsTo?: string;
  /** ID of the JobDescription this position reports to */
  reportsToJobDescriptionId?: string;
  /** User ID of the supervisor (auto-populated from supervisor JD assignment) */
  reportsToUserId?: string;
  directReportsCount?: number;
  indirectReportsCount?: number;
  limitsToAuthority?: AuthorityLimit[];
  minimumQualifications?: Qualification[];
  minimumJobKnowledge?: string[];
  minimumExperienceYears?: string;
  minimumExperienceDescription?: string;
  professionalRegistrations?: ProfessionalRegistration[];
  otherRequirements?: string[];
  bscPerspectives?: BscPerspective[];
  requiredCompetencies?: string[];
  /** User ID assigned to this job description */
  assignedUserId?: string;
  /** Name of the user assigned to this job description (denormalized for display) */
  assignedUserName?: string;
  /** User ID of the creator (for ownership/permissions) */
  createdByUserId?: string;
  /** Name of the creator (denormalized for display) */
  createdByName?: string;
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewJobDescription = {
  title: string;
  grade?: string;
  department?: string | null;
  /** Business unit this job description belongs to */
  businessUnit?: string;
  jobPurpose?: string;
  /** Job title of supervisor (e.g., "CTO", "CFO") - denormalized for display */
  reportsTo?: string;
  /** ID of the JobDescription this position reports to */
  reportsToJobDescriptionId?: string;
  /** User ID of the supervisor (auto-populated from supervisor JD assignment) */
  reportsToUserId?: string;
  directReportsCount?: number;
  indirectReportsCount?: number;
  limitsToAuthority?: AuthorityLimit[];
  minimumQualifications?: Qualification[];
  minimumJobKnowledge?: string[];
  minimumExperienceYears?: string;
  minimumExperienceDescription?: string;
  professionalRegistrations?: ProfessionalRegistration[];
  otherRequirements?: string[];
  bscPerspectives?: BscPerspective[];
  requiredCompetencies?: string[];
  /** User ID assigned to this job description */
  assignedUserId?: string;
  /** Name of the user assigned to this job description (denormalized for display) */
  assignedUserName?: string;
  /** User ID of the creator (for ownership/permissions) */
  createdByUserId?: string;
  /** Name of the creator (denormalized for display) */
  createdByName?: string;
  isActive?: boolean;
  createdBy?: string;
  updatedBy?: string;
};
export type KnowledgeBaseEntry = {
  id?: string;
  documentName: string;
  documentPath: string;
};
export type NewKnowledgeBaseEntry = {
  documentName: string;
  documentPath: string;
};
export type PurchaseOrder = {
  id?: string;
  procurementProcessId?: string;
  title: string;
  date: string;
  quotation: Quotation;
  purchaseOrderNumber: string;
  reqNumber: string;
  development: string;
  project: string;
  status: string;
  expectedDeliveryDate: any;
  itemsReceived?: RequisitionItem[];
  backOrderItems?: RequisitionItem[];
  paid: number;
  balance: number;
  fullFilledValue: number;
  backOrderValue: number;
  bomSavings?: number;
  contractVariance?: number;
  procurementOfficerName?: string;
  procurementOfficer?: object;
  paymentStatus?: string;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  statusModified?: Action;
};
export type PaymentRequisitionPartial = {
  id?: string;
  purchaseOrder?: PurchaseOrder;
  title?: string;
  procurementProcessId?: string;
  paymentMethod?: string;
  referenceNumber?: string;
  currency?: string;
  amount?: number;
  dueDate?: string;
  lastActionedDate?: string;
  dateCreated?: string;
  scheduledOn?: string;
  scheduledFor?: string;
  paymentDate?: string;
  status?:
    | "Awaiting Approval"
    | "Approved"
    | "Rejected"
    | "Scheduled"
    | "Prioritized"
    | "Paid"
    | "Cancelled";
  paymentType?: "DEPOSIT" | "INTERIM" | "FINAL PAYMENT" | "ONCE OFF";
  preparedBy?: User;
  reviewedBy?: User;
  reviewedAt?: string;
  prioritizedBy?: User;
  prioritizedAt?: string;
  scheduledBy?: User;
  scheduledAt?: string;
  approvedBy?: User;
  approvedAt?: string;
  paymentConfirmedBy?: User;
  paymentConfirmedAt?: string;
  department?: string;
  development?: string;
  project?: string;
  batchNumber?: string;
  priority?: number;
  rate?: number;
  swap?: boolean;
  paymentRequisitionDocument?: Attachment;
  documents?: Attachment[];
};
export type PaymentRequisition = {
  id?: string;
  purchaseOrder?: PurchaseOrder;
  title?: string;
  procurementProcessId?: string;
  paymentMethod: string;
  referenceNumber?: string;
  currency: string;
  amount: number;
  dueDate: string;
  lastActionedDate: string;
  dateCreated: string;
  scheduledOn?: string;
  scheduledFor?: string;
  paymentDate?: string;
  status:
    | "Awaiting Approval"
    | "Approved"
    | "Rejected"
    | "Scheduled"
    | "Prioritized"
    | "Paid"
    | "Cancelled";
  paymentType?: "DEPOSIT" | "INTERIM" | "FINAL PAYMENT" | "ONCE OFF";
  preparedBy: User;
  reviewedBy?: User;
  reviewedAt?: string;
  prioritizedBy?: User;
  prioritizedAt?: string;
  scheduledBy?: User;
  scheduledAt?: string;
  approvedBy?: User;
  approvedAt?: string;
  paymentConfirmedBy?: User;
  paymentConfirmedAt?: string;
  department: string;
  development: string;
  project: string;
  batchNumber?: string;
  priority?: number;
  rate?: number;
  swap?: boolean;
  paymentRequisitionDocument?: Attachment;
  documents?: Attachment[];
};
export type NewPaymentRequisition = {
  purchaseOrder?: PurchaseOrder;
  title?: string;
  procurementProcessId?: string;
  paymentMethod: string;
  referenceNumber?: string;
  currency: string;
  amount: number;
  dueDate: string;
  lastActionedDate: string;
  dateCreated: string;
  scheduledOn?: string;
  scheduledFor?: string;
  paymentDate?: string;
  status:
    | "Awaiting Approval"
    | "Approved"
    | "Rejected"
    | "Scheduled"
    | "Prioritized"
    | "Paid"
    | "Cancelled";
  paymentType?: "DEPOSIT" | "INTERIM" | "FINAL PAYMENT" | "ONCE OFF";
  preparedBy: User;
  reviewedBy?: User;
  reviewedAt?: string;
  prioritizedBy?: User;
  prioritizedAt?: string;
  scheduledBy?: User;
  scheduledAt?: string;
  approvedBy?: User;
  approvedAt?: string;
  paymentConfirmedBy?: User;
  paymentConfirmedAt?: string;
  department: string;
  development: string;
  project: string;
  batchNumber?: string;
  priority?: number;
  rate?: number;
  swap?: boolean;
  paymentRequisitionDocument?: Attachment;
  documents?: Attachment[];
};
export type PaymentRequisitionWithRelations = {
  id?: string;
  purchaseOrder?: PurchaseOrder;
  title?: string;
  procurementProcessId?: string;
  paymentMethod: string;
  referenceNumber?: string;
  currency: string;
  amount: number;
  dueDate: string;
  lastActionedDate: string;
  dateCreated: string;
  scheduledOn?: string;
  scheduledFor?: string;
  paymentDate?: string;
  status:
    | "Awaiting Approval"
    | "Approved"
    | "Rejected"
    | "Scheduled"
    | "Prioritized"
    | "Paid"
    | "Cancelled";
  paymentType?: "DEPOSIT" | "INTERIM" | "FINAL PAYMENT" | "ONCE OFF";
  preparedBy: User;
  reviewedBy?: User;
  reviewedAt?: string;
  prioritizedBy?: User;
  prioritizedAt?: string;
  scheduledBy?: User;
  scheduledAt?: string;
  approvedBy?: User;
  approvedAt?: string;
  paymentConfirmedBy?: User;
  paymentConfirmedAt?: string;
  department: string;
  development: string;
  project: string;
  batchNumber?: string;
  priority?: number;
  rate?: number;
  swap?: boolean;
  paymentRequisitionDocument?: Attachment;
  documents?: Attachment[];
};
export type PaymentPartial = {
  id?: string;
  debtorId?: string;
  developmentId?: string;
  paymentDate?: string;
  paymentNo?: string;
  amount?: number;
  paymentMethod?: "bank" | "cash" | "ecocash" | "swipe" | "cheque" | "transfer";
  status?: "pending" | "reconciled" | "reversed" | "cancelled";
  reference?: string;
  allocation?: string;
  allocationTo?: "principal" | "interest" | "other";
  notes?: string;
  reconciliationDate?: string;
  isVatInclusive?: boolean;
  vatAmount?: number;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  linkedInvoices?: string;
  paymentType?: "installment" | "interest" | "vat" | "other";
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  linkedReceiptId?: string;
  [key: string]: any;
};
export type NewPayment = {
  debtorId: string;
  developmentId?: string;
  paymentDate: string;
  paymentNo: string;
  amount: number;
  paymentMethod: "bank" | "cash" | "ecocash" | "swipe" | "cheque" | "transfer";
  status?: "pending" | "reconciled" | "reversed" | "cancelled";
  reference?: string;
  allocation?: string;
  allocationTo?: "principal" | "interest" | "other";
  notes?: string;
  reconciliationDate?: string;
  isVatInclusive?: boolean;
  vatAmount?: number;
  linkedInvoices?: string;
  paymentType?: "installment" | "interest" | "vat" | "other";
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  linkedReceiptId?: string;
  [key: string]: any;
};
export type PearScoreItem = {
  criterion?: string;
  score?: number;
  comments?: string;
};
export type PearHighPerformanceItem = {
  attributeLeft?: string;
  scoreLeft?: number;
  attributeRight?: string;
  scoreRight?: number;
};
export type PearKeyFactorSubItem = {
  description: string;
  selfRating?: string;
  managerRating?: string;
};
export type PearKeyFactorCategory = {
  category: string;
  subItems?: PearKeyFactorSubItem[];
};
export type PearkpiItem = {
  description: string;
  measurement?: string;
};
export type PearokrKeyResult = {
  description: string;
  selfRating?: number;
  managerPerformanceRating?: number;
  managerAlignmentRating?: number;
  managerComment?: string;
};
export type PearCoreValueItem = {
  value: string;
  acronym: string;
  description: string;
  selfRating?: string;
  managerRating?: string;
  group: "ACT" | "REF";
};
export type PearReview = {
  id?: string;
  employeeId?: string;
  employeeName?: string;
  designation?: string;
  department?: string;
  reportsTo?: string;
  managerId?: string;
  managerName?: string;
  managerEditedAt?: string;
  joiningDate?: string;
  reviewPeriod: string;
  evaluationPurpose?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  qualityOfWork?: PearScoreItem[];
  qualityOfWorkTotal?: number;
  workHabits?: PearScoreItem[];
  workHabitsTotal?: number;
  jobKnowledge?: PearScoreItem[];
  jobKnowledgeTotal?: number;
  highPerformanceCulture?: PearHighPerformanceItem[];
  highPerformanceCultureTotal?: number;
  functionalSkillsTotal?: number;
  interpersonalSkills?: PearScoreItem[];
  interpersonalSkillsTotal?: number;
  leadershipProblemSolving?: PearScoreItem[];
  leadershipProblemSolvingTotal?: number;
  interpersonalTotal?: number;
  rawTotal?: number;
  overallScore?: number;
  finalGrade?: string;
  ratingDescription?: string;
  performanceKeyFactors?: PearKeyFactorCategory[];
  performanceKeyFactorsManagerComments?: string | null;
  bscScore?: number;
  bscManagerComments?: string | null;
  nextQuarterKPIs?: PearkpiItem[];
  okrObjective?: string | null;
  okrObjectiveChallenge?: number;
  okrKeyResults?: PearokrKeyResult[];
  cisImprovements?: (string | null)[];
  cisManagerComments?: string | null;
  feedback360?: string | null;
  coreValues?: PearCoreValueItem[];
  strengths?: (string | null)[];
  developmentNeeds?: (string | null)[];
  managerDevelopmentSupport?: string | null;
  overallManagerRating?: number;
  overallManagerComments?: string | null;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
};
export type PearReviewPartial = {
  id?: string;
  employeeId?: string;
  employeeName?: string;
  designation?: string;
  department?: string;
  reportsTo?: string;
  managerId?: string;
  managerName?: string;
  managerEditedAt?: string;
  joiningDate?: string;
  reviewPeriod?: string;
  evaluationPurpose?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  qualityOfWork?: PearScoreItem[];
  qualityOfWorkTotal?: number;
  workHabits?: PearScoreItem[];
  workHabitsTotal?: number;
  jobKnowledge?: PearScoreItem[];
  jobKnowledgeTotal?: number;
  highPerformanceCulture?: PearHighPerformanceItem[];
  highPerformanceCultureTotal?: number;
  functionalSkillsTotal?: number;
  interpersonalSkills?: PearScoreItem[];
  interpersonalSkillsTotal?: number;
  leadershipProblemSolving?: PearScoreItem[];
  leadershipProblemSolvingTotal?: number;
  interpersonalTotal?: number;
  rawTotal?: number;
  overallScore?: number;
  finalGrade?: string;
  ratingDescription?: string;
  performanceKeyFactors?: PearKeyFactorCategory[];
  performanceKeyFactorsManagerComments?: string | null;
  bscScore?: number;
  bscManagerComments?: string | null;
  nextQuarterKPIs?: PearkpiItem[];
  okrObjective?: string | null;
  okrObjectiveChallenge?: number;
  okrKeyResults?: PearokrKeyResult[];
  cisImprovements?: (string | null)[];
  cisManagerComments?: string | null;
  feedback360?: string | null;
  coreValues?: PearCoreValueItem[];
  strengths?: (string | null)[];
  developmentNeeds?: (string | null)[];
  managerDevelopmentSupport?: string | null;
  overallManagerRating?: number;
  overallManagerComments?: string | null;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
};
export type PearReviewWithRelations = {
  id?: string;
  employeeId?: string;
  employeeName?: string;
  designation?: string;
  department?: string;
  reportsTo?: string;
  managerId?: string;
  managerName?: string;
  managerEditedAt?: string;
  joiningDate?: string;
  reviewPeriod: string;
  evaluationPurpose?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  qualityOfWork?: PearScoreItem[];
  qualityOfWorkTotal?: number;
  workHabits?: PearScoreItem[];
  workHabitsTotal?: number;
  jobKnowledge?: PearScoreItem[];
  jobKnowledgeTotal?: number;
  highPerformanceCulture?: PearHighPerformanceItem[];
  highPerformanceCultureTotal?: number;
  functionalSkillsTotal?: number;
  interpersonalSkills?: PearScoreItem[];
  interpersonalSkillsTotal?: number;
  leadershipProblemSolving?: PearScoreItem[];
  leadershipProblemSolvingTotal?: number;
  interpersonalTotal?: number;
  rawTotal?: number;
  overallScore?: number;
  finalGrade?: string;
  ratingDescription?: string;
  performanceKeyFactors?: PearKeyFactorCategory[];
  performanceKeyFactorsManagerComments?: string | null;
  bscScore?: number;
  bscManagerComments?: string | null;
  nextQuarterKPIs?: PearkpiItem[];
  okrObjective?: string | null;
  okrObjectiveChallenge?: number;
  okrKeyResults?: PearokrKeyResult[];
  cisImprovements?: (string | null)[];
  cisManagerComments?: string | null;
  feedback360?: string | null;
  coreValues?: PearCoreValueItem[];
  strengths?: (string | null)[];
  developmentNeeds?: (string | null)[];
  managerDevelopmentSupport?: string | null;
  overallManagerRating?: number;
  overallManagerComments?: string | null;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  employee?: UserWithRelations;
};
export type NewPearReview = {
  employeeId?: string;
  employeeName?: string;
  designation?: string;
  department?: string;
  reportsTo?: string;
  managerId?: string;
  managerName?: string;
  managerEditedAt?: string;
  joiningDate?: string;
  reviewPeriod: string;
  evaluationPurpose?: string;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  qualityOfWork?: PearScoreItem[];
  qualityOfWorkTotal?: number;
  workHabits?: PearScoreItem[];
  workHabitsTotal?: number;
  jobKnowledge?: PearScoreItem[];
  jobKnowledgeTotal?: number;
  highPerformanceCulture?: PearHighPerformanceItem[];
  highPerformanceCultureTotal?: number;
  functionalSkillsTotal?: number;
  interpersonalSkills?: PearScoreItem[];
  interpersonalSkillsTotal?: number;
  leadershipProblemSolving?: PearScoreItem[];
  leadershipProblemSolvingTotal?: number;
  interpersonalTotal?: number;
  rawTotal?: number;
  overallScore?: number;
  finalGrade?: string;
  ratingDescription?: string;
  performanceKeyFactors?: PearKeyFactorCategory[];
  performanceKeyFactorsManagerComments?: string | null;
  bscScore?: number;
  bscManagerComments?: string | null;
  nextQuarterKPIs?: PearkpiItem[];
  okrObjective?: string | null;
  okrObjectiveChallenge?: number;
  okrKeyResults?: PearokrKeyResult[];
  cisImprovements?: (string | null)[];
  cisManagerComments?: string | null;
  feedback360?: string | null;
  coreValues?: PearCoreValueItem[];
  strengths?: (string | null)[];
  developmentNeeds?: (string | null)[];
  managerDevelopmentSupport?: string | null;
  overallManagerRating?: number;
  overallManagerComments?: string | null;
  createdBy?: string;
  updatedBy?: string;
};
export type PingResponse = {
  greeting?: string;
  date?: string;
  url?: string;
  headers?: {
    "Content-Type"?: string;
    [key: string]: any;
  };
};
export type ProcurementContractWithRelations = {
  id?: string;
  title: string;
  supplier: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalValue?: number;
};
export type ProcurementContractPartial = {
  id?: string;
  title?: string;
  supplier?: EntityIdentity;
  attachments?: Attachment[];
  active?: boolean;
  totalValue?: number;
};
export type ProcurementContract = {
  id?: string;
  title: string;
  supplier: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalValue?: number;
};
export type NewProcurementContract = {
  title: string;
  supplier: EntityIdentity;
  attachments?: Attachment[];
  active: boolean;
  totalValue?: number;
};
export type UpdatedProcurementProcess = {
  id?: string;
  currentTask: string;
  currentTaskOwner: string;
  previousTask: string;
  initiatedDate: string;
  lastActionedDate: string;
  status: string;
  requestType?: string;
  requisition: Requisition;
  siteManagerReview?: Review;
  projectManagerReview?: Review;
  cpoReview?: Review;
  pcReview?: Review;
  pmReview?: Review;
  proChairReview?: Review;
  projAdminReview?: Review;
  cfoReview?: Review;
  cooReview?: Review;
  ceoReview?: Review;
  pcToUploadQuotations?: Review;
  initiatedByUser?: User;
  requisitionDocument?: Attachment;
  purchaseOrderDocument?: Attachment;
  splitPurchaseOrder?: any;
  priority?: "Standard" | "Urgent" | "Critical";
  urgentMarkedBy?: User;
  urgentMarkedAt?: string;
};
export type ProcurementProcessPartial = {
  id?: string;
  currentTask?: string;
  currentTaskOwner?: string;
  previousTask?: string;
  initiatedDate?: string;
  lastActionedDate?: string;
  status?: string;
  requestType?: string;
  requisition?: Requisition;
  siteManagerReview?: Review;
  projectManagerReview?: Review;
  cpoReview?: Review;
  pcReview?: Review;
  pmReview?: Review;
  proChairReview?: Review;
  projAdminReview?: Review;
  cfoReview?: Review;
  cooReview?: Review;
  ceoReview?: Review;
  pcToUploadQuotations?: Review;
  initiatedByUser?: User;
  requisitionDocument?: Attachment;
  purchaseOrderDocument?: Attachment;
  splitPurchaseOrder?: any;
  priority?: "Standard" | "Urgent" | "Critical";
  urgentMarkedBy?: User;
  urgentMarkedAt?: string;
};
export type PropertyWithRelations = {
  id?: string;
  development: string;
  phase: string;
  unitNumber: string;
  clientId?: string;
  client?: ClientWithRelations;
};
export type Property = {
  id?: string;
  development: string;
  phase: string;
  unitNumber: string;
  clientId?: string;
};
export type PropertyData = {
  development: string;
  phase: string;
  unitNumber: string;
  clientId?: string;
};
export type ProTrackHandoverPartial = {
  id?: string;
  blockId?: string;
  blockName?: string;
  unitNumber?: string;
  unitType?: string;
  clientName?: string;
  clientEmail?: string;
  clientPhone?: string;
  scheduledDate?: string;
  inspectionDate?: string;
  handoverDate?: string;
  status?: string;
  snagCount?: number;
  outstandingSnags?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ProTrackHandover = {
  id?: string;
  blockId: string;
  blockName?: string;
  unitNumber: string;
  unitType?: string;
  clientName?: string;
  clientEmail?: string;
  clientPhone?: string;
  scheduledDate?: string;
  inspectionDate?: string;
  handoverDate?: string;
  status?: string;
  snagCount?: number;
  outstandingSnags?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewProTrackHandover = {
  blockId: string;
  blockName?: string;
  unitNumber: string;
  unitType?: string;
  clientName?: string;
  clientEmail?: string;
  clientPhone?: string;
  scheduledDate?: string;
  inspectionDate?: string;
  handoverDate?: string;
  status?: string;
  snagCount?: number;
  outstandingSnags?: number;
  notes?: string;
};
export type ProTrackMilestonePartial = {
  id?: string;
  blockId?: string;
  blockName?: string;
  title?: string;
  category?: string;
  plannedStart?: string;
  plannedEnd?: string;
  actualStart?: string;
  actualEnd?: string;
  status?: string;
  progressPct?: number;
  responsible?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ProTrackMilestone = {
  id?: string;
  blockId: string;
  blockName?: string;
  title: string;
  category?: string;
  plannedStart: string;
  plannedEnd: string;
  actualStart?: string;
  actualEnd?: string;
  status?: string;
  progressPct?: number;
  responsible?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewProTrackMilestone = {
  blockId: string;
  blockName?: string;
  title: string;
  category?: string;
  plannedStart: string;
  plannedEnd: string;
  actualStart?: string;
  actualEnd?: string;
  status?: string;
  progressPct?: number;
  responsible?: string;
  notes?: string;
};
export type ProTrackProjectPartial = {
  id?: string;
  projectNumber?: string;
  name?: string;
  siteId?: string;
  overallStatus?: string;
  contract?: object;
  construction?: object;
  financial?: object;
  sales?: object;
  debtors?: object;
  conveyancing?: object;
  notes?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ProTrackProject = {
  id?: string;
  projectNumber: string;
  name: string;
  siteId: string;
  overallStatus?: string;
  contract?: object;
  construction?: object;
  financial?: object;
  sales?: object;
  debtors?: object;
  conveyancing?: object;
  notes?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewProTrackProject = {
  projectNumber: string;
  name: string;
  siteId: string;
  overallStatus?: string;
  contract?: object;
  construction?: object;
  financial?: object;
  sales?: object;
  debtors?: object;
  conveyancing?: object;
  notes?: string;
  updatedBy?: string;
};
export type ProTrackSnagPartial = {
  id?: string;
  blockId?: string;
  blockName?: string;
  siteName?: string;
  unitNumber?: string;
  title?: string;
  description?: string;
  category?: string;
  severity?: string;
  status?: string;
  reportedDate?: string;
  dueDate?: string;
  resolvedDate?: string;
  reinspectionDate?: string;
  reportedBy?: string;
  assignedTo?: string;
  subcontractor?: string;
  location?: string;
  trade?: string;
  rootCause?: string;
  actionRequired?: string;
  inspectionType?: string;
  closureComment?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ProTrackSnag = {
  id?: string;
  blockId: string;
  blockName?: string;
  siteName?: string;
  unitNumber?: string;
  title: string;
  description?: string;
  category?: string;
  severity?: string;
  status?: string;
  reportedDate: string;
  dueDate?: string;
  resolvedDate?: string;
  reinspectionDate?: string;
  reportedBy?: string;
  assignedTo?: string;
  subcontractor?: string;
  location?: string;
  trade?: string;
  rootCause?: string;
  actionRequired?: string;
  inspectionType?: string;
  closureComment?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type NewProTrackSnag = {
  blockId: string;
  blockName?: string;
  siteName?: string;
  unitNumber?: string;
  title: string;
  description?: string;
  category?: string;
  severity?: string;
  status?: string;
  reportedDate: string;
  dueDate?: string;
  resolvedDate?: string;
  reinspectionDate?: string;
  reportedBy?: string;
  assignedTo?: string;
  subcontractor?: string;
  location?: string;
  trade?: string;
  rootCause?: string;
  actionRequired?: string;
  inspectionType?: string;
  closureComment?: string;
  notes?: string;
};
export type PurchaseOrderPartial = {
  id?: string;
  procurementProcessId?: string;
  title?: string;
  date?: string;
  quotation?: Quotation;
  purchaseOrderNumber?: string;
  reqNumber?: string;
  development?: string;
  project?: string;
  status?: string;
  expectedDeliveryDate?: any;
  itemsReceived?: RequisitionItem[];
  backOrderItems?: RequisitionItem[];
  paid?: number;
  balance?: number;
  fullFilledValue?: number;
  backOrderValue?: number;
  bomSavings?: number;
  contractVariance?: number;
  procurementOfficerName?: string;
  procurementOfficer?: object;
  paymentStatus?: string;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  statusModified?: Action;
};
export type QuotationsUploadProgressWithRelations = {
  id?: string;
  reqNumber: string;
  quotations?: Quotation[];
};
export type QuotationsUploadProgress = {
  id?: string;
  reqNumber: string;
  quotations?: Quotation[];
};
export type NewQuotationsUploadProgress = {
  reqNumber: string;
  quotations?: Quotation[];
};
export type RequisitionWithRelations = {
  id?: string;
  title: string;
  development: EntityIdentity;
  project: EntityIdentity;
  totalCost?: number;
  reqNumber: string;
  approved?: boolean;
  items: RequisitionItem[];
  documents?: Attachment[];
};
export type RequisitionReviewWithRelations = {
  id?: string;
  comment: Comment;
  approved: boolean;
};
export type EmployeeReviewPartialExcludingIdUserIdReviewPeriodCreatedAt = {
  accomplishments?: PerformanceItem[];
  quarterlyGoals?: PerformanceItem[];
  monthlyGoals?: PerformanceItem[];
  monthlyIncentiveGoal?: MonthlyIncentiveGoal;
  areaToImprove?: string;
  quarterlyObjective?: string;
  examplesOfExcellence?: string;
  mainGoalToAchieve?: string;
  turnUpOnTime?: boolean;
  dailyCheckIn?: boolean;
  reportsOnTime?: boolean;
  status?: "draft" | "submitted" | "under_review" | "approved" | "rejected";
  managerId?: string;
  managerName?: string;
  managerOverallComments?: string | null;
  managerAccomplishmentsComments?: string | null;
  managerGoalsComments?: string | null;
  managerEditedAt?: string;
  submittedAt?: string;
  approvedAt?: string;
  updatedAt?: string;
};
export type ContactInfo = {
  phone: string;
  email: string;
  contactPerson?: string;
  [key: string]: any;
};
export type Address = {
  street: string;
  city: string;
  country?: string;
  [key: string]: any;
};
export type StakeholderWithRelations = {
  id?: string;
  name: string;
  type: string;
  contactInfo: ContactInfo[];
  address: Address[];
  tin?: string;
  VATNumber?: string;
  paymentTerms?: string;
  supplierCode?: string;
  customerCode?: string;
  rating?: number;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  suspended?: Action;
  statusModified?: Action;
  isInternational?: boolean;
  bankingDetailsVerified?: boolean;
  isTaxClearanceValid: boolean;
  taxClearanceExpiryDate?: any;
  isStakeholderVerified: boolean;
  updateHistory?: Action[];
  [key: string]: any;
};
export type StakeholderPartial = {
  id?: string;
  name?: string;
  type?: string;
  contactInfo?: ContactInfo[];
  address?: Address[];
  tin?: string;
  VATNumber?: string;
  paymentTerms?: string;
  supplierCode?: string;
  customerCode?: string;
  rating?: number;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  suspended?: Action;
  statusModified?: Action;
  isInternational?: boolean;
  bankingDetailsVerified?: boolean;
  isTaxClearanceValid?: boolean;
  taxClearanceExpiryDate?: any;
  isStakeholderVerified?: boolean;
  updateHistory?: Action[];
  [key: string]: any;
};
export type Stakeholder = {
  id?: string;
  name: string;
  type: string;
  contactInfo: ContactInfo[];
  address: Address[];
  tin?: string;
  VATNumber?: string;
  paymentTerms?: string;
  supplierCode?: string;
  customerCode?: string;
  rating?: number;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  suspended?: Action;
  statusModified?: Action;
  isInternational?: boolean;
  bankingDetailsVerified?: boolean;
  isTaxClearanceValid: boolean;
  taxClearanceExpiryDate?: any;
  isStakeholderVerified: boolean;
  updateHistory?: Action[];
  [key: string]: any;
};
export type NewStakeholder = {
  name: string;
  type: string;
  contactInfo: ContactInfo[];
  address: Address[];
  tin?: string;
  VATNumber?: string;
  paymentTerms?: string;
  supplierCode?: string;
  customerCode?: string;
  rating?: number;
  notes?: Note[];
  latestAction?: Action;
  statusModificationRequest?: Action;
  suspended?: Action;
  statusModified?: Action;
  isInternational?: boolean;
  bankingDetailsVerified?: boolean;
  isTaxClearanceValid: boolean;
  taxClearanceExpiryDate?: any;
  isStakeholderVerified: boolean;
  updateHistory?: Action[];
  [key: string]: any;
};
export type SuperVisee = {
  userId: string;
  name: string;
  department: string;
  jobTitle: string;
};
export type SupervisorPartial = {
  id?: string;
  userId?: string;
  supervisees?: SuperVisee[];
};
export type Supervisor = {
  userId?: string;
  supervisees?: SuperVisee[];
};
export type SupervisorData = {
  userId?: string;
  supervisees?: SuperVisee[];
};
export type SupervisorWithRelations = {
  id?: string;
  userId?: string;
  supervisees?: SuperVisee[];
  user?: UserWithRelations;
};
export type Unit = {
  id?: string;
  unitName: string;
  development: EntityIdentity;
  project: EntityIdentity;
};
export type UnitData = {
  unitName: string;
  development: EntityIdentity;
  project: EntityIdentity;
};
export type UnitWithRelations = {
  id?: string;
  unitName: string;
  development: EntityIdentity;
  project: EntityIdentity;
};
export type UnitPartial = {
  id?: string;
  unitName?: string;
  development?: EntityIdentity;
  project?: EntityIdentity;
};
export type UserWithPassword = {
  email?: string;
  name?: string;
  department?: string;
  gender?: string;
  jobTitle?: any;
  idNumber?: any;
  reportsToUserId?: string | null;
  jobDescriptionId?: string | null;
  grade?: string | null;
  hireDate?: string | null;
  employeeNumber?: string | null;
  isActive?: boolean;
  password: string;
};
export type VatInvoicePartial = {
  id?: string;
  debtorId?: string;
  developmentId?: string;
  linkedInvoiceId?: string;
  invoiceNo?: string;
  invoiceDate?: string;
  dueDate?: string;
  description?: string;
  totalExcl?: number;
  vatRate?: number;
  vatAmount?: number;
  totalIncl?: number;
  status?: "pending" | "submitted" | "paid" | "overdue" | "cancelled";
  vatPeriod?: string;
  invoiceType?: "sales" | "purchase" | "adjustment";
  notes?: string;
  debtorName?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  [key: string]: any;
};
export type NewVatInvoice = {
  debtorId: string;
  developmentId?: string;
  linkedInvoiceId?: string;
  invoiceNo: string;
  invoiceDate: string;
  dueDate?: string;
  description: string;
  totalExcl: number;
  vatRate?: number;
  vatAmount: number;
  totalIncl: number;
  status?: "pending" | "submitted" | "paid" | "overdue" | "cancelled";
  vatPeriod?: string;
  invoiceType: "sales" | "purchase" | "adjustment";
  notes?: string;
  debtorName?: string;
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  [key: string]: any;
};
export type VatPaymentPartial = {
  id?: string;
  debtorId?: string;
  developmentId?: string;
  linkedPaymentId?: string;
  receiptNo?: string;
  paymentDate?: string;
  description?: string;
  totalExcl?: number;
  vatRate?: number;
  vatAmount?: number;
  totalIncl?: number;
  status?: "pending" | "reconciled" | "reversed" | "cancelled";
  vatType?: "input" | "output";
  vatPeriod?: string;
  paymentMethod?: "bank" | "cash" | "ecocash" | "swipe" | "cheque" | "transfer";
  reference?: string;
  notes?: string;
  reconciliationDate?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  [key: string]: any;
};
export type NewVatPayment = {
  debtorId?: string;
  developmentId?: string;
  linkedPaymentId?: string;
  receiptNo: string;
  paymentDate: string;
  description: string;
  totalExcl: number;
  vatRate?: number;
  vatAmount: number;
  totalIncl: number;
  status?: "pending" | "reconciled" | "reversed" | "cancelled";
  vatType: "input" | "output";
  vatPeriod?: string;
  paymentMethod?: "bank" | "cash" | "ecocash" | "swipe" | "cheque" | "transfer";
  reference?: string;
  notes?: string;
  reconciliationDate?: string;
  captureMode?: "single" | "bulk-import" | "take-on";
  importBatchId?: string;
  sourceRowNo?: number;
  [key: string]: any;
};
export const {
  useGet360ReviewsByUserByUserIdQuery,
  useLazyGet360ReviewsByUserByUserIdQuery,
  useGetInventoryLocationsCountQuery,
  useLazyGetInventoryLocationsCountQuery,
  useGetInventoryLocationsByIdQuery,
  useLazyGetInventoryLocationsByIdQuery,
  useDeleteInventoryLocationsByIdMutation,
  usePostInventoryLocationsMutation,
  useGetInventoryLocationsQuery,
  useLazyGetInventoryLocationsQuery,
  useGetAccessApplicationsCountQuery,
  useLazyGetAccessApplicationsCountQuery,
  usePutAccessApplicationsByIdMutation,
  useGetAccessApplicationsByIdQuery,
  useLazyGetAccessApplicationsByIdQuery,
  useDeleteAccessApplicationsByIdMutation,
  usePostAccessApplicationsMutation,
  useGetAccessApplicationsQuery,
  useLazyGetAccessApplicationsQuery,
  useGetAccessLogsCountQuery,
  useLazyGetAccessLogsCountQuery,
  useGetAccessLogsByIdQuery,
  useLazyGetAccessLogsByIdQuery,
  useDeleteAccessLogsByIdMutation,
  usePostAccessLogsMutation,
  useGetAccessLogsQuery,
  useLazyGetAccessLogsQuery,
  usePostAddEmployeeReviewMutation,
  usePostAddInviteMutation,
  usePostAddLifeWheelMutation,
  usePostAgreementsClientCreateMutation,
  usePostAgreementsEmploymentCreateMutation,
  useGetAllLifeWheelsQuery,
  useLazyGetAllLifeWheelsQuery,
  useGetAllSpearReviewsQuery,
  useLazyGetAllSpearReviewsQuery,
  usePostAmortisationGenerateByDebtorIdMutation,
  useGetAmortisationSummaryByDebtorIdQuery,
  useLazyGetAmortisationSummaryByDebtorIdQuery,
  usePatchAmortisationByScheduleIdMarkPaidMutation,
  useGetAmortisationByDebtorIdQuery,
  useLazyGetAmortisationByDebtorIdQuery,
  useDeleteAmortisationByDebtorIdMutation,
  useGetBalancedScorecardsByPeriodByPeriodQuery,
  useLazyGetBalancedScorecardsByPeriodByPeriodQuery,
  useGetBalancedScorecardsByUserByUserIdQuery,
  useLazyGetBalancedScorecardsByUserByUserIdQuery,
  useGetBalancedScorecardsCountQuery,
  useLazyGetBalancedScorecardsCountQuery,
  useGetBalancedScorecardsMySubmissionsQuery,
  useLazyGetBalancedScorecardsMySubmissionsQuery,
  useGetBalancedScorecardsOrgChartByJobDescriptionIdReportsQuery,
  useLazyGetBalancedScorecardsOrgChartByJobDescriptionIdReportsQuery,
  useGetBalancedScorecardsOrgChartQuery,
  useLazyGetBalancedScorecardsOrgChartQuery,
  useGetBalancedScorecardsPendingReviewQuery,
  useLazyGetBalancedScorecardsPendingReviewQuery,
  useGetBalancedScorecardsTeamSubmissionsQuery,
  useLazyGetBalancedScorecardsTeamSubmissionsQuery,
  usePatchBalancedScorecardsByIdApproveMutation,
  usePatchBalancedScorecardsByIdRejectMutation,
  usePatchBalancedScorecardsByIdRevertToDraftMutation,
  usePatchBalancedScorecardsByIdSubmitMutation,
  usePatchBalancedScorecardsByIdMutation,
  useGetBalancedScorecardsByIdQuery,
  useLazyGetBalancedScorecardsByIdQuery,
  useDeleteBalancedScorecardsByIdMutation,
  usePostBalancedScorecardsMutation,
  useGetBalancedScorecardsQuery,
  useLazyGetBalancedScorecardsQuery,
  useGetBomByDevelopmentByDevelopmentIdQuery,
  useLazyGetBomByDevelopmentByDevelopmentIdQuery,
  useGetBomByProjectByProjectIdQuery,
  useLazyGetBomByProjectByProjectIdQuery,
  useGetBomCountQuery,
  useLazyGetBomCountQuery,
  usePostBomExternalItemMappingUploadMutation,
  usePatchBomByIdMutation,
  useGetBomByIdQuery,
  useLazyGetBomByIdQuery,
  useDeleteBomByIdMutation,
  usePostBomMutation,
  useGetBomQuery,
  useLazyGetBomQuery,
  useGetBomItemAuditTrailsByBomItemByBomItemIdQuery,
  useLazyGetBomItemAuditTrailsByBomItemByBomItemIdQuery,
  usePatchBomItemAuditTrailsByIdFirstApprovalMutation,
  usePatchBomItemAuditTrailsByIdSecondApprovalMutation,
  usePostBomItemAuditTrailsMutation,
  useGetBomItemsByBomByBomIdQuery,
  useLazyGetBomItemsByBomByBomIdQuery,
  useGetBomItemsByProjectByProjectIdQuery,
  useLazyGetBomItemsByProjectByProjectIdQuery,
  useGetBomItemsCountQuery,
  useLazyGetBomItemsCountQuery,
  usePatchBomItemsByIdFirstApprovalMutation,
  usePatchBomItemsByIdSecondApprovalMutation,
  usePutBomItemsByIdMutation,
  usePatchBomItemsByIdMutation,
  useGetBomItemsByIdQuery,
  useLazyGetBomItemsByIdQuery,
  useDeleteBomItemsByIdMutation,
  usePostBomItemsMutation,
  useGetBomItemsQuery,
  useLazyGetBomItemsQuery,
  useGetBusinessUnitsActiveQuery,
  useLazyGetBusinessUnitsActiveQuery,
  useGetBusinessUnitsCountQuery,
  useLazyGetBusinessUnitsCountQuery,
  usePostBusinessUnitsSeedDefaultsMutation,
  usePatchBusinessUnitsByIdMutation,
  useGetBusinessUnitsByIdQuery,
  useLazyGetBusinessUnitsByIdQuery,
  useDeleteBusinessUnitsByIdMutation,
  usePostBusinessUnitsMutation,
  useGetBusinessUnitsQuery,
  useLazyGetBusinessUnitsQuery,
  useGetCashbookAccountBalancesQuery,
  useLazyGetCashbookAccountBalancesQuery,
  usePostCashbookMutation,
  useGetCashbookQuery,
  useLazyGetCashbookQuery,
  useGetCashflowForecastQuery,
  useLazyGetCashflowForecastQuery,
  useGetCashflowVarianceQuery,
  useLazyGetCashflowVarianceQuery,
  useGetCashflowVarianceHistoryQuery,
  useLazyGetCashflowVarianceHistoryQuery,
  useGetCastingToolPeriodByReviewPeriodQuery,
  useLazyGetCastingToolPeriodByReviewPeriodQuery,
  usePatchCastingToolByIdMutation,
  useGetCastingToolByIdQuery,
  useLazyGetCastingToolByIdQuery,
  usePostCastingToolMutation,
  useGetCastingToolsAllQuery,
  useLazyGetCastingToolsAllQuery,
  useGetCastingToolsDepartmentByDepartmentQuery,
  useLazyGetCastingToolsDepartmentByDepartmentQuery,
  useGetCastingToolsDepartmentStatsQuery,
  useLazyGetCastingToolsDepartmentStatsQuery,
  useGetCastingToolsMyQuery,
  useLazyGetCastingToolsMyQuery,
  useGetCastingToolsByUserByUserIdQuery,
  useLazyGetCastingToolsByUserByUserIdQuery,
  useGetCeoDashboardBscPerspectivesQuery,
  useLazyGetCeoDashboardBscPerspectivesQuery,
  useGetCeoDashboardDepartmentsByDepartmentEmployeesQuery,
  useLazyGetCeoDashboardDepartmentsByDepartmentEmployeesQuery,
  useGetCeoDashboardDepartmentsByDepartmentQuery,
  useLazyGetCeoDashboardDepartmentsByDepartmentQuery,
  useGetCeoDashboardDepartmentsQuery,
  useLazyGetCeoDashboardDepartmentsQuery,
  useGetCeoDashboardEmployeesByEmployeeIdQuery,
  useLazyGetCeoDashboardEmployeesByEmployeeIdQuery,
  useGetCeoDashboardEmployeesQuery,
  useLazyGetCeoDashboardEmployeesQuery,
  useGetCeoDashboardLifeWheelQuery,
  useLazyGetCeoDashboardLifeWheelQuery,
  useGetCeoDashboardNeedsAttentionQuery,
  useLazyGetCeoDashboardNeedsAttentionQuery,
  useGetCeoDashboardOrganizationQuery,
  useLazyGetCeoDashboardOrganizationQuery,
  useGetCeoDashboardTopPerformersQuery,
  useLazyGetCeoDashboardTopPerformersQuery,
  usePostClientMutation,
  useGetClientsQuery,
  useLazyGetClientsQuery,
  useGetCompetenciesActiveQuery,
  useLazyGetCompetenciesActiveQuery,
  useGetCompetenciesByCategoryByCategoryQuery,
  useLazyGetCompetenciesByCategoryByCategoryQuery,
  useGetCompetenciesCountQuery,
  useLazyGetCompetenciesCountQuery,
  usePostCompetenciesSeedDefaultsMutation,
  usePatchCompetenciesByIdMutation,
  useGetCompetenciesByIdQuery,
  useLazyGetCompetenciesByIdQuery,
  useDeleteCompetenciesByIdMutation,
  usePostCompetenciesMutation,
  useGetCompetenciesQuery,
  useLazyGetCompetenciesQuery,
  usePostComsBlocksByBlockIdBaselineActualsMutation,
  useGetComsBlocksByBlockIdEvmOverviewQuery,
  useLazyGetComsBlocksByBlockIdEvmOverviewQuery,
  useGetComsBlocksByBlockIdHasActualsQuery,
  useLazyGetComsBlocksByBlockIdHasActualsQuery,
  useGetComsBlocksByIdStatsQuery,
  useLazyGetComsBlocksByIdStatsQuery,
  usePostComsBlocksByBlockIdUploadAuditMutation,
  useGetComsBlocksByBlockIdUploadAuditQuery,
  useLazyGetComsBlocksByBlockIdUploadAuditQuery,
  usePatchComsBlocksByIdMutation,
  useGetComsBlocksByIdQuery,
  useLazyGetComsBlocksByIdQuery,
  useDeleteComsBlocksByIdMutation,
  usePostComsBlocksMutation,
  useGetComsBlocksQuery,
  useLazyGetComsBlocksQuery,
  usePatchComsCatalogByIdMutation,
  useGetComsCatalogByIdQuery,
  useLazyGetComsCatalogByIdQuery,
  useDeleteComsCatalogByIdMutation,
  usePostComsCatalogMutation,
  useGetComsCatalogQuery,
  useLazyGetComsCatalogQuery,
  useDeleteComsMatDeliveriesByIdMutation,
  usePostComsMatDeliveriesMutation,
  useGetComsMatDeliveriesQuery,
  useLazyGetComsMatDeliveriesQuery,
  usePostComsMonthlyReportRecordsBackfillMutation,
  usePostComsMonthlyReportRecordsGenerateMutation,
  usePostComsMonthlyReportRecordsRegenerateForDateMutation,
  usePatchComsMonthlyReportRecordsByIdMutation,
  useGetComsMonthlyReportRecordsByIdQuery,
  useLazyGetComsMonthlyReportRecordsByIdQuery,
  useDeleteComsMonthlyReportRecordsByIdMutation,
  useGetComsMonthlyReportRecordsQuery,
  useLazyGetComsMonthlyReportRecordsQuery,
  useGetComsReportsMonthlyQuery,
  useLazyGetComsReportsMonthlyQuery,
  useGetComsReportsWorkDoneQuery,
  useLazyGetComsReportsWorkDoneQuery,
  usePatchComsReportsByIdMutation,
  useGetComsReportsByIdQuery,
  useLazyGetComsReportsByIdQuery,
  useDeleteComsReportsByIdMutation,
  usePostComsReportsMutation,
  useGetComsReportsQuery,
  useLazyGetComsReportsQuery,
  usePostComsWeeklyReportsBackfillMutation,
  usePostComsWeeklyReportsGenerateMutation,
  usePostComsWeeklyReportsRegenerateForDateMutation,
  usePatchComsWeeklyReportsByIdMutation,
  useGetComsWeeklyReportsByIdQuery,
  useLazyGetComsWeeklyReportsByIdQuery,
  useDeleteComsWeeklyReportsByIdMutation,
  useGetComsWeeklyReportsQuery,
  useLazyGetComsWeeklyReportsQuery,
  useGetContractItemAuditTrailsByContractItemByContractItemIdQuery,
  useLazyGetContractItemAuditTrailsByContractItemByContractItemIdQuery,
  usePatchContractItemAuditTrailsByIdFirstApprovalMutation,
  usePatchContractItemAuditTrailsByIdSecondApprovalMutation,
  usePostContractItemAuditTrailsMutation,
  useGetContractItemsByContractByContractIdQuery,
  useLazyGetContractItemsByContractByContractIdQuery,
  useGetContractItemsCountQuery,
  useLazyGetContractItemsCountQuery,
  usePatchContractItemsByIdFirstApprovalMutation,
  usePatchContractItemsByIdSecondApprovalMutation,
  usePutContractItemsByIdMutation,
  usePatchContractItemsByIdMutation,
  useGetContractItemsByIdQuery,
  useLazyGetContractItemsByIdQuery,
  useDeleteContractItemsByIdMutation,
  usePostContractItemsMutation,
  useGetContractItemsQuery,
  useLazyGetContractItemsQuery,
  usePostCreateGrvMutation,
  usePostCreateProcurementProcessMutation,
  usePostCreatePurchaseOrderMutation,
  usePostCreateRequisitionMutation,
  usePostCreateRequisitionReviewMutation,
  useGetCreditorsAgeAnalysisReportPdfQuery,
  useLazyGetCreditorsAgeAnalysisReportPdfQuery,
  useGetCreditorsAgeAnalysisQuery,
  useLazyGetCreditorsAgeAnalysisQuery,
  useGetCreditorsCountQuery,
  useLazyGetCreditorsCountQuery,
  useGetCreditorsByIdFullQuery,
  useLazyGetCreditorsByIdFullQuery,
  usePostCreditorsByIdInvoicesMutation,
  useGetCreditorsByIdInvoicesQuery,
  useLazyGetCreditorsByIdInvoicesQuery,
  usePostCreditorsByIdPaymentsMutation,
  useGetCreditorsByIdPaymentsQuery,
  useLazyGetCreditorsByIdPaymentsQuery,
  usePatchCreditorsByIdMutation,
  useGetCreditorsByIdQuery,
  useLazyGetCreditorsByIdQuery,
  useDeleteCreditorsByIdMutation,
  usePostCreditorsMutation,
  useGetCreditorsQuery,
  useLazyGetCreditorsQuery,
  useGetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesQuery,
  useLazyGetDashboardDataSourcesBySourceIdDimensionsAndDimensionIdValuesQuery,
  useGetDashboardDataSourcesByIdDimensionsQuery,
  useLazyGetDashboardDataSourcesByIdDimensionsQuery,
  useGetDashboardDataSourcesByIdMetricsQuery,
  useLazyGetDashboardDataSourcesByIdMetricsQuery,
  useGetDashboardDataSourcesQuery,
  useLazyGetDashboardDataSourcesQuery,
  useGetDashboardLayoutsByIdQuery,
  useLazyGetDashboardLayoutsByIdQuery,
  useGetDashboardLayoutsQuery,
  useLazyGetDashboardLayoutsQuery,
  usePostDashboardsByIdDataMutation,
  usePostDashboardsByIdDrilldownMutation,
  usePostDashboardsByIdPermissionsMutation,
  usePutDashboardsByIdMutation,
  useGetDashboardsByIdQuery,
  useLazyGetDashboardsByIdQuery,
  useDeleteDashboardsByIdMutation,
  usePostDashboardsMutation,
  useGetDashboardsQuery,
  useLazyGetDashboardsQuery,
  usePatchDebtorInvoicesByIdMutation,
  useDeleteDebtorInvoicesByIdMutation,
  useGetDebtorInvoicesQuery,
  useLazyGetDebtorInvoicesQuery,
  useGetDebtorsAgeAnalysisReportPdfQuery,
  useLazyGetDebtorsAgeAnalysisReportPdfQuery,
  useGetDebtorsAgeAnalysisQuery,
  useLazyGetDebtorsAgeAnalysisQuery,
  useGetDebtorsAgingFromExcelQuery,
  useLazyGetDebtorsAgingFromExcelQuery,
  usePatchDebtorsBulkAgeMutation,
  useGetDebtorsComprehensiveAgingQuery,
  useLazyGetDebtorsComprehensiveAgingQuery,
  useGetDebtorsCountQuery,
  useLazyGetDebtorsCountQuery,
  useGetDebtorsDebugAgedCountQuery,
  useLazyGetDebtorsDebugAgedCountQuery,
  usePatchDebtorsDebugClearAllAgedMutation,
  useGetDebtorsDebugClearAllAgedQuery,
  useLazyGetDebtorsDebugClearAllAgedQuery,
  useGetDebtorsByIdFullQuery,
  useLazyGetDebtorsByIdFullQuery,
  usePostDebtorsByIdInvoicesMutation,
  useGetDebtorsByIdInvoicesQuery,
  useLazyGetDebtorsByIdInvoicesQuery,
  useGetDebtorsByDebtorIdPaymentsQuery,
  useLazyGetDebtorsByDebtorIdPaymentsQuery,
  usePostDebtorsByIdReceiptsMutation,
  useGetDebtorsByIdReceiptsQuery,
  useLazyGetDebtorsByIdReceiptsQuery,
  usePostDebtorsByIdStatementEmailMutation,
  useGetDebtorsByIdStatementPdfQuery,
  useLazyGetDebtorsByIdStatementPdfQuery,
  useGetDebtorsByIdStatementQuery,
  useLazyGetDebtorsByIdStatementQuery,
  useGetDebtorsByDebtorIdTransactionsAllQuery,
  useLazyGetDebtorsByDebtorIdTransactionsAllQuery,
  useGetDebtorsByDebtorIdTransactionsSummaryQuery,
  useLazyGetDebtorsByDebtorIdTransactionsSummaryQuery,
  useGetDebtorsByDebtorIdVatInvoicesQuery,
  useLazyGetDebtorsByDebtorIdVatInvoicesQuery,
  useGetDebtorsByDebtorIdVatPaymentsQuery,
  useLazyGetDebtorsByDebtorIdVatPaymentsQuery,
  usePostDebtorsByIdVatStatementEmailMutation,
  useGetDebtorsByIdVatStatementPdfQuery,
  useLazyGetDebtorsByIdVatStatementPdfQuery,
  useGetDebtorsByIdVatStatementQuery,
  useLazyGetDebtorsByIdVatStatementQuery,
  usePatchDebtorsByIdMutation,
  useGetDebtorsByIdQuery,
  useLazyGetDebtorsByIdQuery,
  useDeleteDebtorsByIdMutation,
  usePostDebtorsMutation,
  useGetDebtorsQuery,
  useLazyGetDebtorsQuery,
  usePostDevelopmentMutation,
  useGetDevelopmentsCountQuery,
  useLazyGetDevelopmentsCountQuery,
  useGetDevelopmentsProjectsQuery,
  useLazyGetDevelopmentsProjectsQuery,
  usePutDevelopmentsByIdMutation,
  usePatchDevelopmentsByIdMutation,
  useGetDevelopmentsByIdQuery,
  useLazyGetDevelopmentsByIdQuery,
  useDeleteDevelopmentsByIdMutation,
  usePatchDevelopmentsMutation,
  useGetDevelopmentsQuery,
  useLazyGetDevelopmentsQuery,
  usePatchEmployeeReviewByIdCompleteGoalMutation,
  usePatchEmployeeReviewByIdMutation,
  useGetEmployeeReviewByIdQuery,
  useLazyGetEmployeeReviewByIdQuery,
  useGetEmployeeReviewsGoalStatisticsQuery,
  useLazyGetEmployeeReviewsGoalStatisticsQuery,
  useGetEmployeeReviewsByUserByUserIdQuery,
  useLazyGetEmployeeReviewsByUserByUserIdQuery,
  usePatchExternalItemMapsByIdMutation,
  useGetExternalItemMapsQuery,
  useLazyGetExternalItemMapsQuery,
  useGetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodQuery,
  useLazyGetFeedbackSurveyDraftByUserIdAndReviewerIdReviewPeriodQuery,
  usePutFeedbackSurveyDraftMutation,
  useGetFeedbackSurveyMySubmissionsQuery,
  useLazyGetFeedbackSurveyMySubmissionsQuery,
  useGetFeedbackSurveyByIdQuery,
  useLazyGetFeedbackSurveyByIdQuery,
  usePostFeedbackSurveyMutation,
  usePatchFinanceAccountsByIdMutation,
  useGetFinanceAccountsByIdQuery,
  useLazyGetFinanceAccountsByIdQuery,
  usePostFinanceAccountsMutation,
  useGetFinanceAccountsQuery,
  useLazyGetFinanceAccountsQuery,
  usePostFinanceBudgetsByIdActivateMutation,
  usePostFinanceBudgetsByIdApproveMutation,
  useGetFinanceBudgetsByIdUtilizationQuery,
  useLazyGetFinanceBudgetsByIdUtilizationQuery,
  usePatchFinanceBudgetsByIdMutation,
  useGetFinanceBudgetsByIdQuery,
  useLazyGetFinanceBudgetsByIdQuery,
  usePostFinanceBudgetsMutation,
  useGetFinanceBudgetsQuery,
  useLazyGetFinanceBudgetsQuery,
  useGetFinanceDashboardQuery,
  useLazyGetFinanceDashboardQuery,
  usePostFinanceExpenseReportsByIdAddExpenseMutation,
  usePostFinanceExpenseReportsByIdApproveMutation,
  usePostFinanceExpenseReportsByIdReimburseMutation,
  usePostFinanceExpenseReportsByIdRejectMutation,
  usePostFinanceExpenseReportsByIdSubmitMutation,
  usePatchFinanceExpenseReportsByIdMutation,
  useGetFinanceExpenseReportsByIdQuery,
  useLazyGetFinanceExpenseReportsByIdQuery,
  usePostFinanceExpenseReportsMutation,
  useGetFinanceExpenseReportsQuery,
  useLazyGetFinanceExpenseReportsQuery,
  useGetFinanceInvoicesAccountsPayableSummaryQuery,
  useLazyGetFinanceInvoicesAccountsPayableSummaryQuery,
  useGetFinanceInvoicesAccountsReceivableSummaryQuery,
  useLazyGetFinanceInvoicesAccountsReceivableSummaryQuery,
  usePostFinanceInvoicesByIdApproveMutation,
  usePostFinanceInvoicesByIdRecordPaymentMutation,
  usePatchFinanceInvoicesByIdMutation,
  useGetFinanceInvoicesByIdQuery,
  useLazyGetFinanceInvoicesByIdQuery,
  usePostFinanceInvoicesMutation,
  useGetFinanceInvoicesQuery,
  useLazyGetFinanceInvoicesQuery,
  useGetFinanceMonthlyInstalmentsQuery,
  useLazyGetFinanceMonthlyInstalmentsQuery,
  useGetFinanceReportsExpenseSummaryByCategoryQuery,
  useLazyGetFinanceReportsExpenseSummaryByCategoryQuery,
  useGetFinanceReportsExpenseSummaryByEmployeeQuery,
  useLazyGetFinanceReportsExpenseSummaryByEmployeeQuery,
  useGetFinanceReportsGeneralLedgerByAccountIdQuery,
  useLazyGetFinanceReportsGeneralLedgerByAccountIdQuery,
  useGetFinanceReportsTrialBalanceQuery,
  useLazyGetFinanceReportsTrialBalanceQuery,
  usePostFinanceTransactionsByIdApproveMutation,
  usePostFinanceTransactionsByIdPostMutation,
  usePostFinanceTransactionsByIdReverseMutation,
  useGetFinanceTransactionsByIdQuery,
  useLazyGetFinanceTransactionsByIdQuery,
  usePostFinanceTransactionsMutation,
  useGetFinanceTransactionsQuery,
  useLazyGetFinanceTransactionsQuery,
  usePostGetSignedUrlMutation,
  useGetGradingConfigActiveQuery,
  useLazyGetGradingConfigActiveQuery,
  usePostGradingConfigResetToDefaultMutation,
  usePatchGradingConfigByIdMutation,
  usePostGradingConfigMutation,
  useGetGradingConfigQuery,
  useLazyGetGradingConfigQuery,
  useGetGrvsDropdownQuery,
  useLazyGetGrvsDropdownQuery,
  usePatchGrvsByIdMutation,
  useGetGrvsByIdQuery,
  useLazyGetGrvsByIdQuery,
  useGetGrvsQuery,
  useLazyGetGrvsQuery,
  usePostImportCreditorsMutation,
  usePostImportDebtorInvoicesMutation,
  usePostImportDebtorsMutation,
  usePostImportPaymentsMutation,
  usePostImportReceiptsMutation,
  usePostImportTakeOnTransactionsMutation,
  useGetImportTemplatesCreditorsQuery,
  useLazyGetImportTemplatesCreditorsQuery,
  useGetImportTemplatesDebtorInvoicesQuery,
  useLazyGetImportTemplatesDebtorInvoicesQuery,
  useGetImportTemplatesDebtorsQuery,
  useLazyGetImportTemplatesDebtorsQuery,
  useGetImportTemplatesPaymentsQuery,
  useLazyGetImportTemplatesPaymentsQuery,
  useGetImportTemplatesReceiptsQuery,
  useLazyGetImportTemplatesReceiptsQuery,
  useGetImportTemplatesTakeOnTransactionsQuery,
  useLazyGetImportTemplatesTakeOnTransactionsQuery,
  useGetImportTemplatesVatInvoicesQuery,
  useLazyGetImportTemplatesVatInvoicesQuery,
  useGetImportTemplatesVatPaymentsQuery,
  useLazyGetImportTemplatesVatPaymentsQuery,
  usePostImportVatInvoicesMutation,
  usePostImportVatPaymentsMutation,
  useGetInventoriesCountQuery,
  useLazyGetInventoriesCountQuery,
  useGetInventoriesByIdQuery,
  useLazyGetInventoriesByIdQuery,
  useDeleteInventoriesByIdMutation,
  usePostInventoriesMutation,
  useGetInventoriesQuery,
  useLazyGetInventoriesQuery,
  usePatchInviteMarkAsScannedByIdMutation,
  useGetInviteByIdQuery,
  useLazyGetInviteByIdQuery,
  useGetInvitesQuery,
  useLazyGetInvitesQuery,
  useGetItemCategoriesCountQuery,
  useLazyGetItemCategoriesCountQuery,
  useGetItemCategoriesByIdQuery,
  useLazyGetItemCategoriesByIdQuery,
  useDeleteItemCategoriesByIdMutation,
  usePostItemCategoriesMutation,
  useGetItemCategoriesQuery,
  useLazyGetItemCategoriesQuery,
  useGetItemLocationsCountQuery,
  useLazyGetItemLocationsCountQuery,
  useGetItemLocationsByIdQuery,
  useLazyGetItemLocationsByIdQuery,
  useDeleteItemLocationsByIdMutation,
  usePostItemLocationsMutation,
  useGetItemLocationsQuery,
  useLazyGetItemLocationsQuery,
  useGetItemTransfersCountQuery,
  useLazyGetItemTransfersCountQuery,
  useGetItemTransfersByIdQuery,
  useLazyGetItemTransfersByIdQuery,
  useDeleteItemTransfersByIdMutation,
  usePostItemTransfersMutation,
  useGetItemTransfersQuery,
  useLazyGetItemTransfersQuery,
  useGetItemsCountQuery,
  useLazyGetItemsCountQuery,
  useGetItemsDropdownQuery,
  useLazyGetItemsDropdownQuery,
  useGetItemsByIdQuery,
  useLazyGetItemsByIdQuery,
  useDeleteItemsByIdMutation,
  usePostItemsMutation,
  useGetItemsQuery,
  useLazyGetItemsQuery,
  usePostItemsIssuedMutation,
  useGetItemsIssuedQuery,
  useLazyGetItemsIssuedQuery,
  useGetJobDescriptionsActiveQuery,
  useLazyGetJobDescriptionsActiveQuery,
  useGetJobDescriptionsByDepartmentByDepartmentQuery,
  useLazyGetJobDescriptionsByDepartmentByDepartmentQuery,
  useGetJobDescriptionsCountQuery,
  useLazyGetJobDescriptionsCountQuery,
  useGetJobDescriptionsDepartmentsQuery,
  useLazyGetJobDescriptionsDepartmentsQuery,
  useGetJobDescriptionsGradesQuery,
  useLazyGetJobDescriptionsGradesQuery,
  usePostJobDescriptionsMyMutation,
  usePatchJobDescriptionsMyMutation,
  useGetJobDescriptionsMyQuery,
  useLazyGetJobDescriptionsMyQuery,
  useDeleteJobDescriptionsMyMutation,
  usePostJobDescriptionsRecalculateAllCountsMutation,
  useGetJobDescriptionsTeamQuery,
  useLazyGetJobDescriptionsTeamQuery,
  useGetJobDescriptionsUserByUserIdQuery,
  useLazyGetJobDescriptionsUserByUserIdQuery,
  usePostJobDescriptionsByIdAssignMutation,
  useGetJobDescriptionsByIdReportsCountsQuery,
  useLazyGetJobDescriptionsByIdReportsCountsQuery,
  usePostJobDescriptionsByIdUnassignMutation,
  usePutJobDescriptionsByIdMutation,
  usePatchJobDescriptionsByIdMutation,
  useGetJobDescriptionsByIdQuery,
  useLazyGetJobDescriptionsByIdQuery,
  useDeleteJobDescriptionsByIdMutation,
  usePostJobDescriptionsMutation,
  useGetJobDescriptionsQuery,
  useLazyGetJobDescriptionsQuery,
  usePostKnowledgeBaseMutation,
  useGetKnowledgeBaseQuery,
  useLazyGetKnowledgeBaseQuery,
  usePostLabourAttendanceBatchMutation,
  useGetLabourAttendanceQuery,
  useLazyGetLabourAttendanceQuery,
  usePatchLabourBlocksByIdMutation,
  useDeleteLabourBlocksByIdMutation,
  usePostLabourBlocksMutation,
  useGetLabourBlocksQuery,
  useLazyGetLabourBlocksQuery,
  useGetLabourReportsDailyQuery,
  useLazyGetLabourReportsDailyQuery,
  useGetLabourReportsDashboardQuery,
  useLazyGetLabourReportsDashboardQuery,
  useGetLabourReportsPayrollQuery,
  useLazyGetLabourReportsPayrollQuery,
  useGetLabourReportsRangeQuery,
  useLazyGetLabourReportsRangeQuery,
  usePostLabourWorkersImportOdooMutation,
  usePatchLabourWorkersByIdMutation,
  useDeleteLabourWorkersByIdMutation,
  usePostLabourWorkersMutation,
  useGetLabourWorkersQuery,
  useLazyGetLabourWorkersQuery,
  useGetLifeWheelByIdQuery,
  useLazyGetLifeWheelByIdQuery,
  useGetLifeWheelsByUserByUserIdQuery,
  useLazyGetLifeWheelsByUserByUserIdQuery,
  useGetOrgChartDepartmentByDepartmentQuery,
  useLazyGetOrgChartDepartmentByDepartmentQuery,
  useGetOrgChartSupervisorsQuery,
  useLazyGetOrgChartSupervisorsQuery,
  useGetOrgChartUserByUserIdDirectReportsQuery,
  useLazyGetOrgChartUserByUserIdDirectReportsQuery,
  useGetOrgChartUserByUserIdReportingChainQuery,
  useLazyGetOrgChartUserByUserIdReportingChainQuery,
  useGetOrgChartUserByUserIdQuery,
  useLazyGetOrgChartUserByUserIdQuery,
  useGetOrgChartQuery,
  useLazyGetOrgChartQuery,
  useGetPasswordResetIsResetLinkValidByResetIdQuery,
  useLazyGetPasswordResetIsResetLinkValidByResetIdQuery,
  usePostPasswordResetRequestByUserEmailMutation,
  usePostPasswordResetResetPasswordMutation,
  usePatchPaymentRequisitionsByIdMutation,
  usePostPaymentRequisitionsMutation,
  useGetPaymentRequisitionsQuery,
  useLazyGetPaymentRequisitionsQuery,
  useGetPaymentsCountQuery,
  useLazyGetPaymentsCountQuery,
  usePatchPaymentsByIdMutation,
  useGetPaymentsByIdQuery,
  useLazyGetPaymentsByIdQuery,
  useDeletePaymentsByIdMutation,
  usePostPaymentsMutation,
  useGetPaymentsQuery,
  useLazyGetPaymentsQuery,
  usePostPayrollUploadMutation,
  useGetPearReviewsAdminAllQuery,
  useLazyGetPearReviewsAdminAllQuery,
  useGetPearReviewsByEmployeeByEmployeeIdQuery,
  useLazyGetPearReviewsByEmployeeByEmployeeIdQuery,
  useGetPearReviewsCountQuery,
  useLazyGetPearReviewsCountQuery,
  useGetPearReviewsMyDirectReportsQuery,
  useLazyGetPearReviewsMyDirectReportsQuery,
  useGetPearReviewsMyReviewsQuery,
  useLazyGetPearReviewsMyReviewsQuery,
  useGetPearReviewsRatingScaleQuery,
  useLazyGetPearReviewsRatingScaleQuery,
  useGetPearReviewsSummaryQuery,
  useLazyGetPearReviewsSummaryQuery,
  useGetPearReviewsTemplateQuery,
  useLazyGetPearReviewsTemplateQuery,
  usePostPearReviewsByIdApproveMutation,
  usePatchPearReviewsByIdManagerEditMutation,
  usePostPearReviewsByIdSubmitMutation,
  usePatchPearReviewsByIdMutation,
  useGetPearReviewsByIdQuery,
  useLazyGetPearReviewsByIdQuery,
  useDeletePearReviewsByIdMutation,
  usePostPearReviewsMutation,
  useGetPearReviewsQuery,
  useLazyGetPearReviewsQuery,
  usePostPerformanceAssessmentAlertsSmokeTestMutation,
  useGetPerformanceRatingsQuery,
  useLazyGetPerformanceRatingsQuery,
  usePostPettyCashBulkApproveMutation,
  usePostPettyCashMigratePaymentRequisitionsMutation,
  useGetPettyCashSummaryDashboardQuery,
  useLazyGetPettyCashSummaryDashboardQuery,
  usePatchPettyCashSummarySettingsMutation,
  useGetPettyCashSummarySettingsQuery,
  useLazyGetPettyCashSummarySettingsQuery,
  usePostPettyCashByIdApproveMutation,
  useGetPettyCashByIdAuditLogQuery,
  useLazyGetPettyCashByIdAuditLogQuery,
  usePostPettyCashByIdCancelMutation,
  usePostPettyCashByIdHoldMutation,
  usePostPettyCashByIdMarkPaidMutation,
  usePostPettyCashByIdMoreInfoMutation,
  usePatchPettyCashByIdPaymentDetailsMutation,
  usePostPettyCashByIdPrepareMutation,
  usePostPettyCashByIdRejectMutation,
  usePostPettyCashByIdSubmitMutation,
  usePostPettyCashByIdUploadMutation,
  usePatchPettyCashByIdUrgencyMutation,
  usePatchPettyCashByIdMutation,
  useGetPettyCashByIdQuery,
  useLazyGetPettyCashByIdQuery,
  usePostPettyCashMutation,
  useGetPettyCashQuery,
  useLazyGetPettyCashQuery,
  useGetPingQuery,
  useLazyGetPingQuery,
  useGetProcurementContractsBySupplierBySupplierIdQuery,
  useLazyGetProcurementContractsBySupplierBySupplierIdQuery,
  useGetProcurementContractsCountQuery,
  useLazyGetProcurementContractsCountQuery,
  usePatchProcurementContractsByIdMutation,
  useGetProcurementContractsByIdQuery,
  useLazyGetProcurementContractsByIdQuery,
  useDeleteProcurementContractsByIdMutation,
  usePostProcurementContractsMutation,
  useGetProcurementContractsQuery,
  useLazyGetProcurementContractsQuery,
  usePutProcurementProcessesByIdMutation,
  usePatchProcurementProcessesByIdMutation,
  useGetProcurementProcessesByIdQuery,
  useLazyGetProcurementProcessesByIdQuery,
  useDeleteProcurementProcessesByIdMutation,
  useGetProcurementProcessesQuery,
  useLazyGetProcurementProcessesQuery,
  useGetPropertiesQuery,
  useLazyGetPropertiesQuery,
  usePostPropertyMutation,
  useGetProtrackDashboardQuery,
  useLazyGetProtrackDashboardQuery,
  usePatchProtrackHandoversByIdMutation,
  useGetProtrackHandoversByIdQuery,
  useLazyGetProtrackHandoversByIdQuery,
  useDeleteProtrackHandoversByIdMutation,
  usePostProtrackHandoversMutation,
  useGetProtrackHandoversQuery,
  useLazyGetProtrackHandoversQuery,
  usePatchProtrackMilestonesByIdMutation,
  useGetProtrackMilestonesByIdQuery,
  useLazyGetProtrackMilestonesByIdQuery,
  useDeleteProtrackMilestonesByIdMutation,
  usePostProtrackMilestonesMutation,
  useGetProtrackMilestonesQuery,
  useLazyGetProtrackMilestonesQuery,
  useGetProtrackProjectsPortfolioQuery,
  useLazyGetProtrackProjectsPortfolioQuery,
  usePatchProtrackProjectsByIdMutation,
  useGetProtrackProjectsByIdQuery,
  useLazyGetProtrackProjectsByIdQuery,
  useDeleteProtrackProjectsByIdMutation,
  usePostProtrackProjectsMutation,
  useGetProtrackProjectsQuery,
  useLazyGetProtrackProjectsQuery,
  usePatchProtrackSnagsByIdMutation,
  useGetProtrackSnagsByIdQuery,
  useLazyGetProtrackSnagsByIdQuery,
  useDeleteProtrackSnagsByIdMutation,
  usePostProtrackSnagsMutation,
  useGetProtrackSnagsQuery,
  useLazyGetProtrackSnagsQuery,
  usePatchPurchaseOrdersByIdUpdateCodesMutation,
  usePatchPurchaseOrdersByIdMutation,
  useGetPurchaseOrdersByIdQuery,
  useLazyGetPurchaseOrdersByIdQuery,
  useDeletePurchaseOrdersByIdMutation,
  useGetPurchaseOrdersQuery,
  useLazyGetPurchaseOrdersQuery,
  useGetQuotationsUploadProgressCountQuery,
  useLazyGetQuotationsUploadProgressCountQuery,
  useGetQuotationsUploadProgressByIdQuery,
  useLazyGetQuotationsUploadProgressByIdQuery,
  useDeleteQuotationsUploadProgressByIdMutation,
  usePostQuotationsUploadProgressMutation,
  useGetQuotationsUploadProgressQuery,
  useLazyGetQuotationsUploadProgressQuery,
  useGetReceiptsNextNumberQuery,
  useLazyGetReceiptsNextNumberQuery,
  usePatchReceiptsByIdMutation,
  useDeleteReceiptsByIdMutation,
  useGetReceiptsQuery,
  useLazyGetReceiptsQuery,
  useGetRequisitionByIdQuery,
  useLazyGetRequisitionByIdQuery,
  useGetRequisitionReviewByIdQuery,
  useLazyGetRequisitionReviewByIdQuery,
  useGetRequisitionReviewsQuery,
  useLazyGetRequisitionReviewsQuery,
  useGetRequisitionsNewQuery,
  useLazyGetRequisitionsNewQuery,
  useGetRequisitionsQuery,
  useLazyGetRequisitionsQuery,
  useGetSheqDashboardQuery,
  useLazyGetSheqDashboardQuery,
  usePatchSheqHealthRecordsByIdMutation,
  useGetSheqHealthRecordsByIdQuery,
  useLazyGetSheqHealthRecordsByIdQuery,
  useDeleteSheqHealthRecordsByIdMutation,
  usePostSheqHealthRecordsMutation,
  useGetSheqHealthRecordsQuery,
  useLazyGetSheqHealthRecordsQuery,
  usePatchSheqIncidentsByIdMutation,
  useGetSheqIncidentsByIdQuery,
  useLazyGetSheqIncidentsByIdQuery,
  useDeleteSheqIncidentsByIdMutation,
  usePostSheqIncidentsMutation,
  useGetSheqIncidentsQuery,
  useLazyGetSheqIncidentsQuery,
  usePatchSheqInspectionsByIdMutation,
  useGetSheqInspectionsByIdQuery,
  useLazyGetSheqInspectionsByIdQuery,
  useDeleteSheqInspectionsByIdMutation,
  usePostSheqInspectionsMutation,
  useGetSheqInspectionsQuery,
  useLazyGetSheqInspectionsQuery,
  usePatchSheqPpeCatalogueByIdMutation,
  useDeleteSheqPpeCatalogueByIdMutation,
  usePostSheqPpeCatalogueMutation,
  useGetSheqPpeCatalogueQuery,
  useLazyGetSheqPpeCatalogueQuery,
  usePostSheqPpeExpireMutation,
  usePatchSheqPpeRecordsByIdReturnMutation,
  usePatchSheqPpeRecordsByIdMutation,
  useGetSheqPpeRecordsByIdQuery,
  useLazyGetSheqPpeRecordsByIdQuery,
  useDeleteSheqPpeRecordsByIdMutation,
  usePostSheqPpeRecordsMutation,
  useGetSheqPpeRecordsQuery,
  useLazyGetSheqPpeRecordsQuery,
  useGetSheqPpeWorkerByWorkerIdHoldingsQuery,
  useLazyGetSheqPpeWorkerByWorkerIdHoldingsQuery,
  useGetSheqReportsExpiringQuery,
  useLazyGetSheqReportsExpiringQuery,
  useGetSheqReportsIncidentsSummaryQuery,
  useLazyGetSheqReportsIncidentsSummaryQuery,
  usePatchSheqSopsByIdMutation,
  useGetSheqSopsByIdQuery,
  useLazyGetSheqSopsByIdQuery,
  useDeleteSheqSopsByIdMutation,
  usePostSheqSopsMutation,
  useGetSheqSopsQuery,
  useLazyGetSheqSopsQuery,
  usePostSpearReviewByIdApproveMutation,
  usePatchSpearReviewByIdGoalStatusMutation,
  usePatchSpearReviewByIdManagerEditMutation,
  usePostSpearReviewByIdRejectMutation,
  usePostSpearReviewByIdSubmitMutation,
  useGetSpearReviewsMyDirectReportsQuery,
  useLazyGetSpearReviewsMyDirectReportsQuery,
  useGetStakeholdersByTypeByTypeQuery,
  useLazyGetStakeholdersByTypeByTypeQuery,
  useGetStakeholdersCountQuery,
  useLazyGetStakeholdersCountQuery,
  usePatchStakeholdersByIdMutation,
  useGetStakeholdersByIdQuery,
  useLazyGetStakeholdersByIdQuery,
  useDeleteStakeholdersByIdMutation,
  usePostStakeholdersMutation,
  useGetStakeholdersQuery,
  useLazyGetStakeholdersQuery,
  usePostStatementsBulkSendMutation,
  useGetStatementsLogsQuery,
  useLazyGetStatementsLogsQuery,
  usePutSupervisorsByIdMutation,
  usePatchSupervisorsByIdMutation,
  useDeleteSupervisorsByIdMutation,
  usePostSupervisorsMutation,
  useGetSupervisorsQuery,
  useLazyGetSupervisorsQuery,
  usePostUnitMutation,
  useGetUnitsByProjectByProjectIdQuery,
  useLazyGetUnitsByProjectByProjectIdQuery,
  useGetUnitsCountQuery,
  useLazyGetUnitsCountQuery,
  usePutUnitsByIdMutation,
  usePatchUnitsByIdMutation,
  useGetUnitsByIdQuery,
  useLazyGetUnitsByIdQuery,
  useDeleteUnitsByIdMutation,
  usePatchUnitsMutation,
  useGetUnitsQuery,
  useLazyGetUnitsQuery,
  usePatchUserByIdMutation,
  useGetUserByIdQuery,
  useLazyGetUserByIdQuery,
  useDeleteUserByIdMutation,
  usePostUsersAdminCreateMutation,
  usePostUsersAdminResetPasswordByIdMutation,
  useGetUsersCountQuery,
  useLazyGetUsersCountQuery,
  usePostUsersLoginMutation,
  usePostUsersLogoutMutation,
  useGetUsersMeQuery,
  useLazyGetUsersMeQuery,
  usePostUsersRefreshTokenMutation,
  usePostUsersResetPasswordMutation,
  usePostUsersMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useGetUsersWithReviewsQuery,
  useLazyGetUsersWithReviewsQuery,
  useGetVatInvoicesCountQuery,
  useLazyGetVatInvoicesCountQuery,
  usePatchVatInvoicesByIdMutation,
  useGetVatInvoicesByIdQuery,
  useLazyGetVatInvoicesByIdQuery,
  useDeleteVatInvoicesByIdMutation,
  usePostVatInvoicesMutation,
  useGetVatInvoicesQuery,
  useLazyGetVatInvoicesQuery,
  useGetVatPaymentsCountQuery,
  useLazyGetVatPaymentsCountQuery,
  usePatchVatPaymentsByIdMutation,
  useGetVatPaymentsByIdQuery,
  useLazyGetVatPaymentsByIdQuery,
  useDeleteVatPaymentsByIdMutation,
  usePostVatPaymentsMutation,
  useGetVatPaymentsQuery,
  useLazyGetVatPaymentsQuery,
  useGetVatReturnByVatPeriodQuery,
  useLazyGetVatReturnByVatPeriodQuery,
  useGetVatStatementsClientsQuery,
  useLazyGetVatStatementsClientsQuery,
  useGetVatTransactionsByPeriodByVatPeriodQuery,
  useLazyGetVatTransactionsByPeriodByVatPeriodQuery,
  useGetVatTransactionsPeriodsQuery,
  useLazyGetVatTransactionsPeriodsQuery,
  usePostVatTransactionsMutation,
  useGetVirtualWarehouseSummaryQuery,
  useLazyGetVirtualWarehouseSummaryQuery,
  useGetWhoAmIQuery,
  useLazyGetWhoAmIQuery,
} = injectedRtkApi;
